import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ChangeDetectionStrategy, Component, ElementRef, NgZone, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { ToastrService } from "ngx-toastr";

import { AppComponent } from '../../app.component';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatePipe, DecimalPipe } from '@angular/common';
import Swal from 'sweetalert2';
import { ExcelService } from '../../services/excel.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { forkJoin, Observable, startWith, Subject, Subscription, takeUntil } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { SharedService } from '../../services/sharedService/shared.service'
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { WorkerUrlPrefetchResult } from 'src/serviceworker/service/prefetch';
import { LoggerService } from 'src/app/services/logger.service';
import { decompress } from 'compress-json';
import { LoaderService } from 'src/app/loader.service';
import { SocketMemberService } from 'src/app/services/socket-member.service';
import { GlobalStoreService } from 'src/app/services/global-store.service';
import { select, Store } from '@ngrx/store';
import { selectMemberData, selectMemberError, selectMemberLoading } from 'src/app/state/selectors/member.selector';
import { loadMemberData, loadMemberDataSuccess } from 'src/app/state/actions/members.actions';
import { selectLanguageData } from 'src/app/state/selectors';
import { loadLanguageData } from 'src/app/state/actions';
import { loadCorporateData, loadCorporateDataSuccess } from 'src/app/state/actions/corporates.actions';
import { selectCorporateData, selectCorporateError, selectCorporateLoading } from 'src/app/state/selectors/corporates.selector';
import { floatWith2Decimals, groupBy, sumBy, adjustWith2DecimalsForUI } from "../../common-functions";
import { CustomDatePipe } from 'src/app/pipes/customdate.pipe';
import { data } from 'jquery';


// import{Modal} from 'bootstrap'

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
declare var $: any;
let api, pgno, pageStart, pageEnd, start, end, info;
@Component({
  selector: 'app-manage-customers-datatable',
  templateUrl: './manage-customers-datatable.component.html',
  styleUrls: ['./manage-customers-datatable.component.css'],
  providers: [DatePipe, DecimalPipe, CustomDatePipe],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManageCustomersDatatableComponent implements OnDestroy, OnInit {
  brokerList: Array<any> = [];
  members: Array<any> = [];
  terminationDateValue: any;
  dateFormat = 'YYYY-MM-DD';

  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  @ViewChild('memberdetails') memberdetails: any;

  dtOptions: DataTables.Settings = {};
  persons: Array<any> = [];
  continueWithExistingPlans: boolean = true
  samePlansWithCorporate: boolean = true
  provisioning: boolean = false
  dtTrigger: Subject<any> = new Subject<any>();
  dtTrigger1: Subject<any> = new Subject<any>();
  customerslist: Array<any> = [];
  role: any;
  showmemberData = false;
  corporateData$: Observable<any>;
  customerId: any;
  message: any
  plansDataarray: Array<any> = [];
  popupDisplay: boolean = true;
  valuFormChaild: any = 0;
  emplomentName: any;
  clientList: Array<any> = [];
  loader: boolean
  // members: any;
  terminationform: FormGroup = new FormGroup({
    reason: new FormControl(''),
    memberstatus: new FormControl(''),
    terminationDate: new FormControl(''),
  });
  corporateList: FormGroup = new FormGroup({
    corporateName: new FormControl(''),
  });

  terminationformDetails: FormGroup = new FormGroup({
    reason: new FormControl(''),
    memberstatus: new FormControl(''),
    terminationDate: new FormControl(''),
    proceedWithEquitable: new FormControl(''),
    proceedWithGreenshield: new FormControl(''),
    proceedWithPHR: new FormControl(''),
    proceedWithRefund: new FormControl(''),
    refundAmount: new FormControl(),
    proceedWithSmartchoice: new FormControl(''),
    proceedWithSubscriptionExpiry: new FormControl(''),
    proceedWithCancelCustomer: new FormControl(''),
  });

  effectiveDateForm: FormGroup = new FormGroup({
    effectiveDate: new FormControl(''),

  });

  memberid: any;
  terminateReasonsWithKeys: any;
  Allmembers: any[];
  filterStatus: any[];
  minDate: Date;
  maxDate: Date;
  terminateMemberDetails: any;
  servicDetails: any;
  terminateReasonsApplicable: any;
  staxbillDetails: any;
  proceedWithSubscriptionExpiry: any;
  proceedWithEquitable: any;
  proceedWithGreenshield: any;
  proceedWithRefund: any;
  refundAmount: any;
  proceedWithSmartchoice: any;
  proceedWithCancelCustomer: any;
  terminationsProvisioning: any[];
  emplomentFirstName: any;
  emplomentLastName: any;
  invoicedetails: any
  showfilter: boolean = false;
  isSubscribed: any;
  public lang: any = {};
  selectedLanguage: string;
  languageData: any;
  isDataChanged: boolean = false;
  intervalId: any;
  currentPage = 1;
  itemsPerPage = 10;
  filterValue: string = '';
  private socketSubscription: Subscription;
  displaying_results: any = [];
  displaying_results2: any = [];
  restLoader: boolean = true;
  loading$: Observable<boolean>;
  error$: Observable<string | null>;
  membersData$: Observable<any>;
  languageData$: Observable<any>;
  private destroy$ = new Subject<void>();
  sortColumn: string = '';
  sortOrder: 'ASC' | 'DESC' = 'ASC';
  MemberDetails: any;
  memberInfo: any;
  gigterminationRes: any;



  plansskumain: any[] = [];
  plandetailsobjvalue: any;
  optionstitle: any[] = [];
  optionmessage: any;

  adminName: any;

  isExecutiveCP: boolean;
  filteredEmployeeList: any = []
  serviceCount: any = 0;
  basicTiersCount: any = 1;
  AnnualCount: any = 0;
  adminData: any;
  lengthofstatus: any;
  defaultColor: any;
  applicationStatus: any;
  paidByCompany: Array<any> = [];
  allBrokers: Array<any> = [];
  coveredByCompany: Array<any> = [];
  paidByEmployee: Array<any> = [];
  bulkplans: Array<any> = [];
  payrolldeduction: Array<any> = [];
  uploadEmployeeExcelData: Array<any> = [];
  countryList: any;
  subdomainName: any;

  payrolldedcutionname: any;
  payrollOptions: any;
  planselectedId: any;
  planRequestBody: any;
  selectedWalletConfig: any;
  plancheckCoverage: any = false;
  plancheck2Coverage: any = false;
  plancheck3Coverage: any = false;
  block1coverage: any = true;
  block2coverage: any = true;
  block3coverage: any = true;



  public coveredEmployeeShare: any = 0;
  public paidEmployeeShare: any = 0;
  public totalEmployeeShare: any = 0;
  public cartDisplayAmount: any = 0;
  public allPlansAmountTotal: any = 0;
  public allPlansTotal: any = 0;
  public allPlansTotaltax: any = 0;
  public allCPPlansAmountTotal: any = 0;
  public allCCPlansAmountTotal: any = 0;
  public allEPPlansAmountTotal: any = 0;
  public allCPTaxTotal: any = 0;
  public allCCTaxTotal: any = 0;
  public allEPTaxTotal: any = 0;
  public companyPaidTotal: any = 0;
  public companyCoveredTotal: any = 0;
  public paidEmployeedTotal: any = 0;
  public companyCoveredCompanyShareTotal: any = 0;
  public companyCoveredCompanySharePlanAmountTotal: any = 0;
  public companyCoveredCompanyShareTaxTotal: any = 0;
  public companyCoveredEmployeeShareTotal: any = 0;
  public companyCoveredEmployeeSharePlanAmountTotal: any = 0;
  public companyCoveredEmployeeShareTaxTotal: any = 0;
  public effectiveCompanyTotalContibution: any = 0;
  public effectiveEmployeeTotalContibution: any = 0;
  public effectiveCompanyPlansAmountTotal: any = 0;
  public effectiveCompanyTaxTotal: any = 0;

  employeeplancheck: any;
  empCount: any;
  elementid: any;
  block2execid: any;
  defaultAmount: any;
  checkmark = false;
  executiveid: any;
  selectionTiers: any;
  plansNewBlock1: any;
  tierConfigCheck: any;
  walletConfigCheck: any;
  customSelected = false;
  upgradeplanscheck: any;
  showtierbasicplans = false;
  showtieradvplans = false;
  hidementalplans: any = 222;
  hidewaddellplans: any = 222;
  showinputbox: any;
  showinputbox1: any;
  productobj: any;
  basicInfo = true;
  showsearchbox: boolean = true;
  isActive1: boolean = true;
  plansInfo = false;
  showaddadmin = false;
  addadminform = true;
  wallettierInfo = false;
  wallettierInfoandtier = false;
  EmployeeInfo = false;
  datagraphInfo = false;
  showdeletebutton = false;
  showemptywalletConfig = false;

  uploadlogoafter = false;
  nowalletnotierInfo = false;
  upgradeplansselection = false;
  upgradeplansselectiontiers = false;
  employeeplanpurchase = false;
  employeeplanpurchasetiers = false;
  voidcheckuploadafter = false;
  showconfigurebutton = true;

  showvoidcheck = true;
  showimagelogo = true;
  willDownload = false;
  bankDetails = false;
  showstatus = false;
  walletData: any;
  tierWalletConfig: any;
  TierData: any;
  public postalvalue: any;
  public invalidpostalcodeprivince: boolean = false;
  public invalidpostalcodeprivincewaddell: boolean = false;
  public CORP_PAYROLL_NOT_MANDATORY_PACKAGES: any = [2, 8, 9];
  public CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS: any = [19, 20, 21, 23, 25, 26];
  statesInfo: any;
  plansres: any;
  planres2: any;
  plansBlock1: any;
  plansBlock1Tiers: any;
  packageIndex: any;
  imagedisplay: any;
  imagedisplayvoid: any;
  editindex: any;
  groupIndex: any;
  walletConfig: any;
  employeeplanpurchasetierscheck: any;
  upgradertierscheck: any;
  packageIndexblock2: any;
  groupIndexblock2: any;
  corporationclient: any;
  disabledColor: any;
  counter: any;
  selectedplansblock1: any;
  selectedplansblock2: any;
  selectedplansblock3: any;
  configureTierList: any;
  disallowedplans: any;
  disallowedplansTiers: any;
  voidcheckfile: any;
  uploadadminlogoimg: any;
  session: any;
  configprovinceres: any;
  configprovincereslist: any;
  enrollmentDates: any;
  provincialHealthcareUrl: any;
  provincialZipcodes: any;
  provincelistid: any;
  state_id: any;
  statename: any;
  corporateId: any;
  corporateClientId: any;
  maxEmployeeCount: any;
  lengthofemployee: any;
  editadminfirstname: any;
  editadminlastname: any;
  editadminphone: any;
  editadminemail: any;
  editadminrole: any = '';
  editEmployeeId: any;
  selectedPlansTierBlock1: any;
  selectedplansforTier: Array<any> = [];
  dummyAdminData: Array<any> = [];
  tierinfonames: Array<any> = [];
  addedEmployeelist: Array<any> = [];
  tierslist: Array<any> = [];
  finalTiersforGraph: Array<any> = [];
  TierlistforGrapsh: Array<any> = [];
  planssummarymain: Array<any> = [];
  planssummaryopt: Array<any> = [];
  planssummary: Array<any> = [];
  plansresblack2: Array<any> = [];
  plansresblack2Tiers: Array<any> = [];
  plansresblack2final: Array<any> = [];
  plansresblack3: Array<any> = [];
  Newplansresblack3: Array<any> = [];
  planssummary2: Array<any> = [];
  plansNewBlock2: Array<any> = [];
  selectedCoverage: Array<any> = [];
  Newplansresblack3Tiers: Array<any> = [];
  plansNewBlock2Tiers: Array<any> = [];
  plansNewBlock3Tiers: Array<any> = [];
  plansresblack3Tiers: Array<any> = [];
  finalblock2res: Array<any> = [];
  excelempdata: Array<any> = [];
  tierconfig: Array<any> = [];
  EmployeeAddData: Array<any> = [];
  finalemployeekeys: Array<any> = [];
  tierarray: Array<any> = [];
  corpDetails: Array<any> = [];
  SubDomains: Array<any> = [];
  public planssummarymainLife: any = [];
  CorpName: any;
  streetAddress: any;
  streetAddress2: any;
  country: any = '';
  city: any;
  province: any = '';
  postalCode: any;
  policyStartDate: any;
  setupWallet: any = false;
  setUplevelofCoverage: any = false;
  noOfEmployees: any;
  paymentInfo: any;
  waitTime: any;
  useCreditCard: any;
  invoicePayment: any;
  padPayment: any;

  filterarray: Array<any> = [];
  packagePlanLevelTiers: any = {};
  displayPackage: Array<boolean> = [];
  selectedPlansInfoTierArray: Array<any> = [];
  selectedPlansInfoTierArrayBlock2: Array<any> = [];
  selectedPlansInfoTierArrayBlock3: Array<any> = [];
  selectedTiers: Array<any> = [];
  TiersArray: Array<any> = [];
  selectedPackagePlansInfoTier: any = {};
  selectedPackagePlansInfoTierBlock2: any = {};
  selectedPackagePlansInfoTierBlock3: any = {};
  selectedPackagePlansInfoTiername: any = {};
  selectedPackagePlansInfoTiernameBlock2: any = {};
  selectedPackagePlansInfoTiernameBlock3: any = {};
  selectedPackagePlansInfoTier2: any = {};
  selectedPackagesassignedTiers: any = {};
  selectedPackagesassignedTiers2: any = {};
  selectedPackagesassignedTiers21: any = {};
  selectedPackagesavailableTiers: any = {};
  selectedPackagesavailableTiers2: any = {};
  selectedPackagesavailableTiers21: any = {};
  selectedPackagesavailableTiers3: any = {};
  selectedPackagesassignedTiers3: any = {};

  selectedPackagePlansInfoTier2Block2: any = {};
  selectedPackagePlansInfoTier3Block3: any = {};
  selectedPackagesassignedTiersBlock2: any = {};
  selectedPackagesassignedTiersBlock3: any = {};
  selectedPackagesassignedTiers2Block2: any = {};
  selectedPackagesassignedTiers2Block21: any = {};
  selectedPackagesassignedTiers3Block3: any = {};
  selectedPackagesassignedTiers3Block31: any = {};
  selectedPackagesavailableTiersBlock2: any = {};
  selectedPackagesavailableTiersBlock3: any = {};
  selectedPackagesavailableTiers2Block2: any = {};
  selectedPackagesavailableTiers2Block21: any = {};
  selectedPackagesavailableTiers3Block3: any = {};
  selectedPackagesavailableTiers3Block31: any = {};
  seelctedplanLevelTierMapping: Array<any> = [];
  seelctedplanLevelTierMapping2: Array<any> = [];
  disabledelement: any

  showinput = true;
  showinput1 = false;

  showinputBlock2 = true;
  showinput1Block2 = false;

  showinputBlock3 = true;
  showinput1Block3 = false;
  seelctedplanLevelTierMappingBlock2: Array<any> = [];
  seelctedplanLevelTierMapping2Block2: Array<any> = [];

  seelctedplanLevelTierMappingBlock3: Array<any> = [];
  seelctedplanLevelTierMapping3Block3: Array<any> = [];
  walletsymbol: any;
  chart: any;
  chart1: any;
  isActive!: boolean;
  showemptytierconfig: any;
  annualincomeCheck = false;
  lengthofServiceCheck = false;
  tiersLevelCheck = false;
  public fieldArray: Array<any> = [];
  public newAttribute: any = {};
  public defaulttiers: Array<any> = [];
  public dynamicArray: Array<any> = [];
  public dynamicArrayService: Array<any> = [];
  public dynamicArrayAnnualIncome: Array<any> = [];
  dropdownList: Array<any> = [];
  selectedItems: Array<any> = [];
  dropdownSettings = {};
  public employeeList: Array<any> = [];
  public newDynamic: any = {};
  public adminError: boolean = false;
  adminStatuslist: Array<any> = [];
  dropDownSelect = false;
  employeedata: any = [];
  employeedata2: any = [];

  finalCompanyPaidCoverages: any = [];
  plansCoveragecheckboxCheck: { [key: string]: boolean } = {};
  getPlanCoverage: { [key: string]: any } = {};
  public mainarray: any = [];
  mainarrayValues: any = [];
  mainarrayFinal: any = []
  public modifiedBlocksCoveredByCompany: any;
  public modifiedBlocksPaidByCompany: any
  public formData: any;
  public allFormData: any = {};
  public companypaidproductid = [];
  public disabledcompanypaidproductid = [];
  public removedisabledcompanypaidproductid = [];
  public adddisabledcompanypaidproductid = [];
  specialpackages: any;
  public packagesInBlocks: any;
  basepackages: any;
  firstName: any;
  showOtherField: boolean = false;
  groupContactsData: any;
  existingPlans: any;
  coreplantemplateValue: any = null;
  emailAlreadyexist: boolean = false;
  domainExisting: boolean = false;
  postalCodeDisplay: any = 'Postal Code';
  provianceDispaly: any = 'Province';
  allCountrys: any;
  selectedCountry: string;
  multiSelectProviance: any = [];
  multiSelectProviancenames: any = [];
  adminformOthers: any;
  aptSuite: any;
  isCountrySelected: boolean = false;
  multiSlectProviances: any;
  version: string;
  employeeWorkingProviance: any;
  balkPlans: any;
  imagedisplayPad: any = "";
  showdisplayPad: boolean = false;
  corePlans: any;
  showbankInfo: boolean = false;
  showEmployeeValue: any;
  showEmployeeValue1: any
  headCountmiss: boolean = false;
  headCountmiss1: boolean = false;
  showEmployeelist: any = [];
  deletedId: Array<any> = [];

  addemployeefrom: boolean;
  editemployeefrom: boolean;
  editEmployeeindex: any;
  editEmployeefirstname: any;
  editEmployeelastname: any;
  editEmployeephone: any;
  editEmployeeemail: any;
  presentMail: any;
  editEmployeeDateofbirth: string;
  editEmployeeOccupation: any;
  editEmployeefamilyStatus: string;
  editemployeeCountry: any;
  editEmployeeResidenetIn: any;
  editEmployeeeAnnualIncome: any;
  UId: any;
  isBulk: boolean;
  editEmployeeDateofhire: string;
  editEmployeesex: any;
  showinputboxvalue: { [key: string]: boolean } = {}
  showinputboxvalue1: any;
  failedEmployeesList: any;
  // message: any;

  brokerProfileslist: Array<any> = [];
  public bulkemployeeList: Array<any> = [];
  waddellExcelKeys: any = [];
  editEmployeeStreeAddress: any;
  editEmployeeCity: any;
  editEmployeeProvicne: any;
  editEmployeeposatlCode: any;
  ExcelProvinceCode: any = '';
  isWaddell: boolean;
  checkboxCheck: { [key: string]: boolean } = {};
  selectedSubGrpId: any = '';
  showHeadCount: { [key: string]: any } = {};
  isCollapsed: { [key: string]: boolean } = {};
  isCollapsedTwo: { [key: string]: boolean } = {};
  isCollapsedThree: { [key: string]: boolean } = {};

  corporateDetails: any = {}
  corporateDetailsMain: any

  corporateSignupConfigData$: Observable<any>;
  corporateSignupConfigData: any = {};
  customerData: any;
  customerAsAnEmployee: string;
  paymentMethodCheck: string;
  updatedBrokerId: any;
  brokerProfileslistSearch: any[];
  profileid: any;
  brokerProfileslist1: any;
  gig_customer_id: string;
  waitingPeriodValue: any = 0
  waitingPeriodforintialSignup: any = false
  customerPlans: any;
  CorporateFormData: any;
  payrollCCPlantaxTotal: any;
  empDirectpayPlanamountTotal: any;
  empDirectpayPlantaxTotal: any;
  payrollCCPlansAmountTotal: any;
  payrollCCPlangrandTotal: any;
  empDirectpayPlangrandTotal: any;
  DirectCCpayPlanamountTotal: any;
  DirectCCpayPlantaxTotal: any;
  DirectCCpayPlangrandTotal: any;
  companydealingplansTotal: any;
  companydealingplanstaxTotal: any;
  companydealingplansgrandTotal: any;
  deltaCompanyTax: any;
  public directpayCCplansarr: any = [];
  public payrollCCplansarr: any = [];
  public employeeDealingPlansarr: any = [];
  public companySelectedPlans = [];
  public companyCoveredPlans = [];
  public EmployeeSelectedPlans = [];
  public allSelectedPlans = [];
  public companyDealingPlans = [];

  public alloptinplans = [];
  iafgplansCheck: any = [];
  planobjdata: any = {};
  planobjdataobj: any = {};
  planoptionsValues: any = [];
  planOptionsModel = false;
  selectedItem: any;
  inviteEmailId: any=0;
  reinstateData: any;
  requestQueueData:any;
  reinstatePlans: any;
  finalEffectiveDate:any
  planEnrollmentDates: any;
  currentMember: any;
  reasonForReinstate:any = '';

  constructor(private logger: LoggerService, private formBuilder: FormBuilder,
    private _CustomDatePipe: CustomDatePipe,
    private renderer: Renderer2,
    private _decimalPipe: DecimalPipe,
    private toastrService: ToastrService,
    public elementRef: ElementRef,
    private formBuilderDetails: FormBuilder,
    private SharedService: SharedService,
    private loaderService: LoaderService,
    private socketMemberService: SocketMemberService,
    private globalStoreService: GlobalStoreService,
    private http: HttpClient, public router: Router, private datePipe: DatePipe, private excelService: ExcelService,
    private store: Store<{ memberData: [], languageData: [], corporateData: [], }>

  ) {
    this.corporateData$ = store.select(selectCorporateData);
    this.membersData$ = store.select(selectMemberData);
    this.loading$ = store.select(selectMemberLoading);
    this.error$ = store.select(selectMemberError);
    this.languageData$ = store.select(selectLanguageData);
  }

  ngOnInit() {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'Members List');
    },100)
    this.configprovinceres = [
      {
        "countryId": 1,
        "id": 1,
        "name": "Alberta",
        "provincialHealthcareUrl": "https://www.alberta.ca/ahcip-how-to-apply.aspx",
        "published": true,
        "shortName": "AB",
        "cowanId": "5",
        "zipcodes": "T",
        "fusebillId": "1",
        "equitableId": 1,
        "equitableQuestions": null,
        "smartchoiceId": 1,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 2,
        "name": "Quebec",
        "provincialHealthcareUrl": "https://www.ramq.gouv.qc.ca/en/citizens/health-insurance/register",
        "published": true,
        "shortName": "QC",
        "cowanId": "2",
        "zipcodes": "G,H,J",
        "fusebillId": "11",
        "equitableId": 10,
        "equitableQuestions": null,
        "smartchoiceId": 11,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 12,
        "name": "Ontario",
        "provincialHealthcareUrl": "https://www.ontario.ca/page/apply-ohip-and-get-health-card",
        "published": true,
        "shortName": "ON",
        "cowanId": "1",
        "zipcodes": "K,L,M,N,P",
        "fusebillId": "9",
        "equitableId": 8,
        "equitableQuestions": null,
        "smartchoiceId": 9,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 13,
        "name": "New Brunswick",
        "provincialHealthcareUrl": "https://www2.gnb.ca/content/gnb/en/departments/health/MedicarePrescriptionDrugPlan/content/medicare/ApplyingforaCard.html",
        "published": true,
        "shortName": "NB",
        "cowanId": "8",
        "zipcodes": "E",
        "fusebillId": "4",
        "equitableId": 4,
        "equitableQuestions": null,
        "smartchoiceId": 4,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 14,
        "name": "British Columbia",
        "provincialHealthcareUrl": "https://www2.gov.bc.ca/gov/content/health/health-drug-coverage/msp/bc-residents/eligibility-and-enrolment/how-to-enrol",
        "published": true,
        "shortName": "BC",
        "cowanId": "6",
        "zipcodes": "V",
        "fusebillId": "2",
        "equitableId": 2,
        "equitableQuestions": true,
        "smartchoiceId": 2,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 15,
        "name": "Saskatchewan",
        "provincialHealthcareUrl": "https://www.ehealthsask.ca/residents/health-cards/Pages/Apply-for-a-Health-Card.aspx",
        "published": true,
        "shortName": "SK",
        "cowanId": "4",
        "zipcodes": "S",
        "fusebillId": "12",
        "equitableId": 11,
        "equitableQuestions": true,
        "smartchoiceId": 12,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 16,
        "name": "Nova Scotia",
        "provincialHealthcareUrl": "https://novascotia.ca/dhw/MSI/health_cards.asp",
        "published": true,
        "shortName": "NS",
        "cowanId": "9",
        "zipcodes": "B",
        "fusebillId": "7",
        "equitableId": 7,
        "equitableQuestions": null,
        "smartchoiceId": 6,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 17,
        "name": "Prince Edward Island",
        "provincialHealthcareUrl": "https://www.princeedwardisland.ca/en/service/apply-for-pei-health-card-new-residents",
        "published": true,
        "shortName": "PEI",
        "cowanId": "10",
        "zipcodes": "C",
        "fusebillId": "10",
        "equitableId": 9,
        "equitableQuestions": null,
        "smartchoiceId": 10,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 18,
        "name": "Newfoundland and Labrador",
        "provincialHealthcareUrl": "https://www.gov.nl.ca/hcs/files/mcp-forms-ben-reg.pdf",
        "published": true,
        "shortName": "NL",
        "cowanId": "7",
        "zipcodes": "A",
        "fusebillId": "5",
        "equitableId": 5,
        "equitableQuestions": null,
        "smartchoiceId": 5,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 19,
        "name": "Nunavut",
        "provincialHealthcareUrl": "https://www.gov.nu.ca/health/information/health-care-card",
        "published": true,
        "shortName": "NU",
        "cowanId": "16",
        "zipcodes": "X",
        "fusebillId": "8",
        "equitableId": 13,
        "equitableQuestions": null,
        "smartchoiceId": 8,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 20,
        "name": "Yukon",
        "provincialHealthcareUrl": "https://yukon.ca/en/health-care-card",
        "published": true,
        "shortName": "YT",
        "cowanId": "12",
        "zipcodes": "Y",
        "fusebillId": "13",
        "equitableId": 12,
        "equitableQuestions": null,
        "smartchoiceId": 13,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 21,
        "name": "Manitoba",
        "provincialHealthcareUrl": "https://www.gov.mb.ca/health/mhsip/forms.html",
        "published": true,
        "shortName": "MB",
        "cowanId": "3",
        "zipcodes": "R",
        "fusebillId": "3",
        "equitableId": 3,
        "equitableQuestions": true,
        "smartchoiceId": 3,
        "country_id": 1
      },
      {
        "countryId": 1,
        "id": 22,
        "name": "Northwest Territories",
        "provincialHealthcareUrl": "https://www.hss.gov.nt.ca/en/services/applying-health-care",
        "published": true,
        "shortName": "NT",
        "cowanId": "13",
        "zipcodes": "X",
        "fusebillId": "6",
        "equitableId": 6,
        "equitableQuestions": null,
        "smartchoiceId": 7,
        "country_id": 1
      },
      {
        "countryId": 2,
        "id": 23,
        "name": "Alabama",
        "provincialHealthcareUrl": null,
        "published": true,
        "shortName": "AL",
        "cowanId": null,
        "zipcodes": "35004-36925",
        "fusebillId": null,
        "equitableId": null,
        "equitableQuestions": null,
        "smartchoiceId": null,
        "country_id": 2
      },
      {
        "countryId": 2,
        "id": 24,
        "name": "Alaska",
        "provincialHealthcareUrl": null,
        "published": true,
        "shortName": "AK",
        "cowanId": null,
        "zipcodes": "99501-99950",
        "fusebillId": null,
        "equitableId": null,
        "equitableQuestions": null,
        "smartchoiceId": null,
        "country_id": 2
      },
      {
        "countryId": 2,
        "id": 25,
        "name": "Arizona",
        "provincialHealthcareUrl": null,
        "published": true,
        "shortName": "AZ",
        "cowanId": null,
        "zipcodes": "85001-86556",
        "fusebillId": null,
        "equitableId": null,
        "equitableQuestions": null,
        "smartchoiceId": null,
        "country_id": 2
      }
    ]

    this.planEnrollmentDates = [
          moment().subtract(1, 'months').startOf('month').format('MMM-DD-YYYY'), // Previous month
          moment().startOf('month').format('MMM-DD-YYYY'),
          moment().add(1, 'months').startOf('month').format('MMM-DD-YYYY'),
          moment().add(2, 'months').startOf('month').format('MMM-DD-YYYY')
        ]

    this.configprovinceres = [...this.configprovinceres].sort(
      (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    );

    this.getLanguageTokens()
    this.getclientList();

    this.loader = true
    this.isSubscribed = false
    this.role = sessionStorage.getItem('role');

    this.effectiveDateForm = this.formBuilder.group({
      effectiveDate: ['', [Validators.required]],
    });
    this.terminationform = this.formBuilder.group({
      reason: [''],
      memberstatus: [''],
      terminationDate: ['', [Validators.required],],
    });


    this.corporateList = this.formBuilder.group({

      corporateName: ['', [Validators.required],],
    });
    this.dtOptions = {
      pagingType: 'simple_numbers',
      order: [],
      language: {
        searchPlaceholder: 'Search here...'
      },
      destroy: true,
      // ordering: true,
      // columnDefs: [
      //   {
      //     targets: '_all', // Index of the 'id' column
      //     orderable: false, // Disable sorting for this column
      //   },
      // ],
      columnDefs: [
        {
          targets: [6],  // Index of the "Amount" column
          type: 'date'
        }
      ],
    };

    // const memberDetails = this.globalStoreService.getMemberDetails()
    // if(memberDetails?.length!=0){
    //   setTimeout(()=>{
    //     this.members = memberDetails
    //     this.Allmembers= this.members
    //     this.restLoader=false
    //     console.log(this.members?.length,memberDetails?.length)
    //     this.dtTrigger.next(null);
    //   },0)
    // }else{
    //   this.globalStoreService.setMemberDetails();
    //   const memberDetails = this.globalStoreService.getMemberDetails()
    //   setTimeout(()=>{
    //     this.members = memberDetails
    //     this.Allmembers= this.members
    //     this.restLoader=false
    //     console.log(this.members?.length,memberDetails?.length)
    //     this.dtTrigger.next(null);
    //   },0)
    // }

    // let table = $('#DataTables_Table_0').DataTable();
    // info = table.page.info();
    // this.loadTable()
    // this.dtTrigger.next(null);


    // this.getServiceWorkerDetails();

    // init member socket
    let role = sessionStorage.getItem('role')
    if (role == 'ADMINISTRATOR') {
      this.initMemberSocket()
    }
  }

  // ngOnInit() {
  //   this.store.dispatch(loadMemberData());

  //   // this.dtOptions = {
  //   //   pagingType: 'simple_numbers',
  //   //   order: [],
  //   //   language: {
  //   //     searchPlaceholder: 'Search here...'
  //   //   },
  //   //   destroy: true,
  //   // };
  //   this.dtTrigger.next(null);
  //   this.membersData$ = this.store.select(state => state.memberData).pipe(
  //     // startWith([]),
  //     // takeUntil(this.destroy$)
  //   );

  //   this.membersData$.subscribe(data => {
  //     if(data){
  //       console.log(data)
  //       if (data?.memberData == undefined || Object.keys(data.memberData).length <= 0) {
  //         console.log('No data to process', new Date().toISOString());
  //         return;
  //       }
  //       if(this.members.length>0){
  //         return;
  //       }
  //       this.dtTrigger.next(null);
  //       this.dtTrigger.subscribe();
  //       const role = sessionStorage.getItem('role');
  //       if (role == 'ADMINISTRATOR') {
  //         this.members = decompress(data.memberData);
  //         this.members = this.members.map(res=>{
  //           return {
  //             ...res,
  //             isCorporateAccount: res.isCorporateAccount == null || res.isCorporateAccount == undefined ? false : res.isCorporateAccount,
  //           }
  //         })
  //       } else {
  //         this.members = data.memberData.map(res => {
  //           return {
  //             ...res,
  //             username: res.user?.username,
  //             primaryPhone: res?.contactInformations?.[0]?.primaryPhone || '',
  //             isCorporateAccount: res.isCorporateAccount == null || res.isCorporateAccount == undefined ? false : res.isCorporateAccount,
  //           };
  //         });
  //       }

  //       // setTimeout(() => {
  //         this.members.sort((a, b) => {
  //           const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };

  //           if (order[a.status] !== order[b.status]) {
  //             return order[a.status] - order[b.status];
  //           }
  //           const result = a.firstName.localeCompare(b.firstName);
  //           return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
  //         });
  //         this.sortColumn = 'firstName';
  //         this.sortOrder = 'ASC';
  //         this.Allmembers = this.members;
  //         this.loader = false;
  //         setTimeout(() => {
  //           this.restLoader = false;
  //           // this.dtTrigger.next(null);
  //         }, 0);
  //       // },0);
  //     }
  //   });

  //   setTimeout(()=>{
  //     this.loading$.subscribe(loading => {});
  //     this.error$.subscribe(error => {});
  //     this.getLanguageTokens();
  //     this.terminationform = this.formBuilder.group({
  //       reason: [''],
  //       memberstatus: [''],
  //       terminationDate: ['', [Validators.required]],
  //     });
  //     let role = sessionStorage.getItem('role');
  //     if (role == 'ADMINISTRATOR') {
  //       this.initMemberSocket();
  //     }
  //   },100)
  // }

  initMemberSocket() {
    console.log('MemberGateway', 'Initialized');
    this.socketSubscription = this.socketMemberService
      .listen('memberUpdated')
      .subscribe((data) => {
        if (data && data.message) {
          this.toastrService.warning(data.message, '', { timeOut: 3000 });
        }
      });
  }

  public getLanguageTokens() {
    // let body = {
    //   "project": "Admin Portal",
    //   "url": "manageMembers"
    // }
    // this.http
    //   .post('https://languageengineapi.aitestpro.com/string/project-url-strings', body, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       console.log(response)
    //       this.lang = {};
    //       this.languageData = response.strings
    //       this.selectedLanguage = sessionStorage.getItem("language")
    //       for (let token of response.strings) {
    //         this.lang[token.key] = token[this.selectedLanguage];
    //       }
    //       console.log(this.lang)
    //     })

    // this.store.dispatch(loadLanguageData());

    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if (data) {
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(() => {
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        }, 0)
      }
    })

  }
  public note: string = ""
  public enroll: any

  loadTable() {
    let self = this;
    this.dtOptions = {
      pagingType: 'simple_numbers',
      pageLength: 10,
      destroy: true,
      order: [],
      language: {
        searchPlaceholder: 'Search here...'
      },
      columnDefs: [
        {
          targets: '_all', // Index of the 'id' column
          orderable: false, // Disable sorting for this column
        },
      ],
      drawCallback: function () {
        self.displaying_results = this.api().rows({ page: 'current' })[0];
        let api = this.api();
        this.pageInfo = api.page.info();
        pgno = this.pageInfo.page + 1;
        pageEnd = this.pageInfo.end;
        console.log('hi ', pgno, this.pageInfo);
        start = this.pageInfo.start + 1;
        end = this.pageInfo.end;
      },
    };



    // alert(info.start + '::::' + info.end);
    var accessToken = sessionStorage.getItem('accessToken');
    // var getClients = '/api/ap/admin/customers/list';
    const role = sessionStorage.getItem('role')
    let getClients = ''
    if (role == 'ADMINISTRATOR') {
      // getClients = 'http://[::1]:3002/api/ap/global/adminMembers';
      getClients = '/api/ap/global/adminMembers';
    } else {
      getClients = '/api/ap/admin/customers/list';
    }

    this.http
      .get(
        environment.apiUrl + getClients, {
        // .get(getClients, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      }
      )
      .subscribe(
        (response: any) => {

          if (response['status'] == 200 || response['statusCode'] == 200) {
            // this.members = (response as any).data;
            if (role == 'ADMINISTRATOR') {
              this.members = decompress(response.data)
            } else {
              this.members = response.data.map(res => {
                return {
                  ...res,
                  username: res.user?.username,
                  primaryPhone: res?.contactInformations?.[0]?.primaryPhone || '',
                }
              })
            }
            this.filterStatus = [];
            this.members.map((member) => {
              if (!this.filterStatus.includes(member.status))
                this.filterStatus.push(member.status);
            });
            this.logger.log("status", this.filterStatus);
            this.members.sort((a, b) => {
              const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };

              if (order[a.status] !== order[b.status]) {
                return order[a.status] - order[b.status];
              }
              // return a.firstName.localeCompare(b.firstName);
              const result = a.firstName.localeCompare(b.firstName);
              return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
            });
            this.Allmembers = this.members;
            let filter//sorting get all active members sub sort by last name. append draft sub sort by last name

            // this.dtTrigger.next(null);
            this.logger.log(JSON.stringify(response));
            // this.members=response.data;
            this.loader = false
            setTimeout(() => {
              this.showfilter = true
            }, 1000);
            // this.http.get(environment.apiUrl+'/api/ap/global/set-adminMembers').subscribe((newResponse) => {})
          } else {
            this.loader = false
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message })
          }
        },
        (error) => {
          this.loader = false
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  setMinDateBasedOnRoleAndStatus(client: any) {
    const today = new Date();
    if (this.role === 'BROKER') {
      this.minDate = today;
      this.note = this.lang.Required_backdated_selection_contact_Administrator
      return
    } else if (this.role === 'ADMINISTRATOR') {
      const threeMonthsFromNow = new Date(today.setMonth(today.getMonth() - 3));
      this.minDate = new Date(threeMonthsFromNow.getFullYear(), threeMonthsFromNow.getMonth(), 1);

      if (client.status === "Active" && client.customerSignup?.enrollmentDate) {
        this.enroll = new Date(client.customerSignup?.enrollmentDate)
        this.logger.log(this.minDate <= this.enroll)

        if (this.minDate <= this.enroll && this.enroll < new Date()) {
          this.minDate = this.enroll
          this.note = this.lang.enrollment_date_is_the_earliest_selection
          this.logger.log("mindate", this.minDate)
          return
        }

        if (this.minDate < this.enroll && this.enroll >= new Date()) {
          this.minDate = new Date()
          this.note = this.lang.Today_is_the_earliest_selection
          this.logger.log("mindate", this.minDate)
          return
        }
        this.note = this.lang.Can_select_from_3_months_from_the_past
      }
      if (client.status === "Draft") {
        this.minDate = null
        this.note = ""
        return
        // this.logger.log("mindate draft", this.minDate)
      }
      this.logger.log("mindate", this.minDate)
    }

  }

  terminationformDetailsValidations() {
    this.terminationformDetails = this.formBuilderDetails.group({
      reason: ['', [Validators.required],],
      memberstatus: ['', [Validators.required],],
      terminationDate: ['', [Validators.required],],
      proceedWithEquitable: [''],
      proceedWithGreenshield: [''],
      proceedWithPHR: [''],

      proceedWithRefund: [''],
      refundAmount: [''],
      proceedWithSmartchoice: [''],
      proceedWithSubscriptionExpiry: [''],
      proceedWithCancelCustomer: [''],


    });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger1.next(null);
    });
  }
  viewsubBrokerList(brokerlist) {

    $('#subGroupList-modal').modal('show');
    this.logger.log(brokerlist)
    this.customerslist = brokerlist
    this.dtTrigger1.next(null);
    // $("#DataTables_Table_1").dataTable().OnDestroy()
    $("#DataTables_Table_1").dataTable().fnDestroy();

  }

  public viewBrokerDetails(broker: any, index: number) {

    this.router.navigate(['/manageAdvisors/editAdvisor/' + broker.id]);

    // /broker/{brokerId}/details

  }

  public getCorporateDetails(item: any) {
    console.log(item)

    const selectedValue = this.corporateList.get('corporateName').value;
    console.log(selectedValue)
    this.selectedItem = this.clientList.find(item => item.name === selectedValue);
    console.log('Selected Item:', this.selectedItem);
    this.GetCorpDetails1(this.selectedItem.id)

  }

  GetCorpDetails1(CorpId: any) {

    var endPoint = '/api/ap/admin/corporate/' + this.selectedItem.id + '/details';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            console.log(response);

            this.corporateDetailsMain = response.data
          }


        })

  }
  public gigtoCorp(member: any) {
    this.memberInfo = member
    this.getclientList1()
    console.log(member)
    Swal.fire({
      title: 'Info',
      text: 'Under which corporate entity should this member be added?',
      showDenyButton: true,
      showCloseButton: true,
      confirmButtonText: 'New',
      denyButtonText: 'Existing'
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.router.navigate(['/gig-to-corp/' + member.id]);
      }
      else if (result.isDenied) {
        this.corporateList.reset()
        $("#showCorporatelist").modal('show');
        this.getCustomerDetails(member.id)
        // this.router.navigate(['/gig-to-corp/' + member.id]);
      }
    });


  }

  getCustomerDetails(id) {
    var accessToken = sessionStorage.getItem('accessToken');

    let customerDataEndpoint = '/customer/' + id + '/details/first';
    this.http.get(environment.apiUrl + '/api/ap/admin' + customerDataEndpoint, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe(async (response: any) => {
      if (response.status == 200) {

        this.MemberDetails = response.data

        this.provincelist1(this.MemberDetails.province)


      }
    })
  }

  public getclientList1() {
    this.store.dispatch(loadCorporateData());
    this.corporateData$ = this.store.select(state => state.corporateData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.corporateData$.subscribe(data => {
      if (data) {
        console.log(data)
        if (data?.corporateData == undefined || Object.keys(data.corporateData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if (this.clientList.length > 0) {
          this.dtTrigger.next(null);
          return;
        }
        this.sortColumn = 'name';
        this.sortOrder = 'ASC';
        this.loader = false;

        const role = sessionStorage.getItem('role');
        if (role == 'ADMINISTRATOR') {
          // this.clientList = decompress(data.corporateData)
          this.clientList = data.corporateData
        } else {
          this.clientList = data.corporateData.map(res => {
            return {
              ...res,
              formsLength: res.forms?.length || 0
            }
          })
        }
        this.filterStatus = [];
        this.clientList?.map((member) => {
          if (!this.filterStatus.includes(member.status))
            this.filterStatus.push(member.status);
          if (!member.published || member.published == undefined || member.published == null) {
            return { ...member, published: false }
          } else {
            return { ...member }
          }
        });
        setTimeout(() => {
          const sortedList = [...this.clientList].sort((a, b) => {
            const order = { true: 1, false: 2, cancelled: 3 };
            if (order[a.status] !== order[b.status]) {
              return order[a.status] - order[b.status];
            }
            return a.name.trim().localeCompare(b.name.trim());
          });
          this.clientList = sortedList;
          this.restLoader = false;
          setTimeout(() => {
            this.dtTrigger.next(null);
          }, 0);
        }, 0)
      } else {
        console.error('Observable returned undefined');
      }
    })
  }
  public planenrollmentdate: any

  terminatemember(client: any, index: number) {
    this.terminationform.reset();
    this.setMinDateBasedOnRoleAndStatus(client);
    this.emplomentFirstName = client.firstName;//client.name;
    this.emplomentLastName = client.lastName;//client.name;
    this.planenrollmentdate = client.customerSignup?.enrollmentDate
    this.memberid = client.id;
    $("#showmemberlist").modal('show');

  }


  isDisabled() {
    const checkVal = this.staxbillDetails ? this.staxbillDetails.refundApplicable == false ? true : false : true
    return checkVal;
  }

  submitterminationEnd() {

    this.terminateMemberDetails.proceedWithGreenshield = this.terminationformDetails.get('proceedWithGreenshield').value
    this.terminateMemberDetails.proceedWithRefund = this.terminationformDetails.get('proceedWithRefund').value
    this.terminateMemberDetails.proceedWithSmartchoice = this.terminationformDetails.get('proceedWithSmartchoice').value
    this.terminateMemberDetails.proceedWithSubscriptionExpiry = this.terminationformDetails.get('proceedWithSubscriptionExpiry').value
    this.terminateMemberDetails.proceedWithCancelCustomer = this.terminationformDetails.get('proceedWithCancelCustomer').value
    this.terminateMemberDetails.proceedWithEquitable = this.terminationformDetails.get('proceedWithEquitable').value
    this.terminateMemberDetails.proceedWithPHR = this.terminationformDetails.get('proceedWithPHR').value
    this.terminateMemberDetails.refundAmount = this.terminationformDetails.get('refundAmount').value


    let data = {
      'data': this.terminateMemberDetails,
      'reason': this.terminationformDetails.get('reason').value ?? " ",
    };

    this.logger.log(data);

    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/member/' + this.memberid + '/confirmMemberTermination';
    var headers = {
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
    };

    this.http.post(environment.apiUrl + terminate, data, { headers: headers })
      .subscribe(async (responce: any) => {
        this.logger.log("entering")
        console.log({ responce })

        if (responce.status == '200') {
          var details = '/api/ap/admin/customers/list';

          // await postServiceWorkerMessage(WorkerMessageType.Delete, [
          //   environment.apiUrl + details
          // ]);

          // this.getServiceWorkerDetails()
          $("#DataTables_Table_0").dataTable().fnDestroy();
          Swal.fire({ title: "Info", html: responce.message }).then(async (res) => {
            if (res.isConfirmed) {



              // this.dtTrigger.next(null);
            }
          });
          $('#showTerminateMemberDetails').modal('hide');

          // this.globalStoreService.setMemberDetails()
          console.log(this.members)
          // this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => { })
          // this.http.get(environment.apiUrl + '/api/ap/global/set-adminAdvisors').subscribe((newResponse) => { })
          this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {
            this.members = this.members.map(member =>
              member.id == this.memberid ? { ...member, status: 'Cancelled' } : member
            );
            // this.members=[]
            this.store.dispatch(loadMemberDataSuccess({ memberData: this.members }))
            // this.store.dispatch(loadMemberData())
            // this.getclientList();
            this.http.post(environment.reportApiUrl + '/websocket/member/notification-to-others', {
              "message": "Members information has been updated. Please refresh screen."
            }, { headers: headers }).subscribe((res) => { })

            // this.refreshTableData()
            // window.location.reload()
          })

        } else {
          Swal.fire({ title: "Info", text: responce.message });
        }

      }, (error) => {
        Swal.fire({ title: "Error", text: error.message || error.data.message });
      })
  }
  closeTerminatePopup(id: any) {
    $(`#${id}`).modal("hide");
    this.terminationform.reset();
  }

  submittermination() {
    if (this.terminationform.invalid) {
      this.terminationform.markAllAsTouched()
      this.toastrService.error(this.lang.Minimium_Date + `:${moment(this.minDate).format('MM-DD-YYYY')} \n` + this.lang.Note + `"${this.note}`);

      this.logger.log(this.terminationform.controls)
      return
    }
    this.logger.log(this.terminationform.value)
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/member/' + this.memberid + '/configureMemberTermination';

    let data = {
      "reason": this.terminationform.value.reason,
      "memberStatus": this.terminationform.value.memberstatus,
      "terminationDate": this.datePipe.transform(
        this.terminationform.value.terminationDate,
        'yyyy-MM-dd'
      ) || ''
    }
    let terminateDate = this.datePipe.transform(this.terminationform.value.terminationDate, 'yyyy-MM-dd') || ''

    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/member/' + this.memberid + '/configureMemberTermination';
    // /member/{memberId}/configureMemberTermination
    let queryParams = new HttpParams();
    queryParams = queryParams.append("terminationDate", terminateDate);
    this.http
      .get(environment.apiUrl + terminate, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
        params: queryParams
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            $("#showmemberlist").modal('hide');
            $('#showTerminateMemberDetails').modal('show');

            this.terminateMemberDetails = response.data;

            // alert(this.terminateMemberDetails.serviceType)

            this.logger.log("asasasa", this.terminateMemberDetails);
            this.terminateReasonsApplicable = this.terminateMemberDetails.terminateReasonsApplicable;
            this.servicDetails = this.terminateMemberDetails.serviceDetails;
            this.terminateReasonsWithKeys = response.data.terminateReasonsWithKeys;
            this.logger.log('terminateReasonsWithKeys', this.terminateReasonsWithKeys);
            this.staxbillDetails = this.terminateMemberDetails.staxbillDetails;

            let proceedWithEquitable = this.terminateMemberDetails.proceedWithEquitable;
            let proceedWithGreenshield = this.terminateMemberDetails.proceedWithGreenshield;
            let proceedWithPHR = this.terminateMemberDetails.proceedWithPHR
            let proceedWithRefund = this.terminateMemberDetails.proceedWithRefund;
            let refundAmount = this.staxbillDetails.refundAmount == 'NA' ? "N/A" : this.staxbillDetails.refundAmount;

            let proceedWithSmartchoice = this.terminateMemberDetails.proceedWithSmartchoice;
            let proceedWithSubscriptionExpiry = this.terminateMemberDetails.proceedWithSubscriptionExpiry;
            let proceedWithCancelCustomer = this.terminateMemberDetails.proceedWithCancelCustomer;

            this.terminationsProvisioning = response.data.terminationsProvisioning

            this.terminationformDetails.get('proceedWithEquitable').setValue(proceedWithEquitable);
            this.terminationformDetails.get('proceedWithGreenshield').setValue(proceedWithGreenshield);
            this.terminationformDetails.get('proceedWithPHR').setValue(proceedWithPHR);
            this.terminationformDetails.get('proceedWithRefund').setValue(proceedWithRefund);
            this.terminationformDetails.get('proceedWithSmartchoice').setValue(proceedWithSmartchoice);
            this.terminationformDetails.get('proceedWithSubscriptionExpiry').setValue(proceedWithSubscriptionExpiry);
            this.terminationformDetails.get('proceedWithCancelCustomer').setValue(proceedWithCancelCustomer);
            this.terminationformDetails.get('refundAmount').setValue(refundAmount);


            for (let control of Object.keys(this.terminationformDetails.controls)) {
              this.terminationformDetails.get(control).updateValueAndValidity();
            }
            // Swal.fire({ title: this.lang.Info, text: response.message })

          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message })
          }
        }, (error) => {
          if (error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
        }
      );
  }

  closeModelPopup(id: any) {
    $('#' + id).modal('hide');
  }
  viewCustomerDetails(id: any) {
    this.router.navigate(['/customer/' + id + '/details']);
  }



  public addClientDetails() {
    this.router.navigate(['/addCorporate']);

  }
  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }


  // getServiceWorkerDetails() {
  //   var getClients = '/api/ap/admin/customers/list';

  //   let prefetchurls = []

  //   let Data = [{
  //     url: environment.apiUrl + getClients,
  //     // fetch options
  //     options: {
  //       mode: 'cors',
  //       headers: {
  //         Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
  //         'Content-Type': 'application/json',
  //       }
  //     }
  //   }]
  //   prefetchurls = Data

  //   postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls).then((results: WorkerUrlPrefetchResult) => {
  //     $("#DataTables_Table_0").dataTable().fnDestroy();

  //     // this._LoaderService.HideLoader()


  //     setTimeout(() => {
  //       this.members = results[0].response.data;
  //       this.filterStatus = [];
  //       this.members.map((member) => {
  //         if (!this.filterStatus.includes(member.status))
  //           this.filterStatus.push(member.status);
  //       });
  //       this.logger.log("status", this.filterStatus);
  //       this.members.sort((a, b) => {
  //         const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };

  //         if (order[a.status] !== order[b.status]) {
  //           return order[a.status] - order[b.status];
  //         }
  //         // return a.firstName.localeCompare(b.firstName);
  //         const result = a.firstName.localeCompare(b.firstName);
  //         return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
  //       });
  //       this.Allmembers = this.members;
  //       let filter//sorting get all active members sub sort by last name. append draft sub sort by last name

  //       this.dtTrigger.next(null);
  //       // this.members=response.data;
  //       this.loader = false
  //       setTimeout(() => {
  //         this.showfilter = true
  //       }, 1000);


  //     }, 1000)
  //   })
  // }

  // public getclientList() {
  //   var corporateId = sessionStorage.getItem('corporateId');
  //   var accessToken = sessionStorage.getItem('accessToken');
  //   // var getClients = '/api/ap/admin/customers/list';
  //   const role = sessionStorage.getItem('role')
  //   let getClients = ''
  //   if (role == 'ADMINISTRATOR') {
  //     // getClients = 'http://[::1]:3002/api/ap/global/adminMembers';
  //     getClients = '/api/ap/global/adminMembers';
  //   } else {
  //     getClients = '/api/ap/admin/customers/list';
  //   }
  //   const that = this;

  //   this.loader = true;
  //   this.http
  //   .get(environment.apiUrl + getClients, {
  //     // .get(getClients, {
  //       headers: {
  //         Authorization: 'Bearer ' + accessToken,
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     .subscribe(
  //       (response: any) => {

  //         if (response['status'] == 200 || response['statusCode'] == 200) {
  //           // this.members = (response as any).data;
  //           if (role == 'ADMINISTRATOR') {
  //             this.members = decompress(response.data)
  //           } else {
  //             this.members = response.data.map(res=>{return {
  //               ...res,
  //               username: res.user?.username,
  //               primaryPhone: res?.contactInformations?.[0]?.primaryPhone || '',
  //             }})
  //           }
  //           console.log('this.members',this.members)
  //           this.filterStatus = [];
  //           // this.members.map((member) => {
  //           //   if (!this.filterStatus.includes(member.status))
  //           //     this.filterStatus.push(member.status);
  //           // });
  //           this.logger.log("status", this.filterStatus);
  //           this.members.sort((a, b) => {
  //             const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };

  //             if (order[a.status] !== order[b.status]) {
  //               return order[a.status] - order[b.status];
  //             }
  //             // return a.firstName.localeCompare(b.firstName);
  //             const result = a.firstName.localeCompare(b.firstName);
  //             return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
  //           });
  //           this.Allmembers = this.members;
  //           let filter//sorting get all active members sub sort by last name. append draft sub sort by last name

  //           this.dtTrigger.next(null);
  //           this.restLoader = false
  //           this.logger.log(JSON.stringify(this.members));
  //           this.loader = false
  //           // this.globalStoreService.setMemberDetails(this.members)
  //           // setTimeout(() => {
  //           //   this.showfilter = true
  //           // }, 1000);
  //           // this.http.get(environment.apiUrl+'/api/ap/global/set-adminMembers').subscribe((newResponse) => {})
  //         } else {
  //           this.loader = false
  //           Swal.fire({ title: this.lang.Error??'Error', text: response.message })
  //         }
  //       },
  //       (error) => {
  //         this.loader = false
  //         if (
  //           error.status == 400 ||
  //           error.status == 401 ||
  //           error.status == 402 ||
  //           error.status == 403
  //         ) {
  //           Swal.fire({
  //             title: 'Error',
  //             text: error.error.error.message,
  //             showDenyButton: false,
  //             showCancelButton: false,
  //             confirmButtonText: 'OK',
  //           }).then((result) => {
  //             /* Read more about isConfirmed, isDenied below */
  //             if (result.isConfirmed) {
  //               sessionStorage.clear();
  //               this.router.navigate(['/login']);
  //             }
  //             else {
  //               sessionStorage.clear();
  //               this.router.navigate(['/login']);
  //             }
  //           });
  //         } else {
  //           // Swal.fire(error.error.error.message)
  //           Swal.fire({ title: 'Error', text: error.error.error.message });
  //         }
  //         // this.toastrService.error("Invalid Credentials", 'Error!');
  //       }
  //     );

  // // this.loader = true;
  // // const memberDetails = this.globalStoreService.getMemberDetails()

  // // if(memberDetails?.length!=0) {
  // //   this.loadData(memberDetails)
  // // } else {
  // //   this.globalStoreService.setMemberDetails();
  // //   const memberDetails = this.globalStoreService.getMemberDetails()
  // //   this.loadData(memberDetails)
  // // }
  // }

  public getclientList() {
    this.store.dispatch(loadMemberData());

    this.membersData$ = this.store.select(state => state.memberData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.membersData$.subscribe(data => {
      if (data) {
        sessionStorage.setItem("data", JSON.stringify(data))

        if ((data?.memberData == undefined || Object.keys(data.memberData).length <= 0) && data?.loading == true) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if (this.members?.length > 0 && data?.loading == false) {
          this.dtTrigger.next(null);
          return;
        }
        const role = sessionStorage.getItem('role');
        if (role == 'ADMINISTRATOR') {
          // this.members = decompress(data.memberData);
          this.members = data.memberData;
          if(this.members && this.members.length > 0){
            this.members = this.members.map(res => {
              return {
                ...res,
                isCorporateAccount: res.isCorporateAccount == null || res.isCorporateAccount == undefined ? false : res.isCorporateAccount,
              }
            })
          }
        } else {
          this.members = data.memberData.map(res => {
            return {
              ...res,
              username: res.user?.username,
              primaryPhone: res?.contactInformations?.[0]?.primaryPhone || '',
              isCorporateAccount: res.isCorporateAccount == null || res.isCorporateAccount == undefined ? false : res.isCorporateAccount,
            };
          });
        }

        setTimeout(() => {
          this.members = this.members.filter((member: any) => member.firstName != null && member.firstName != undefined && member.lastName != null && member.lastName != undefined).sort((a, b) => {
            const order = { Active: 1, Draft: 2, Suspended: 3, Hold: 4, Cancelled: 5, Incomplete: 6 };

            if (order[a.status] !== order[b.status]) {
              return order[a.status] - order[b.status];
            }
            const result = a.firstName.localeCompare(b.firstName);
            return result !== 0 ? result : a.lastName.localeCompare(b.lastName);
          });
          // this.sortColumn = 'firstName';
          this.sortOrder = 'ASC';
          let brokerId = sessionStorage.getItem("brokerId");
          if(brokerId && brokerId != null && brokerId != undefined && brokerId != ""){
          let signinResults:any = JSON.parse(sessionStorage.getItem("signinResults") ?? "{}");
          console.log(signinResults);
            if(signinResults && signinResults != null && signinResults != undefined && signinResults != ""){
              this.members = this.members.filter((item:any) => item.user.username == (signinResults?.email ?? ""));
            }
          }
          this.Allmembers = this.members;
          console.log(this.members)
          this.loader = false;
          this.restLoader = false;
          setTimeout(() => {
            this.dtTrigger.next(null);
          }, 100);
        }, 0);
      }
    })
  }

  loadData = (memberDetails) => {
    this.members = memberDetails;
    this.Allmembers = this.members;
    setTimeout(() => {
      this.dtTrigger.next(null);
    }, 0)
    this.restLoader = false;
    this.logger.log(JSON.stringify(this.members));
    this.loader = false
  }

  // get filteredAndPaginatedMembers() {
  //   const filteredMembers = this.members.filter(member => {
  //     return Object.values(member).some(value =>
  //       String(value).toLowerCase().includes(this.filterValue.toLowerCase())
  //     );
  //   });

  //   const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  //   return filteredMembers.slice(startIndex, startIndex + this.itemsPerPage);
  // }

  get filteredAndPaginatedMembers() {
    // Filter members based on the filter value
    const filteredMembers = this.members.filter(member => {
      return Object.values(member).some(value =>
        String(value).toLowerCase().includes(this.filterValue.toLowerCase())
      );
    });

    // Sort the filtered members based on the current sort column and order
    if (this.sortColumn) {
      filteredMembers.sort((a, b) => {
        let valueA = a[this.sortColumn] !== undefined && a[this.sortColumn] !== null ? a[this.sortColumn] : '';
        let valueB = b[this.sortColumn] !== undefined && b[this.sortColumn] !== null ? b[this.sortColumn] : '';

        // If the value is a boolean, convert to 1 or 0 for sorting
        if (typeof valueA === 'boolean') {
          valueA = valueA ? 1 : 0;
        }
        if (typeof valueB === 'boolean') {
          valueB = valueB ? 1 : 0;
        }

        // Trim and normalize strings (to lower case) for comparison
        if (typeof valueA === 'string') {
          valueA = valueA.trim().toLowerCase();
        }
        if (typeof valueB === 'string') {
          valueB = valueB.trim().toLowerCase();
        }

        // Handle dates
        if (typeof valueA === 'string' && Date.parse(valueA)) {
          valueA = new Date(valueA);
        }
        if (typeof valueB === 'string' && Date.parse(valueB)) {
          valueB = new Date(valueB);
        }

        // Compare strings alphabetically
        if (typeof valueA === 'string' && typeof valueB === 'string') {
          if (valueA < valueB) {
            return this.sortOrder === 'ASC' ? -1 : 1;
          }
          if (valueA > valueB) {
            return this.sortOrder === 'ASC' ? 1 : -1;
          }
        }

        // Compare numbers
        if (typeof valueA === 'number' && typeof valueB === 'number') {
          if (valueA < valueB) {
            return this.sortOrder === 'ASC' ? -1 : 1;
          }
          if (valueA > valueB) {
            return this.sortOrder === 'ASC' ? 1 : -1;
          }
        }

        // Compare dates (after parsing string to Date)
        if (valueA instanceof Date && valueB instanceof Date) {
          return this.sortOrder === 'ASC' ? valueA.getTime() - valueB.getTime() : valueB.getTime() - valueA.getTime();
        }

        return 0;
      });
    }

    // Paginate the filtered and sorted members
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return filteredMembers.slice(startIndex, startIndex + this.itemsPerPage);
  }


  sortTable(column: string): void {
    console.log('Sorting by column:', column);

    // Toggle the sort order if the same column is clicked
    if (this.sortColumn === column) {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      // Default to ascending order if a new column is clicked
      this.sortColumn = column;
      this.sortOrder = 'ASC';
    }
  }

  // sortTable(column: string): void {
  //   console.log('Sorting by column:', column);

  //   // Toggle the sort order if the same column is clicked
  //   if (this.sortColumn === column) {
  //     this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
  //   } else {
  //     // Default to ascending order if a new column is clicked
  //     this.sortColumn = column;
  //     this.sortOrder = 'ASC';
  //   }

  //   // Apply the sorting to the data
  //   this.members.sort((a, b) => {
  //     // Handle cases where properties may be null or undefined
  //     let valueA = a[column] !== undefined && a[column] !== null ? a[column] : '';
  //     let valueB = b[column] !== undefined && b[column] !== null ? b[column] : '';

  //     // If the value is a date string, convert it to a Date object
  //     if (typeof valueA === 'string' && Date.parse(valueA)) {
  //       valueA = new Date(valueA);
  //     }
  //     if (typeof valueB === 'string' && Date.parse(valueB)) {
  //       valueB = new Date(valueB);
  //     }

  //     // If values are strings, compare them alphabetically
  //     if (typeof valueA === 'string' && typeof valueB === 'string') {
  //       if (valueA < valueB) {
  //         return this.sortOrder === 'ASC' ? -1 : 1;
  //       }
  //       if (valueA > valueB) {
  //         return this.sortOrder === 'ASC' ? 1 : -1;
  //       }
  //     }

  //     // If values are numbers, compare them numerically
  //     if (typeof valueA === 'number' && typeof valueB === 'number') {
  //       if (valueA < valueB) {
  //         return this.sortOrder === 'ASC' ? -1 : 1;
  //       }
  //       if (valueA > valueB) {
  //         return this.sortOrder === 'ASC' ? 1 : -1;
  //       }
  //     }

  //     // If values are dates (after parsing the string), compare them
  //     if (valueA instanceof Date && valueB instanceof Date) {
  //       return this.sortOrder === 'ASC' ? valueA.getTime() - valueB.getTime() : valueB.getTime() - valueA.getTime();
  //     }

  //     // For non-comparable types or default behavior
  //     return 0;
  //   });

  //   console.log('Sorted data:', this.members);
  // }


  totalPages() {
    // return Math.ceil(this.members.length / this.itemsPerPage);
    const filteredMembers = this.members.filter(member => {
      return Object.values(member).some(value =>
        String(value).toLowerCase().includes(this.filterValue.toLowerCase())
      );
    });
    return Math.ceil(filteredMembers.length / this.itemsPerPage);
  }

  nextPage() {
    if (this.currentPage < this.totalPages()) {
      this.currentPage++;
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  refreshTableData() {
    this.members = [];
    this.Allmembers = [];
    this.filterStatus = [];
    this.loader = true;
    this.filterValue = ''

    // if ($.fn.DataTable.isDataTable('#DataTables_Table_0')) {
    //   $('#DataTables_Table_0').DataTable().clear().destroy();
    // }
    this.getclientList()
  }

  changeStatus(e: any) {
    this.showfilter = false;
    // this.Allmembers=this.members;
    $("#DataTables_Table_0").dataTable().fnDestroy();
    this.members = [];

    let val = e.target.value.toLowerCase();//member.status.toLowerCase()==val
    if (val == 'all') {
      this.members = this.Allmembers;
    } else {
      this.members = this.Allmembers.filter((member) => {
        if (member.status.toLowerCase() == val) {
          return member;
        }
      });
    }
    this.dtTrigger.next(null);
    this.logger.log(this.members);
    // this.showfilter = true

    setTimeout(() => {
      this.showfilter = true
    }, 500);
  }

  public deletebrokerDetails(broker: any, index: any) {

    this.logger.log(broker)
    // this.logger.log(index)
    var accessToken = sessionStorage.getItem('accessToken');
    var deleteBroker = '/api/ap/broker/' + broker.id + ''


    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_delete_this,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        this.http
          .delete(environment.apiUrl + deleteBroker, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                // this.dtTrigger.next("");
                window.location.reload()
                // this.getBrokerList()
              } else {
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error ?? 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      }
    })

  }


  public showDetails(member: any, index: number) {

    this.customerId = member.id;
    sessionStorage.setItem("customerId", member.id);
    this.showmemberData = true;
    this.logger.log({ member })
    this.SharedService.setUserName(member.firstName + " " + member.lastName)
    sessionStorage.setItem('memberUserName', member.firstName + " " + member.lastName);

    this.router.navigate(['/manageMembers/employee/' + member.id + '/details']);

    // const modal = new Modal(this.memberdetails.nativeElement);
    // modal.show();
    // setTimeout(() => {
    //   // $('#memberdetails-modal').modal('show');

    // }, 100);

  }

  public brokerStatus(customer: any, event: any, index: number) {

    $("#DataTables_Table_0").dataTable().fnDestroy();

    var accessToken = sessionStorage.getItem('accessToken');
    // var brokerStatus = '/api/ap/broker/' + broker.id + '/activation/' + event
    var brokerStatus = '/api/ap/customer/' + customer.id + '/status/' + event

    let obj = {}
    Swal.fire({
      title: this.lang.Info,
      text: this.lang.Are_you_sure_you_want_to_change_this + customer.firstName + this.lang.Status + '?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang.Submit,
      cancelButtonText: this.lang.Close
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        this.http
          .put(environment.apiUrl + brokerStatus, obj, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                // window.location.reload()
                this.getclientList()
              } else {
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message })
              }
            },
            (error) => {
              if (error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error ?? 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    // sessionStorage.clear();
                    // this.router.navigate(['/login']);
                  }
                  else {
                    // sessionStorage.clear();
                    // this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      }
      else {
        this.getclientList()
        // window.location.reload()
      }
    })

  }


  getCorporateData() {

    $('#showCorporatelist').modal('hide');
    const selectedValue = this.corporateList.get('corporateName').value;
    console.log(selectedValue)
    this.selectedItem = this.clientList.find(item => item.name === selectedValue);
    console.log('Selected Item:', this.selectedItem);

    Swal.fire({
      title: this.lang.Alert,
      text: "Are you sure want to add this Member as Group Contact to this Corporate?",
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.addadminFinal(this.selectedItem.id, this.selectedItem.parentId)

      }
      else {
        $("#showaddMemberConfiguration").modal('show')
        // Swal.fire({
        //   title: 'Info',
        //   text: 'Add this GIG Member with which plans?',
        //   showDenyButton: true,
        //   showCancelButton: true,
        //   confirmButtonText: 'Existing',
        //   denyButtonText: `Convert`,
        //   cancelButtonText: 'New',

        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     this.continueWithExistingPlans = true
        //     this.samePlansWithCorporate = false
        //     this.effectiveDateForm.reset()
        //     $('#showeffectiveDate').modal('show');
        //   }
        //   else if (result.isDenied) {
        //     this.continueWithExistingPlans = false
        //     this.samePlansWithCorporate = true


        //     this.effectiveDateForm.reset()
        //     $('#showeffectiveDate').modal('show');
        //   }
        //   else {
        //     this.continueWithExistingPlans = false
        //     this.samePlansWithCorporate = false
        //     this.effectiveDateForm.reset()
        //     $('#showeffectiveDate').modal('show');
        //   }
        // })
        // this.gigtoCorpConvertion(selectedItem.id, selectedItem.parentId)
      }
    })

  }
  ExistingPlans() {
    this.continueWithExistingPlans = true
    this.samePlansWithCorporate = false
    this.effectiveDateForm.reset()
    $('#showaddMemberConfiguration').modal('hide');
    $('#showeffectiveDate').modal('show');
  }
  ConvertPlans() {
    this.continueWithExistingPlans = false
    this.samePlansWithCorporate = true


    this.effectiveDateForm.reset()
    $('#showaddMemberConfiguration').modal('hide');
    $('#showeffectiveDate').modal('show');
  }
  Newplans() {
    this.continueWithExistingPlans = false
    this.samePlansWithCorporate = false
    this.effectiveDateForm.reset()
    $('#showaddMemberConfiguration').modal('hide');
    $('#showeffectiveDate').modal('show');
  }

  addadminFinal(CorpId, parentId) {

    let obj = {
      firstName: this.capitalize(this.MemberDetails.firstName),
      lastName: this.capitalize(this.MemberDetails.lastName),
      phoneNum: this.MemberDetails.primaryPhone,
      email: this.MemberDetails.primaryEmail,
      role: 'CORPORATE_PLAN_ADMINISTRATOR',
      roleName: ''
    };

    let endPoint = `/api/ap/admin/v2/corporate/${CorpId}/groupAdmin`;
    let accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            $("#showaddMemberConfiguration").modal('show')

            // Swal.fire({
            //   title: 'Info',
            //   text: 'Add this GIG Member with which plans?',
            //   showDenyButton: true,
            //   showCancelButton: true,
            //   confirmButtonText: 'Existing',
            //   denyButtonText: `Convert`,
            //   cancelButtonText: 'New',

            // }).then((result) => {
            //   if (result.isConfirmed) {
            //     this.continueWithExistingPlans = true
            //     this.samePlansWithCorporate = false
            //     this.effectiveDateForm.reset()
            //     $('#showeffectiveDate').modal('show');
            //     // this.gigtoCorpConvertion(CorpId, parentId)
            //   }
            //   else if (result.isDenied) {
            //     this.continueWithExistingPlans = false
            //     this.samePlansWithCorporate = true


            //     this.effectiveDateForm.reset()
            //     $('#showeffectiveDate').modal('show');
            //   }
            //   else {
            //     this.continueWithExistingPlans = false
            //     this.samePlansWithCorporate = false
            //     this.effectiveDateForm.reset()
            //     $('#showeffectiveDate').modal('show');
            //     // this.getCorporatePlans(CorpId)
            //   }
            // })

            // this.gigtoCorpConvertion(CorpId, parentId)

          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            })
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );


  }

  submiteffectiveDate() {


    var corporateId = sessionStorage.getItem('corporateId');
    $('#showeffectiveDate').modal('hide');
    if (this.continueWithExistingPlans && !this.samePlansWithCorporate) {
      this.gigtoCorpConvertion(this.selectedItem.id, this.selectedItem.parentId)
    }
    else if (!this.continueWithExistingPlans && this.samePlansWithCorporate) {
      console.log(this.MemberDetails)
      console.log(this.MemberDetails.state)
      console.log(this.configprovinceres)


      let requests = []; // Array to store all HTTP requests
      let statesData = this.configprovinceres.filter((item) => {
        // return item.name??item.shortName == this.MemberDetails.state
        return item.name == this.MemberDetails.state || item.shortName == this.MemberDetails.state

      });

      console.log(statesData)

      if (this.MemberDetails.customerPlans.length > 0) {

        for (let i = 0; i < this.MemberDetails.customerPlans.length; i++) {


          let produtype;
          let productCoverage;

          if (this.MemberDetails.customerPlans[i].isBundle) {
            if (this.MemberDetails.customerPlans[i].name.includes("Classic")) {
              produtype = 'CORP';
            }
            else {
              produtype = 'BOTH';
            }

            productCoverage = this.MemberDetails.customerPlans[i].coverage1.trim();
          } else {
            produtype = 'BOTH';
            productCoverage = 'any';
          }

          let accessToken = sessionStorage.getItem('accessToken');
          let endPoint = `/api/ap/plan/pricing?plan=${this.MemberDetails.customerPlans[i].name}&state=${statesData[0].shortName}&productType=${produtype}&productCoverage=${productCoverage}&fields=all`;

          let request = this.http.get(environment.apiUrl + endPoint, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          });

          requests.push(request); // Push the request into the array
        }

        // Execute all HTTP requests in parallel and wait for completion
        forkJoin(requests).subscribe((responses: any[]) => {
          responses.forEach(response => {
            if (response?.status === 200) {

              let obj = {
                "enrollmentDate": this._CustomDatePipe.transform(this.effectiveDateForm.get('effectiveDate').value),
                "taxesInfo": this.determineTaxes(response.data?.products?.[0]?.calculatedTax?.planProductInfos ?? []),
                "taxApplicable": response.data.totalTax > 0
              };

              Object.assign(response.data, obj, { ...obj.taxesInfo });
              this.plansDataarray.push(response.data);
            }
          });

          // Call gigtoCorpConvertion after all requests are done
          this.gigtoCorpConvertion(this.selectedItem.id, this.selectedItem.parentId);
        });
      }
      else {
        Swal.fire({ title: "Info", text: 'No Existing Plans Available' });
      }

      //   for (let i = 0; i < this.MemberDetails.customerPlans; i++) {
      //     let produtype
      //     let productCoverage

      //     if (this.MemberDetails.customerPlans[i].isBundle == true) {
      //       produtype = 'CORP'
      //       productCoverage = this.MemberDetails.customerPlans[i].coverage1
      //     }
      //     else {
      //       produtype = 'BOTH'
      //       productCoverage = 'any'
      //     }
      //     let accessToken = sessionStorage.getItem('accessToken');

      //     let endPoint = `api/ap/plan/pricing?plan=${this.MemberDetails.customerPlans[i].name}&state=${this.MemberDetails.customerPlans[i].province}&productType=${produtype}&productCoverage=${productCoverage}&fields=all`;
      //     this.http
      //       .post(environment.apiUrl + endPoint, {
      //         headers: {
      //           Authorization: 'Bearer ' + accessToken,
      //           'Content-Type': 'application/json',
      //         },
      //       })
      //       .subscribe(
      //         (response: any) => {
      //           if (response['status'] == 200) {

      //             let obj = {
      //               "enrollmentDate": this._CustomDatePipe.transform(this.effectiveDateForm.get('effectiveDate').value),
      //               "taxesInfo": this.determineTaxes(response.data?.products?.[0]?.calculatedTax?.planProductInfos ?? []),
      //               "taxApplicable": response.data.tax > 0
      //             }

      //             Object.assign(response.data, obj);
      //             this.plansDataarray.push(response.data)


      //           }
      //         })
      //   }
      // this.gigtoCorpConvertion(this.selectedItem.id, this.selectedItem.parentId)



    }


    else {
      this.getCorporatePlans(this.selectedItem.id)
    }

  }
  public provincelist1(event: any) {
    // alert(event.target.value)

    this.configprovinceres.forEach((element: any) => {
      if (element.name == event) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });


  }

  getCorporatePlans(corporateId: any) {

    console.log(this.MemberDetails)
    console.log(this.configprovinceres)

    let statesData = this.configprovinceres.filter((item) => {
      // return item.name ?? item.shortName === this.MemberDetails.state
      return item.name == this.MemberDetails.state || item.shortName == this.MemberDetails.state

    });

    console.log(statesData)
    let statesId: any;
    let statesName: any;
    let fusebillStateId: any
    if (statesData.length > 0) {
      statesId = statesData[0].id;
      fusebillStateId = parseInt(statesData[0].fusebillId),
        statesName = statesData[0].name;
    } else {
      statesId = '';
      fusebillStateId = '';
      statesName = '';
    }

    let obj = {
      "isStudent": false,
      "recaptchaCheck": false,
      "g_recaptcha_response": "test",
      "fusebillCustomerId": null,
      "planEnrollmentDate": this._CustomDatePipe.transform(this.effectiveDateForm.get('effectiveDate').value) || '0000-00-00',
      "enrollmentDate": this._CustomDatePipe.transform(this.effectiveDateForm.get('effectiveDate').value) || '0000-00-00',
      "EnrollmentDate": this._CustomDatePipe.transform(this.effectiveDateForm.get('effectiveDate').value) || '0000-00-00',
      "first_name": this.MemberDetails.firstName,
      "firstName": this.MemberDetails.firstName,
      "last_name": this.MemberDetails.lastName,
      "lastName": this.MemberDetails.lastName,
      "email": "johndemoaitp" + this.genRandonString(3) + "@aitestpro.com",
      "phone_number": this.MemberDetails.primaryPhone,
      "street_address_line1": this.MemberDetails.line1,
      "street_address_line2": this.MemberDetails.line2,
      "city": this.MemberDetails.city,
      "province": statesData[0].shortName,
      "province_id": this.provincelistid,
      "country": "Canada",
      "country_id": 124,
      "countryId": 124,
      "postal_code": this.MemberDetails.postalCode,
      "date_of_birth": this.MemberDetails.dob,
      "dob": this.MemberDetails.dob,
      "gender": this.MemberDetails.gender,
      "workingProvince": this.MemberDetails.province,
      "enrolmentProgramName": "",
      "working_20hours": true,
      "weeklyHours": 0,
      "hours_per_week": 40,
      "coveredParentalHealthInsurance": false,
      "provincial_health_coverage": true,
      "work_visa": "",
      "having_spouse": false,
      "spouse_details": {},
      "having_dependent_children": false,
      "no_of_children": 0,
      "children_details": "",
      "signature": "digiSign",
      "fusebillCustomer": true,
      "formId": this.corporateDetailsMain.formId || 1,
      "brokerId": +this.selectedItem.id,
      "termsandconditions": "",
      "disclouseradvisor": true,
      "state": statesData[0].shortName,
      "stateId": this.state_id,
      "state_id": this.state_id,
      "fusebillStateId": fusebillStateId,
      "currency": "CAD",
      "currencySymbol": "$",
      "apt": "",
      "studentId": null,
      "beneficiaries_details": [],
      "employeeKey": "",
      "employeeGeneric": true,
      "employerName": "",
      "date_of_hiring": this._CustomDatePipe.transform(this.MemberDetails.registrationDate),
      "isCorporate": true
    }
    let validationdata: string = `${environment.apiUrl}/api/ap/customer/v3/plans`;

    var accessToken = sessionStorage.getItem('accessToken');
    //this.studentService.validation(personalInfoData)
    this.http.post(validationdata, obj,
      {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        }
      })
      .subscribe(
        (result: any) => {
          if (result.status == '200') {
            $("#showPlansForEmployee").modal('show')
            this.allFormData = {}
            this.formData = {}
            this.mainarray = [];
            this.mainarrayValues = [];
            this.mainarrayFinal = [];
            this.modifiedBlocksPaidByCompany = ''
            this.modifiedBlocksCoveredByCompany = '',



              sessionStorage.setItem("employeeshare", "0");



            sessionStorage.setItem('plansummaryLife', '[]');
            sessionStorage.setItem('planssummarymainLife', '[]');

            sessionStorage.setItem("planDetailsArrayBlock", "[]");

            sessionStorage.setItem("totalAmount", "0");
            sessionStorage.setItem("totalAmountUI", "0");

            sessionStorage.setItem("allSelectedPlans", "[]");


            sessionStorage.setItem("plansummary", "[]");
            sessionStorage.setItem("selectedPlans", "{}");
            sessionStorage.setItem("selectedPlansLife", "{}");
            sessionStorage.setItem("plansummarymain", "[]");
            sessionStorage.setItem("plansummaryopt", "[]");
            sessionStorage.removeItem("Spousesignature")


            sessionStorage.setItem(
              "corporateStateId",
              result.data.workingProvince.id
            );
            sessionStorage.setItem(
              "corporateStateName",
              result.data.workingProvince.name
            );
            sessionStorage.setItem(
              "companyStateId",
              result.data.corporateProvince.id
            );
            // sessionStorage.removeItem("paymentMethod")   ////here
            sessionStorage.removeItem("paymentfail");
            this.companypaidproductid = [];
            this.disabledcompanypaidproductid = [];
            this.removedisabledcompanypaidproductid = [];
            this.adddisabledcompanypaidproductid = [];






            this.specialpackages = [];
            this.packagesInBlocks = result.data.blocks;
            this.basepackages = result.data.packages;
            let companyplans = this.convertpackagesToPlans2(
              this.packagesInBlocks
            )[1];
            let baseplans = this.convertpackagesToPlans2(this.basepackages)[1];
            this.calculateBasePlanDeltasforCCplans(
              this.packagesInBlocks.coveredByCompany,
              baseplans,
              companyplans
            );
            this.calculateBasePlanCPplans(
              this.packagesInBlocks.paidByCompany,
              baseplans,
              companyplans
            );

            // //console.log(this.packagesInBlocks.paidByCompany)
            // //console.log(this.modifiedBlocksPaidByCompany)
            this.mainarrayValues = this.cobminedcommonfunction(
              // this.packagesInBlocks.paidByCompany,
              this.modifiedBlocksPaidByCompany,
              this.modifiedBlocksCoveredByCompany,
              this.packagesInBlocks.paidByEmployee
            );

            let allPackages = [];
            for (let key in this.mainarrayValues) {
              //this.consoleMessage(key)
              allPackages.push(this.mainarrayValues[key]);
            }
            // this.mainarray = allPackages;





            let filteredMainArray = allPackages
              .map((element: any) => {
                // Map the groups
                let filteredGroups = element.groups.map((group: any) => {
                  // Map the plans
                  let filteredPlans = group.plans.map((plan: any) => {
                    // Filter the productAddonss


                    let filteredProductAddonss = Object.keys(plan.productAddonss).reduce(
                      (acc: any, key) => {

                        let filteredProducts = plan.productAddonss[key].filter((product: any) =>
                          product.hasOwnProperty('display') && product.display
                        );
                        console.log(filteredProducts)
                        const containsOnlyEmptyObjects = filteredProducts.every(
                          (product: any) => Object.keys(product).length === 0
                        );

                        if (containsOnlyEmptyObjects) {
                          console.log("filteredProducts contains only empty objects.");
                        } else {
                          acc[key] = filteredProducts;
                          console.log("filteredProducts contains non-empty objects.");
                        }
                        // if (filteredProducts.length > 0) {
                        //   acc[key] = filteredProducts;
                        // }
                        return acc;
                      },
                      {}
                    );
                    return {
                      ...plan,
                      productAddonss: filteredProductAddonss,
                    };
                  }).filter((plan: any) => Object.keys(plan.productAddonss).length > 0); // Remove plans without any matching productAddons

                  return {
                    ...group,
                    plans: filteredPlans,
                  };
                }).filter((group: any) => group.plans.length > 0); // Remove groups without any matching plans

                return {
                  ...element,
                  groups: filteredGroups,
                };
              })
              .filter((element: any) => element.groups.length > 0); // Remove elements without any matching groups


            console.log(filteredMainArray)

            this.mainarrayFinal = filteredMainArray

            console.log(this.mainarrayFinal)

            // this code needs to comment for single single in
            this.mainarrayFinal.forEach((element: any) => {
              element.groups.forEach((group: any) => {
                group.plans.forEach((plan: any) => {
                  if (plan.productAddonss) {
                    Object.keys(plan.productAddonss).forEach((key) => {
                      // plan.productAddonss[key].forEach((product) => {
                      const keys = ['planCoverage'];
                      const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
                        self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
                      );
                      plan.productAddonss[key] = filteredData
                      // });
                    });
                  }
                });

              });
            });

            this.mainarrayFinal.forEach((element: any) => {
              element.groups.forEach((group: any) => {
                if (group.categorization.paidByCompany == 1) {
                  group.plans.forEach((plan: any) => {
                    let pl = { ...plan, ...group.categorization }
                    Object.keys(plan.productAddonss).forEach((key) => {
                      let productLength = plan.productAddonss[key]?.display
                      let displayingProductlengths = plan.productAddonss[key].filter((e: any) => { return e.dispaly == true })?.length

                      plan.productAddonss[key].forEach((product: any) => {

                        if (pl.isBundle) {
                          this.companypaidproductid.push(pl);
                        }
                        else {
                          this.companypaidproductid.push(product.planlevel);
                        }


                        const dom: HTMLElement = this.elementRef.nativeElement;

                        const plan: any = dom.querySelector("#plancheck" + product.id);

                        if (plan) {
                          plan.checked = false;
                        }
                        // $("#plancheck" + product.id).prop("checked", false);
                      });
                    });
                  });
                }

                setTimeout(() => {
                  if (group.categorization.coveredByCompany == 1) {
                    group.plans.forEach((plan: any) => {
                      Object.keys(plan.productAddonss).forEach((key) => {
                        plan.productAddonss[key].forEach((product: any) => {
                          // $("#plancheck" + product.id).prop("checked", false);
                          const dom: HTMLElement = this.elementRef.nativeElement;

                          const plan: any = dom.querySelector("#plancheck" + product.id);

                          if (plan) {
                            plan.checked = false;
                          }
                        });
                      });
                    });
                  }
                  if (group.categorization.paidByEmployee == 1) {
                    group.plans.forEach((plan: any) => {

                      if (plan.productAddonss) {
                        Object.keys(plan.productAddonss).forEach((key) => {
                          plan.productAddonss[key].forEach((product: any) => {
                            // $("#plancheck" + product.id).prop("checked", false);
                            const dom: HTMLElement = this.elementRef.nativeElement;

                            const plan: any = dom.querySelector("#plancheck" + product.id);

                            if (plan) {
                              plan.checked = false;
                            }
                          });
                        });
                      }
                    });
                  }
                }, 1000);
              });
            });


            sessionStorage.setItem("stateid", result.data.province.id);


            sessionStorage.setItem(
              "planDetailsArray",
              JSON.stringify(this.specialpackages)
            );
            sessionStorage.setItem(
              "planDetailsArrayBlock",
              JSON.stringify(this.mainarrayFinal)
            );
            this.autoSelectCompanyPaidPlans();




            // this.http.post(environment.apiUrl+'/api/ap/v2/global/set-adminCorporates',{wait:true}).subscribe((newResponse) => {
            //   this.http.post(environment.reportApiUrl+'/websocket/corporate/notification-to-others',{
            //     "message": "Corporates information has been updated. Please refresh screen."
            //   }, { headers: {
            //     Authorization: 'Bearer ' + accessToken,
            //     'Content-Type': 'application/json',
            //   } }).subscribe((res)=>{
            //     console.log({res})
            //   })
            // })

          }
          else {
            Swal.fire({ title: "Info", text: result.message });

          }
        })

  }

  public onCheckboxChange(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    options: any,
    pname: any,
    groupname: any,
    plancoverage: any,
    planprice: any,
    gst: any,
    hst: any,
    pst: any,
    event: any,
    event1: any,
    packageindex: any,
    groupindex: any,
    planindex: any,
    plan: any,
    product: any,
    pckage: any,
    group: any
  ) {
    // let multiple = allow_multiple ? Boolean(allow_multiple.data[0]) : false;
    let multiple = allow_multiple == true ? true : false;


    if (e.target.checked) {
      //unselect all checkboxes with same id(fix for single.couple and family multiple seelction)



      const dom: HTMLElement = this.elementRef.nativeElement;

      const samePlanIdElements = dom.querySelectorAll('#' + e.target.id);
      //console.log(samePlanIdElements)
      let targetClassName = 'cp_plan'
      if (e.target.className.includes('cp_plan')) {
        targetClassName = 'cp_plan'
      }
      else if (e.target.className.includes('cc_plan')) {
        targetClassName = 'cc_plan'
      }
      else if (e.target.className.includes('ep_plan')) {
        targetClassName = 'ep_plan'
      }

      for (let i = 0; i < samePlanIdElements.length; i++) {
        let elem = samePlanIdElements[i];
        let element: any = elem;
        //console.log(elem)


        if (element.checked && element.className.includes(targetClassName)) {
          element.checked = false;
          element.disabled = false;  //need to change here for flex bronze disabled
          this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);

        }
      }
      e.target.checked = true

    } else {

    }



    //console.log(disallowedPlanLevels)
    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(",");
      //console.log(disallowed_plans)
      const dom1: HTMLElement = this.elementRef.nativeElement;
      const disallowed_elements = dom1.querySelectorAll(
        ".plansscreen input[type='checkbox']"
      );

      // disallowed_elements.forEach((elem: any) => {

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        // elementcv.checked=false

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split("##");

        //this.consoleMessage("main", plandetailsobj);
        let isBundle = plandetailsobj[21] == "true" ? true : false
        if (e.target.checked) {
          if (!elem.disabled) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = true;
                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            } else {

              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                  elem.disabled = true;

                  this.disabledelement =
                    'Already included in GroupBenefitz All-In';
                }
              }

            }
          }
          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }
        else {
          if (elem.disabled) {
            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              } else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  //  elem.checked=false
                  elem.disabled = false;
                }
              }
            }
            if (isBundle) {
              if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            } else {
              if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {

                elem.disabled = false;

                this.disabledelement =
                  'Already included in GroupBenefitz All-In';
              }
            }

            // else {
            //   if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
            //     //  elem.checked=false
            //     elem.disabled = false;
            //   }
            // }
          }


          if (elem.checked) {

            if (plandetailsobj[12] == null || plandetailsobj[12] == '') {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[13]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }

              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                }
              }
            } else {
              if (isBundle) {
                if (disallowed_plans.indexOf(plandetailsobj[12]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }
              else {
                if (disallowed_plans.indexOf(plandetailsobj[20]) >= 0) {
                  elem.checked = false;
                  this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
                  // elem.disabled =true
                }
              }

            }
          }
        }


      }
    }





    //////this.consoleMessage(e)
    // //console.log(`newPlan${plan.id}`)

    let sameplanclassname = `newPlan${plan.id}`
    // //console.log(e.target.className)/////this.consoleMessage(e)
    let classname = e.target.className.replace(sameplanclassname, '');
    // //console.log(classname)
    classname = e.target.className.split(' ').join('.');
    // classname = classname.split(' ').join('.');

    // if (classname[0] != '.') {
    //   classname = `.${classname}`

    // }

    // if (classname[classname.length - 1] == '.') {
    //   classname = classname.substring(0, classname.length - 1);
    // }

    //console.log(classname)
    //console.log(sameplanclassname)
    // //////this.consoleMessage(classname)
    const dom: HTMLElement = this.elementRef.nativeElement;
    // const elements = dom.querySelectorAll('.' + classname);
    const elements = dom.querySelectorAll(classname);

    const samePlanElements = dom.querySelectorAll('.' + sameplanclassname);
    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;

          if (element.checked) {
            this.unselectplan1(elem, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {

      }
    } else {

      //console.log("elesehere")
      if (e.target.checked) {


        // for (let i = 0; i < samePlanElements.length; i++) {
        //   let elem = samePlanElements[i];
        //   element = elem;

        //   if (element.checked) {

        //     this.unselectplan(elem, options, plan, product, pckage, group,planindex);
        //     element.checked = false;
        //   }
        // }

        // e.checked = true;
        // e.target.checked = true;
      } else {
      }
      // alert("!")
      //no checking for other checkboxes you can selet multiple
    }
    setTimeout(() => {
      if (e.target.checked) {

        console.log(group)
        console.log(pckage)

        let removedisabledcompanypaidproductid: any = []
        let removedisabledcoveredpaidproductid: any = []
        let removedisabledemployedpaidproductid: any = []
        if (
          group.categorization.coveredByCompany == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {

          pckage.groups.forEach((element: any) => {
            if (pckage.id != 5) {
              if (element.categorization.paidByCompany == 1 || element.categorization.paidByEmployee == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledcompanypaidproductid.push(
                          pl
                        );
                      }
                      else {
                        removedisabledcompanypaidproductid.push(
                          // id: product.id,

                          product.planLevel,

                        );
                      }

                    });
                  });
                });
              }
            }
            else {
              if (group?.parentId == element?.parentId) {
                if (element.categorization.paidByCompany == 1 || element.categorization.paidByEmployee == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledcompanypaidproductid.push(
                            pl
                          );
                        }
                        else {
                          removedisabledcompanypaidproductid.push(
                            // id: product.id,

                            product.planLevel,

                          );
                        }

                      });
                    });
                  });
                }
              }
            }

          });
        } else {
        }

        if (
          group.categorization.paidByCompany == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {

          pckage.groups.forEach((element: any) => {
            if (pckage.id != 5) {
              if (element.categorization.coveredByCompany == 1 || element.categorization.paidByEmployee == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledcoveredpaidproductid.push(
                          pl,
                        );
                      }
                      else {
                        removedisabledcoveredpaidproductid.push(
                          // id: product.id,
                          product.planLevel,
                        );
                      }

                    });
                  });
                });
              }
            }
            else {
              if (group?.parentId == element?.parentId) {
                if (element.categorization.coveredByCompany == 1 || element.categorization.paidByEmployee == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledcoveredpaidproductid.push(
                            pl,
                          );
                        }
                        else {
                          removedisabledcoveredpaidproductid.push(
                            // id: product.id,
                            product.planLevel,
                          );
                        }

                      });
                    });
                  });
                }
              }
            }
          });
        } else {
        }

        if (
          group.categorization.paidByEmployee == 1
          // ||
          // group.categorization.paidByEmployee == 1
        ) {



          pckage.groups.forEach((element: any) => {
            //console.log(element)
            if (pckage.id != 5) {

              if (element.categorization.paidByCompany == 1 || element.categorization.coveredByCompany == 1) {
                element.plans.forEach((plan: any) => {
                  let pl = plan
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      if (pl.isBundle) {
                        removedisabledemployedpaidproductid.push(
                          pl,
                        );
                      }
                      else {
                        removedisabledemployedpaidproductid.push(
                          product.planLevel,
                        );
                      }

                    });
                  });
                });
              }
            }
            else {


              if (group?.parentId == element?.parentId) {
                if (element.categorization.paidByCompany == 1 || element.categorization.coveredByCompany == 1) {
                  element.plans.forEach((plan: any) => {
                    let pl = plan
                    Object.keys(plan.productAddonss).forEach((key) => {
                      plan.productAddonss[key].forEach((product: any) => {
                        if (pl.isBundle) {
                          removedisabledemployedpaidproductid.push(
                            pl,
                          );
                        }
                        else {
                          removedisabledemployedpaidproductid.push(
                            product.planLevel,
                          );
                        }

                      });
                    });
                  });
                }
              }
            }
          });
        } else {
        }

        console.log(removedisabledcompanypaidproductid)
        console.log(removedisabledcoveredpaidproductid)
        console.log(removedisabledemployedpaidproductid)

        removedisabledcompanypaidproductid = removedisabledcompanypaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledcoveredpaidproductid = removedisabledcoveredpaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledemployedpaidproductid = removedisabledemployedpaidproductid.filter(
          (item: any) => item !== undefined && item !== null
        );
        removedisabledcompanypaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;


            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)
                  //  plan.disabled = false;
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            }
            else {
              plan = dom.querySelectorAll("#plancheck" + element.id);
              plan.disabled = false;
              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }





            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {

              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + element.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + element.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + element.id);
                    /* //console.log(plan) */

                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);


              if (elem.isBundle) {
                // if (elem.id == element.id) {
                //   selectplans.splice(index, 1)
                // }

                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)
                    }
                  })
                })
              } else {


                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)
                }
                // if(elem.id==elem.products[0].id){
                //   selectplans.splice(index,1)
                // }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();

          }, 1000);
        });
        removedisabledcoveredpaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;



            let plan: any = ''


            //console.log(element)
            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)


                  //console.log(plan)
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            } else {
              plan = dom.querySelectorAll("#plancheck" + element.id);

              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }


            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {
              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + element.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + element.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + element.id);
                    // //console.log(plan)


                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);
              if (elem.isBundle) {


                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)
                    }
                  })
                })
              } else {
                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)
                }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();
          }, 100);
        });
        removedisabledemployedpaidproductid.forEach((element: any, index: any) => {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelectorAll("#plancheck" + element.id);
            // //console.log(plan)
            // //Rakesh changes here company to upgrade
            // plan.disabled = false;
            // plan.forEach((element: any) => {
            //   //console.log(element)
            //   element.checked = false
            // });


            let plan: any = ''


            //console.log(element)
            if (element.isBundle) {

              Object.keys(element.productAddonss).forEach((key) => {
                element.productAddonss[key].forEach((product: any) => {
                  //console.log(product)
                  plan = dom.querySelectorAll("#plancheck" + product.planId + ".coverage" + product.planCoverage)


                  //console.log(plan)
                  plan.forEach((element: any) => {
                    //console.log(element)
                    element.disabled = false;
                    element.checked = false
                  });
                })
              })


            } else {
              plan = dom.querySelectorAll("#plancheck" + element.id);

              plan.forEach((element: any) => {
                //console.log(element)
                element.disabled = false;
                element.checked = false
              });
            }


            //remove this plan from sum
            // plan.click()

            let selectplans =
              JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

            selectplans.forEach((elem: any, index: any) => {
              setTimeout(() => {


                if (elem.id == element.id) {

                } else {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + element.id);
                    const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + element.id);
                    const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + element.id);
                    // //console.log(plan)


                    plan.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });

                    plan2.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });
                    plan3.forEach((elem: any) => {
                      (elem as HTMLElement).style.display = 'block';
                    });



                  }, 1000);
                }



              }, 1000);
              if (elem.isBundle) {


                Object.keys(element.productAddonss).forEach((key) => {
                  element.productAddonss[key].forEach((product: any) => {
                    if (elem.id == element.id && elem.coverage == product.planCoverage) {
                      selectplans.splice(index, 1)

                    }
                  })
                })
              } else {
                if (elem.id == elem.products[0].planLevel) {
                  selectplans.splice(index, 1)

                }
              }


            })

            sessionStorage.setItem(
              "plansummarymain",
              JSON.stringify(selectplans)
            );


            sessionStorage.setItem("plansummary", JSON.stringify(selectplans));

            this.planCoverafeFunction();
          }, 100);
        });


        this.selectplan1(e.target, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
      } else {


        this.unselectplan1(e.target, options, plan, product, pckage, group, planindex, disallowedPlanLevels);
      }
    }, 10);
  }


  public allowmultipleplans() { }

  public disallowedPlans() { }
  public selectplan1(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    planProductIndex: any,
    disallowedPlanLevels: any
  ) {
    // ////this.consoleMessage(elementcv)
    //this.consoleMessage(plan);
    //this.consoleMessage(product)
    //this.consoleMessage(pckage)
    //this.consoleMessage(group)

    // alert("1")
    this.planobjdata = {};
    this.planobjdataobj = {}

    console.log(disallowedPlanLevels)

    let details: any = elementcv.attributes.data.value;

    let detailsObj: any = details.split("##");


    let categorization = {}

    if (group.categorization.paidByCompany == 1) {

      categorization = {
        paidByCompany: detailsObj[22] == "true" ? 0 : 1,
        coveredByCompany: detailsObj[22] == "true" ? 1 : 0,
        paidByEmployee: group.categorization.paidByEmployee,
      }
    } else {
      categorization = {
        paidByCompany: group.categorization.paidByCompany,
        coveredByCompany: group.categorization.coveredByCompany,
        paidByEmployee: group.categorization.paidByEmployee,
      }
    }

    //console.log(categorization)

    // paidByCompany: group.categorization.paidByCompany,
    // coveredByCompany: group.categorization.coveredByCompany,
    // paidByEmployee: group.categorization.paidByEmployee,

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    if (options && options.length > 0) {
      sessionStorage.setItem('options', JSON.stringify(options));
    }
    // if (options && options.length > 0) {
    //   let obj = {
    //     isBundle: plan.isBundle,
    //     disallowedPlanLevels: disallowedPlanLevels,
    //     enrollmentDate: this.userForm.value.planEnrollmentDate
    //       ? this._CustomDatePipe.transform(this.userForm.value.planEnrollmentDate)
    //       : undefined,
    //     // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
    //     name: plandetailsobj[14],
    //     details: plandetailsobj[0],
    //     packagename: plandetailsobj[0],
    //     groupName: plandetailsobj[1],
    //     // amount: parseFloat(plandetailsobj[3]),
    //     amount: parseFloat(product.calculatedTax.price),
    //     planCoverage: plandetailsobj[2],
    //     // planPrice: parseFloat(plandetailsobj[3]),
    //     planPrice: parseFloat(product.calculatedTax.price),
    //     // amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
    //     amountUI: "$" + parseFloat(product.calculatedTax.price),
    //     gst:
    //       plandetailsobj[4] == null ||
    //         plandetailsobj[4] == "" ||
    //         plandetailsobj[4] == undefined ||
    //         plandetailsobj[4] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[4]),
    //     hst:
    //       plandetailsobj[5] == null ||
    //         plandetailsobj[5] == "" ||
    //         plandetailsobj[5] == undefined ||
    //         plandetailsobj[5] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[5]),
    //     pst:
    //       plandetailsobj[6] == null ||
    //         plandetailsobj[6] == "" ||
    //         plandetailsobj[6] == undefined ||
    //         plandetailsobj[6] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[6]),
    //     qst:
    //       plandetailsobj[17] == null ||
    //         plandetailsobj[17] == "" ||
    //         plandetailsobj[17] == undefined ||
    //         plandetailsobj[17] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[17]),
    //     gstCheck:
    //       plandetailsobj[4] == null ||
    //         plandetailsobj[4] == "" ||
    //         plandetailsobj[4] == undefined ||
    //         plandetailsobj[4] == "null"
    //         ? false
    //         : true,
    //     hstCheck:
    //       plandetailsobj[5] == null ||
    //         plandetailsobj[5] == "" ||
    //         plandetailsobj[5] == undefined ||
    //         plandetailsobj[5] == "null"
    //         ? false
    //         : true,
    //     pstCheck:
    //       plandetailsobj[6] == null ||
    //         plandetailsobj[6] == "" ||
    //         plandetailsobj[6] == undefined ||
    //         plandetailsobj[6] == "null"
    //         ? false
    //         : true,
    //     qstCheck:
    //       plandetailsobj[17] == null ||
    //         plandetailsobj[17] == "" ||
    //         plandetailsobj[17] == undefined ||
    //         plandetailsobj[17] == "null"
    //         ? false
    //         : true,
    //     id: parseFloat(plandetailsobj[7]),
    //     fusebillPlanID:
    //       plandetailsobj[8] == null ||
    //         plandetailsobj[8] == "" ||
    //         plandetailsobj[8] == undefined ||
    //         plandetailsobj[8] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[8]),
    //     planFrequencyID:
    //       plandetailsobj[9] == null ||
    //         plandetailsobj[9] == "" ||
    //         plandetailsobj[9] == undefined ||
    //         plandetailsobj[9] == "null"
    //         ? 0
    //         : parseFloat(plandetailsobj[9]),
    //     optIn: plandetailsobj[10] == "true" ? true : false,
    //     planname: plandetailsobj[14],
    //     planLevel: parseInt(plandetailsobj[15]),
    //     packageId: parseInt(plandetailsobj[16]),
    //     options: [],
    //     paidByCompany1: plandetailsobj[19],
    //     coveredByCompany1: plandetailsobj[20],
    //     paidByEmployee1: plandetailsobj[21],
    //     planLevel_parentId: plandetailsobj[12],
    //     // disallowedPlanLevels: plandetailsobj[11],
    //     version: plan.version,
    //     description: plan.description,
    //     insuranceType: plan.insuranceType,
    //   };
    //   if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
    //     if (plandetailsobj[11].includes(plandetailsobj[12])) {
    //     }
    //   }
    //   let coverage = product.planCoverage;

    //   coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage)
    //     ? coverage
    //     : null;
    //   ////this.consoleMessage(obj)
    //   this.productobj = {
    //     id: product.id,
    //     productId: product.productId,
    //     name: product.name,

    //     planProductId: product.planProductId,
    //     price: adjustWith2DecimalsForUI(product.price1 || product.price),
    //     tax: adjustWith2DecimalsForUI(
    //       product.calculatedTax ? product.calculatedTax.tax : 0
    //     ),
    //     total: adjustWith2DecimalsForUI(
    //       product.calculatedTax ? product.calculatedTax.total : 0
    //     ),
    //     //  price: parseFloat(this._decimalPipe.transform(product.price1 || product.price, "1.2-2")) ,
    //     //  tax: parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")),
    //     //  total:parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")),
    //     tax_details:
    //       product.bundledTaxes && product.bundledTaxes.length > 0
    //         ? product.bundledTaxes
    //         : product.taxesDataJSON,
    //     calculatedTax: product.calculatedTax,
    //     bundledProducts: product.bundledProducts,
    //     planCoverage: product.planCoverage,
    //     planLevel: product.planlevel
    //       ? product.planlevel.id
    //       : plan.planLevel
    //         ? plan.planLevel
    //         : group.id,
    //     planLevelParent: product.planlevel
    //       ? product.planlevel.parentId
    //       : group.parentId,
    //     description: product.description,
    //     coverage: coverage,
    //     version: product.version
    //   };
    //   let obj1: any = {
    //     packageId: plan.packageId,
    //     packageName: pckage.name,

    //     planproductname: this.productobj.name,

    //     groupid: plan.planLevel,
    //     groupName: group.name,
    //     id: plan.id,
    //     name: plan.name,
    //     planLevel: plan.planLevel ? plan.planLevel : group.id,
    //     planLevelParent: group.parentId,
    //     fusebillPlanID: plan.fusebillId,
    //     planFrequencyID: plan.frqMonthly,
    //     isBundle: plan.isBundle,
    //     disallowedPlanLevels: disallowedPlanLevels,
    //     coverage: coverage,
    //     planCoverage: product.planCoverage,
    //     bundledProducts: [],
    //     products: [],
    //     upgradeCalculation: plan.products && plan.products[planProductIndex] ? plan.products[planProductIndex].upgradeCalculation : plan.upgradeCalculation,

    //   };
    //   obj1.products.push(this.productobj);
    //   let finalobj1: any = { ...obj1, ...categorization };



    //   //this.consoleMessage(obj1);


    //   this.planobjdata = finalobj1;
    //   this.planobjdataobj = obj
    //   this.elementcvValues = elementcv

    //   console.log(this.planobjdata)

    //   // this.addtoplansummary(obj, obj1, elementcv);
    //   this.addtoplansummary(obj, finalobj1, elementcv);
    //   setTimeout(() => {


    //     // this.openplanoptions(elementcv, options, plan, product)

    //     this.openplanoptions(elementcv)
    //   }, 1000);
    // }
    // else {
    let obj = {
      isBundle: plan.isBundle,
      disallowedPlanLevels: disallowedPlanLevels,
      enrollmentDate: this._CustomDatePipe.transform(this.effectiveDateForm.get('effectiveDate').value),
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      // amount: parseFloat(plandetailsobj[3]),
      amount: parseFloat(product.calculatedTax.price),
      planCoverage: plandetailsobj[2],
      // planPrice: parseFloat(plandetailsobj[3]),
      planPrice: parseFloat(product.calculatedTax.price),
      // amountUI: "$" + this._decimalPipe.transform(plandetailsobj[3], "1.2-2"),
      amountUI: "$" + parseFloat(product.calculatedTax.price),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      paidByCompany1: plandetailsobj[19],
      coveredByCompany1: plandetailsobj[20],
      paidByEmployee1: plandetailsobj[21],
      planLevel_parentId: plandetailsobj[12],
      // disallowedPlanLevels: plandetailsobj[11],
      version: plan.version,
      description: plan.description,
      insuranceType: plan.insuranceType,
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    let coverage = product.planCoverage;

    coverage = ["SINGLE", "COUPLE", "FAMILY"].includes(coverage)
      ? coverage
      : null;
    ////this.consoleMessage(obj)
    this.productobj = {
      id: product.id,
      productId: product.productId,
      name: product.name,

      planProductId: product.planProductId,
      //  price: product.price1 || product.price,
      //  tax: product.calculatedTax ? product.calculatedTax.tax : 0,
      //  total: product.calculatedTax ? product.calculatedTax.total : 0,

      price: adjustWith2DecimalsForUI(product.price1 || product.price),
      tax: adjustWith2DecimalsForUI(
        product.calculatedTax ? product.calculatedTax.tax : 0
      ),
      total: adjustWith2DecimalsForUI(
        product.calculatedTax ? product.calculatedTax.total : 0
      ),
      //  price: parseFloat(this._decimalPipe.transform(product.price1 || product.price, "1.2-2")) ,
      //  tax: parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.tax : 0, "1.2-2")),
      //  total:parseFloat(this._decimalPipe.transform(product.calculatedTax ? product.calculatedTax.total : 0, "1.2-2")),

      tax_details:
        product.bundledTaxes && product.bundledTaxes.length > 0
          ? product.bundledTaxes
          : product.taxesDataJSON,
      calculatedTax: product.calculatedTax,
      bundledProducts: product.bundledProducts,
      planCoverage: product.planCoverage,
      planLevel: product.planlevel
        ? product.planlevel.id
        : plan.planLevel
          ? plan.planLevel
          : group.id,
      planLevelParent: product.planlevel
        ? product.planlevel.parentId
        : group.parentId,
      description: product.description,
      coverage: coverage,
      version: product.version
    };
    let obj1: any = {
      packageId: plan.packageId,
      packageName: pckage.name,

      planproductname: this.productobj.name,

      groupid: plan.planLevel,
      groupName: group.name,
      id: plan.id,
      name: plan.name,
      planLevel: plan.planLevel ? plan.planLevel : group.id,
      planLevelParent: group.parentId,
      fusebillPlanID: plan.fusebillId,
      planFrequencyID: plan.frqMonthly,
      isBundle: plan.isBundle,
      coverage: coverage,
      planCoverage: product.planCoverage,
      bundledProducts: [],
      products: [],
      upgradeCalculation: plan.products && plan.products[planProductIndex] ? plan.products[planProductIndex].upgradeCalculation : plan.upgradeCalculation,

    };

    obj1.products.push(this.productobj);
    let finalobj1: any = { ...obj1, ...categorization };

    //console.log(finalobj1)


    this.addtoplansummary(obj, finalobj1, elementcv);
    setTimeout(() => {

      this.openplanoptions(elementcv)
    }, 1000);
    // }
  }

  public unselectplan1(
    elementcv: any,
    options: any,
    plan: any,
    product: any,
    pckage: any,
    group: any,
    planProductIndex: any,
    disallowedPlanLevels: any
  ) {

    //console.log(plan)

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");
    let obj = {
      isBundle: plan.isBundle,
      enrollmentDate: this._CustomDatePipe.transform(this.effectiveDateForm.get('effectiveDate').value),
      // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
      name: plandetailsobj[14],
      details: plandetailsobj[0],
      packagename: plandetailsobj[0],
      groupName: plandetailsobj[1],
      amount: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      planCoverage: plandetailsobj[2],
      planPrice: parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      amountUI: "$" + parseFloat(plandetailsobj[3].replace(/\,/g, "")),
      gst:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? 0
          : parseFloat(plandetailsobj[4]),
      hst:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? 0
          : parseFloat(plandetailsobj[5]),
      pst:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? 0
          : parseFloat(plandetailsobj[6]),
      qst:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? 0
          : parseFloat(plandetailsobj[17]),
      gstCheck:
        plandetailsobj[4] == null ||
          plandetailsobj[4] == "" ||
          plandetailsobj[4] == undefined ||
          plandetailsobj[4] == "null"
          ? false
          : true,
      hstCheck:
        plandetailsobj[5] == null ||
          plandetailsobj[5] == "" ||
          plandetailsobj[5] == undefined ||
          plandetailsobj[5] == "null"
          ? false
          : true,
      pstCheck:
        plandetailsobj[6] == null ||
          plandetailsobj[6] == "" ||
          plandetailsobj[6] == undefined ||
          plandetailsobj[6] == "null"
          ? false
          : true,
      qstCheck:
        plandetailsobj[17] == null ||
          plandetailsobj[17] == "" ||
          plandetailsobj[17] == undefined ||
          plandetailsobj[17] == "null"
          ? false
          : true,
      id: parseFloat(plandetailsobj[7]),
      fusebillPlanID:
        plandetailsobj[8] == null ||
          plandetailsobj[8] == "" ||
          plandetailsobj[8] == undefined ||
          plandetailsobj[8] == "null"
          ? 0
          : parseFloat(plandetailsobj[8]),
      planFrequencyID:
        plandetailsobj[9] == null ||
          plandetailsobj[9] == "" ||
          plandetailsobj[9] == undefined ||
          plandetailsobj[9] == "null"
          ? 0
          : parseFloat(plandetailsobj[9]),
      optIn: plandetailsobj[10] == "true" ? true : false,
      planname: plandetailsobj[14],
      planLevel: parseInt(plandetailsobj[15]),
      packageId: parseInt(plandetailsobj[16]),
      options: [],
      paidByCompany1: plandetailsobj[19],
      coveredByCompany1: plandetailsobj[20],
      paidByEmployee1: plandetailsobj[21],
      planLevel_parentId: plandetailsobj[12],
      disallowedPlanLevels: plandetailsobj[11],
    };
    if (plandetailsobj[11] != null || plandetailsobj[11] != "null") {
      if (plandetailsobj[11].includes(plandetailsobj[12])) {
      }
    }

    this.removeplansummary(obj, group, pckage, elementcv);
    setTimeout(() => {


      this.openplanoptions(elementcv)


    }, 1000);
  }

  public openplanoptions(elementcv: any) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split("##");

    let modifiedOptions: any = [];
    let optionumber: any = [];
    // let optionumber = $("#optionumber").val();  //rakesh
    // jQuery("#showplanoptions-modal").modal("hide");

    let planSummary = JSON.parse(sessionStorage.getItem('plansummary') || '[]');
    let optionsValue = JSON.parse(sessionStorage.getItem('options') || '[]');

    for (let i = 0; i < planSummary.length; i++) {

      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });
        optionsValue = filteredData


      }
      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });
        optionsValue = filteredData

      }
      if (planSummary[i].planproductname && planSummary[i].planproductname.includes("La Vie") && planSummary[i].planproductname.includes("Medcan")) {
        // Your code here

        const filteredData = optionsValue.map((item: any) => {
          return {
            ...item, // Preserve the rest of the object
            planOptionsValues: item.planOptionsValues.filter((option: any) =>
              option.name.includes("La Vie") || option.name.includes("Medcan") ||
              option.name.includes("Yes") ||
              option.name.includes("No")
            )
          };
        });

        optionsValue = filteredData


      }
    }

    // this.plandetailsobjvalue = plandetailsobj;

    this.plandetailsobjvalue = plandetails;

    optionsValue.forEach((element: any) => {
      element.planOptionsValues.forEach((options: any) => {
        options.planOptionName = element.name;
        options.json = JSON.stringify(options);
      });

      modifiedOptions.push(element);
    });

    this.optionstitle = modifiedOptions;
    //this.consoleMessage("isexeccp:" + plandetailsobj[19]);
    this.isExecutiveCP = plandetailsobj[19]
      ? parseInt(plandetailsobj[19]) == 1
        ? true
        : false
      : false;
    this.planOptionsModel = true
    // alert("startrhetre")
    // jQuery("#showplanoptions-modal").modal("show");
  }
  public addtoplansummary(obj: any, obj1: any, e: any) {
    let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || "[]");

    // console.log(obj)
    // console.log(obj1)

    /* This code mainly for flex plan silver and gold */


    for (let i = 0; i < planSummary.length; i++) {
      if (obj1.planLevelParent) {
        if (planSummary[i].planLevelParent == obj1.planLevelParent && planSummary[i].coveredByCompany == obj1.coveredByCompany) {

          const dom: HTMLElement = this.elementRef.nativeElement;

          const plan: any = dom.querySelector("#plancheck" + planSummary[i].id + ".coverage" + planSummary[i].coverage);
          //console.log(plan)
          if (plan.checked) {
            plan.checked = false
          }
          planSummary.splice(i, 1)
        }
      }
    }



    //this.consoleMessage("obj1", obj1);
    //console.log("obj", obj);
    setTimeout(() => {
      const dom: HTMLElement = this.elementRef.nativeElement;
      const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
      const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
      const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
      // //console.log(plan)

      if (obj.coverage === "SINGLE") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
      } else if (obj.coverage === "COUPLE") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
      } else if (obj.coverage === "FAMILY") {
        if (plan) {
          plan.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan2) {
          plan2.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'none';
          });
        }
        if (plan3) {
          plan3.forEach((elem: any) => {
            (elem as HTMLElement).style.display = 'block';
          });
        }
      } else {
        // Default case - hide all plans if coverage doesn't match expected
      }



    }, 2000);

    this.addtoslectplans(obj.id, planSummary.length);
    planSummary.push(obj);

    let gstprice = 0;
    let hstprice = 0;
    let pstprice = 0;
    let qstprice = 0;

    if (obj.options && obj.options.length > 0) {
      obj["disallowedPlanLevels"] = obj1.disallowedPlanLevels

    }

    if (obj.gst > 0) {
      gstprice = obj.planPrice * obj.gst;

      obj['gstPrice'] = gstprice
        ? this._decimalPipe.transform(gstprice, '1.2-2')
        : 0;
      obj['gstPrice'] = parseFloat(obj['gstPrice']);
    } else {
      obj["gstPrice"] = 0;
    }

    if (obj.hst > 0) {
      hstprice = obj.planPrice * obj.hst;

      obj['hstPrice'] = hstprice
        ? this._decimalPipe.transform(hstprice, '1.2-2')
        : 0;
      obj['hstPrice'] = parseFloat(obj['hstPrice']);
    } else {
      obj["hstPrice"] = 0;
    }

    if (obj.pst > 0) {
      pstprice = obj.planPrice * obj.pst;


      obj['pstPrice'] = pstprice
        ? this._decimalPipe.transform(pstprice, '1.2-2')
        : 0;
      obj['pstPrice'] = parseFloat(obj['pstPrice']);
    } else {
      obj["pstPrice"] = 0;
    }

    if (obj.qst > 0) {
      qstprice = obj.planPrice * obj.qst;

      obj['qstPrice'] = qstprice
        ? this._decimalPipe.transform(qstprice, '1.2-2')
        : 0;
      obj['qstPrice'] = parseFloat(obj['qstPrice']);
    } else {
      obj["qstPrice"] = 0;
    }

    obj["taxUI"] = "";
    if (obj["gstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["gstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
          "&nbsp;(GST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["pstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["pstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
          "&nbsp;(PST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["qstCheck"]) {
      obj["taxUI"] += "<span>";
      if (obj["qstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
          "&nbsp;(QST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (obj["hstCheck"]) {
      obj["taxUI"] += "<span> ";
      if (obj["hstPrice"] == 0) {
        obj["taxUI"] += "-";
      } else {
        obj["taxUI"] +=
          "$" +
          this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
          "&nbsp;(HST)";
      }
      obj["taxUI"] += "</span>";
    }

    if (
      !obj["hstCheck"] &&
      !obj["gstCheck"] &&
      !obj["pstCheck"] &&
      !obj["qstCheck"]
    ) {
      obj["taxUI"] += "<span>-";

      obj["taxUI"] += "</span>";
    }

    // ////this.consoleMessage(object["taxUI"])

    // obj["tax"] = parseFloat(
    //   this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, "1.2-2")
    // );
    // obj["tax"] = parseFloat(
    //   this._decimalPipe.transform(obj1.products[0].calculatedTax.tax, "1.2-2")
    // );
    obj['tax'] = obj1.products[0]
      ? this._decimalPipe.transform(obj1.products[0].calculatedTax.tax, "1.2-2") : 0;
    obj['tax'] = parseFloat(obj['tax']);
    // obj["products"] =obj1

    obj["coverage"] = obj1.coverage;
    obj["planCoverage"] = obj1.planCoverage;
    obj["planLevelParent"] = obj1.planLevelParent;
    obj["planproductname"] = obj1.planproductname;

    obj["products"] = obj1.products;
    obj["upgradeCalculation"] = obj1.upgradeCalculation;
    obj["paidByCompany"] = obj1.paidByCompany;
    obj["coveredByCompany"] = obj1.coveredByCompany;
    obj["paidByEmployee"] = obj1.paidByEmployee;



    let pricecal = obj1.products[0].calculatedTax.total;
    obj["totalPrice"] = pricecal;

    obj["totalUI"] = "$" + pricecal;

    (obj["total"] = pricecal),
      (obj["skuTotalPrice"] = parseFloat(
        obj1.products.reduce((acc: any, calculatedTax: any) => {
          return acc + calculatedTax.total;
        }, 0)
      ));

    let updatedSum = this.addtosum(obj.skuTotalPrice);
    this.planssummarymain = [];
    this.planssummaryopt = [];

    planSummary.forEach((element: any) => {
      if (element.packagename != "Opt-in") {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    this.plansskumain.push(obj1);

    sessionStorage.setItem("plansskumain", JSON.stringify(this.plansskumain));

    sessionStorage.setItem(
      "plansummarymain",
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      "plansummaryopt",
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem("plansummary", JSON.stringify(planSummary));

    // setTimeout(() => {
    this.planCoverafeFunction();

    // }, 3000);



    setTimeout(() => {
      this.planssummarymainLife = JSON.parse(
        sessionStorage.getItem('planssummarymainLife') || '[]'
      );

      this.planssummarymain = JSON.parse(
        sessionStorage.getItem('plansummarymain') || '[]'
      );
      var total = 0;
      for (let i = 0; i < this.planssummarymainLife.length; i++) {
        total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
      }
      // for (let i = 0; i < this.planssummarymain.length; i++) {
      //   if (obj.planproductname.includes("La Vie")) {

      //     if (this.planssummarymain[i].planLevel == 18) {

      //       if (this.planssummarymain[i].coverage == obj.coverage) {

      //       } else {
      //         const dom: HTMLElement = this.elementRef.nativeElement;
      //         // const plan: any = dom.querySelector(`#plancheck792`)
      //         const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
      //         setTimeout(() => {
      //           plan.click()
      //           this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan.", "");
      //         }, 1000);
      //       }
      //       break;
      //     }
      //     else {

      //       const dom: HTMLElement = this.elementRef.nativeElement;
      //       // const plan: any = dom.querySelector(`#plancheck792`)
      //       const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

      //       console.log(plan)
      //       setTimeout(() => {
      //         plan.click()
      //         this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan.", "");
      //       }, 1000);
      //     }
      //   }
      // }
      this.companypaidproductid = this.companypaidproductid.filter(
        (item: any) => item !== undefined && item !== null
      );

      var result = this.companypaidproductid.reduce((unique: any, o: any) => {
        if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
          unique.push(o);
        }
        return unique;
      }, []);
      console.log(result);
      const filteredPlans = result.filter((result: any) => result.planLevel === 18);

      console.log(filteredPlans);


      if (filteredPlans.length > 0) {
        for (let i = 0; i < this.planssummarymain.length; i++) {
          if (obj.planproductname.includes("La Vie")) {

            if (this.planssummarymain[i].coverage == obj.coverage) {

            } else {
              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
              setTimeout(() => {
                plan.click()
                this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
              }, 1000);
            }



          }
        }
      } else {
        for (let i = 0; i < this.planssummarymain.length; i++) {
          if (obj.planproductname.includes("La Vie")) {

            if (this.planssummarymain[i].planLevel == 18) {

              if (this.planssummarymain[i].coverage == obj.coverage) {

              } else {
                const dom: HTMLElement = this.elementRef.nativeElement;
                // const plan: any = dom.querySelector(`#plancheck792`)
                const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);
                setTimeout(() => {
                  plan.click()
                  this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
                }, 1000);
              }
              break;
            }
            else {

              const dom: HTMLElement = this.elementRef.nativeElement;
              // const plan: any = dom.querySelector(`#plancheck792`)
              const plan: any = dom.querySelector("#plancheck792" + ".coverage" + obj.coverage);

              console.log(plan)
              setTimeout(() => {
                plan.click()
                this.toastrService.success("La Vie plan selection automatically includes Complete Executive Care plan", "");
              }, 1000);
              break;
            }
          }
        }
      }
      for (let i = 0; i < this.planssummarymain.length; i++) {

        total += parseFloat(this.planssummarymain[i].skuTotalPrice);
      }

    }, 100);

    setTimeout(() => {
      let selectplans =
        JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";



      selectplans.forEach((element: any) => {
        if (element.paidByCompany == 1) {
          const dom: HTMLElement = this.elementRef.nativeElement;
          const plan: any = dom.querySelector("#plancheck" + element.id);

          const samePlanIdElements = dom.querySelectorAll('#' + e.id);
          //console.log(samePlanIdElements)
          let targetClassName = 'cp_plan'
          if (e.className.includes('cp_plan')) {
            targetClassName = 'cp_plan'
          }
          else if (e.className.includes('cc_plan')) {
            targetClassName = 'cc_plan'
          }
          else if (e.className.includes('ep_plan')) {
            targetClassName = 'ep_plan'
          }

          for (let i = 0; i < samePlanIdElements.length; i++) {
            let elem = samePlanIdElements[i];
            let element: any = elem;
            // //console.log(elem)
            // //console.log(elem.className.includes('cp_plan'))
            if (elem.className.includes('cp_plan')) {
              element.disabled = false;
              if (element.checked) {
                element.disabled = true;

              }
            }
          }
          if (plan) {
            // plan.disabled = true;
            // if(plan.isBundle){
            //   plan.disabled = false;
            // }else{
            //   plan.disabled = false;
            // }

          }
        }
      });
    }, 1000);
  }

  public getindexofplan(obj: any) {

    //console.log(obj)
    let plansproductarray = JSON.parse(sessionStorage.getItem("plansummary") || '[]');

    for (let i = 0; i < plansproductarray.length; i++) {
      if (obj.isBundle == false) {
        if (plansproductarray[i].id == obj.id) {

          if (plansproductarray[i].paidByCompany == 1) {
            plansproductarray[i].products.forEach((product: any, index: any) => {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck" + product.id);

              if (plan) {
                // plan.disabled = false;
              }
            })

          }
          return i;
        }
      } else {
        if (plansproductarray[i].id == obj.id) {
          if (plansproductarray[i].paidByCompany == 1) {
            plansproductarray[i].products.forEach((product: any, index: any) => {
              const dom: HTMLElement = this.elementRef.nativeElement;
              const plan: any = dom.querySelector("#plancheck" + product.id);

              if (plan) {
                plan.disabled = false;
              }
            })

          }
          return i;
        }
      }
    }
  }

  toggleItem1(item: any): void {
    item.expanded = !item.expanded;
  }
  toggleItem2(item: any): void {
    item.expanded = !item.expanded;
  }

  public removeplansummary(obj: any, group: any, pckage: any, e: any) {



    console.log(obj)
    let planSummary = JSON.parse(sessionStorage.getItem("plansummary") || '[]');

    if (obj.planLevel == 15) {
      for (let i = 0; i < planSummary.length; i++) {

        if (planSummary[i].planLevel == 18) {
          planSummary[i].options = []
        }

      }

    }

    if (planSummary) {

      let index: any = this.getindexofplan(obj);
      if (index > -1) {
        planSummary.splice(index, 1);
      } else {

        return;
      }

      var newselectedplans: any = {};
      for (var i = 0; i < planSummary.length; i++) {
        newselectedplans[planSummary[i].id] = i;
      }

      sessionStorage.setItem("selectedPlans", JSON.stringify(newselectedplans));

      let gstprice = 0;
      let hstprice = 0;
      let pstprice = 0;
      let qstprice = 0;

      if (obj.gst > 0) {
        gstprice = obj.planPrice * obj.gst;


        obj['gstPrice'] = gstprice
          ? this._decimalPipe.transform(gstprice, '1.2-2')
          : 0;
        obj['gstPrice'] = parseFloat(obj['gstPrice']);
      } else {
        obj["gstPrice"] = 0;
      }

      if (obj.hst > 0) {
        hstprice = obj.planPrice * obj.hst;




        obj['hstPrice'] = hstprice
          ? this._decimalPipe.transform(hstprice, '1.2-2')
          : 0;
        obj['hstPrice'] = parseFloat(obj['hstPrice']);

      } else {
        obj["hstPrice"] = 0;
      }

      if (obj.pst > 0) {
        pstprice = obj.planPrice * obj.pst;


        obj['pstPrice'] = pstprice
          ? this._decimalPipe.transform(pstprice, '1.2-2')
          : 0;
        obj['pstPrice'] = parseFloat(obj['pstPrice']);




      } else {
        obj["pstPrice"] = 0;
      }
      if (obj.qst > 0) {
        qstprice = obj.planPrice * obj.qst;

        obj['qstPrice'] = qstprice
          ? this._decimalPipe.transform(qstprice, '1.2-2')
          : 0;
        obj['qstPrice'] = parseFloat(obj['qstPrice']);
      } else {
        obj["qstPrice"] = 0;
      }

      obj["taxUI"] = "";
      if (obj["gstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["gstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["gstPrice"], "1.2-2") +
            "&nbsp;(GST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["pstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["pstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["pstPrice"], "1.2-2") +
            "&nbsp;(PST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["qstCheck"]) {
        obj["taxUI"] += "<span>";
        if (obj["qstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["qstPrice"], "1.2-2") +
            "&nbsp;(QST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (obj["hstCheck"]) {
        obj["taxUI"] += "<span> ";
        if (obj["hstPrice"] == 0) {
          obj["taxUI"] += "-";
        } else {
          obj["taxUI"] +=
            "$" +
            this._decimalPipe.transform(obj["hstPrice"], "1.2-2") +
            "&nbsp;(HST)";
        }
        obj["taxUI"] += "</span>";
      }

      if (
        !obj["hstCheck"] &&
        !obj["gstCheck"] &&
        !obj["pstCheck"] &&
        !obj["qstCheck"]
      ) {
        obj["taxUI"] += "<span>-";

        obj["taxUI"] += "</span>";
      }

      // ////this.consoleMessage(object["taxUI"])



      obj['tax'] = gstprice + hstprice + pstprice + qstprice
        ? this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, '1.2-2')
        : 0;
      obj['tax'] = parseFloat(obj['tax']);
      (obj["totalPrice"] =
        obj.planPrice + gstprice + hstprice + pstprice + qstprice),
        (obj["totalUI"] =
          "$" +
          parseFloat(
            obj.planPrice + gstprice + hstprice + pstprice + qstprice
          ));

      obj["total"] = parseFloat(
        obj.planPrice + gstprice + hstprice + pstprice + qstprice
      );

      let updatedSum = this.removetosum(obj.totalPrice);
      this.planssummarymain = [];
      this.planssummaryopt = [];
      console.log(planSummary)

      planSummary.forEach((element: any) => {
        if (element.packagename != "Opt-in") {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      sessionStorage.setItem(
        "plansummarymain",
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        "plansummaryopt",
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem("plansummary", JSON.stringify(planSummary));



      this.planCoverafeFunction();








      setTimeout(() => {
        let selectplans =
          JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

        //console.log(pckage);
        //console.log(group);

        let adddisabledcompanypaidproductid: any = []

        if (
          group.categorization.coveredByCompany == 1
          ||
          group.categorization.paidByEmployee == 1
        ) {
          pckage.groups.forEach((element: any) => {
            if (element.categorization.paidByCompany == 1) {
              if (group?.parentId == element?.parentId) {
                element.plans.forEach((plan: any) => {

                  let pl = { ...plan, ...element.categorization }
                  Object.keys(plan.productAddonss).forEach((key) => {
                    plan.productAddonss[key].forEach((product: any) => {
                      //console.log(product)
                      //console.log(pl)
                      if (pl.isBundle) {
                        adddisabledcompanypaidproductid.push(
                          pl,
                        );
                      } else {
                        adddisabledcompanypaidproductid.push(product.planlevel);
                      }

                    });
                  });
                });
              }
            }
          });



          adddisabledcompanypaidproductid = adddisabledcompanypaidproductid.filter(
            (item: any) => item !== undefined && item !== null
          );
          console.log(adddisabledcompanypaidproductid);

          for (let i = 0; i < adddisabledcompanypaidproductid.length; i++) {
            // adddisabledcompanypaidproductid.forEach((element: any, index: any) => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            // const plan: any = dom.querySelector("#plancheck" + adddisabledcompanypaidproductid[i].id);


            // const planCheck1 = this.renderer.selectRootElement("#plancheck" + element.id, true);

            let selectPlanCheck;
            if (obj?.isBundle == true) {
              selectPlanCheck = selectplans.some(function (el: any) {
                return el.packageId == adddisabledcompanypaidproductid[i].packageId && el.planLevelParent == adddisabledcompanypaidproductid[i].planLevel_parentId;
              })
            }
            else {
              selectPlanCheck = selectplans.some(function (el: any) {
                return el.packageId == adddisabledcompanypaidproductid[i].packageId;
              })



              let planData: any = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id);
              let targetClassName = 'cp_plan'
              if (e.className.includes('cp_plan')) {
                targetClassName = 'cp_plan'
              }
              else if (e.className.includes('cc_plan')) {
                targetClassName = 'cc_plan'
              }
              else if (e.className.includes('ep_plan')) {
                targetClassName = 'ep_plan'
              }

              for (let i = 0; i < planData.length; i++) {
                console.log(planData[i])
                if (planData[i].className.includes('cp_plan')) {
                  planData[i].click()
                  return false;

                }
              }


            }

            //console.log(selectPlanCheck)
            if (selectPlanCheck) {

              selectplans.forEach((products: any) => {

                if (products.packageId == adddisabledcompanypaidproductid[i].packageId) {

                  products.products.forEach((prod: any) => {
                    // if (prod.id == adddisabledcompanypaidproductid[i].id) {
                    if (prod.planLevel == adddisabledcompanypaidproductid[i].id) {
                    } else {
                      //console.log("checkHere")
                      // $("#plancheck" + element.id).click()
                    }
                  });
                } else {
                  // //this.consoleMessage("CheckHere1")

                }
              });
            } else {


              const dom: HTMLElement = this.elementRef.nativeElement;

              let coverage = adddisabledcompanypaidproductid[i].companyPaidCoverage?.replace("SELECTIVE_", "")
              //console.log(coverage)

              let planData;
              if (coverage && coverage != "DIRECT") {
                planData = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id + ".coverage" + coverage)
                //console.log(planData)
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                planData.forEach((element: any) => {
                  if (element.className.includes('cp_plan')) {

                    //console.log(element)
                    element.click()
                  }
                });
                break;
              }
              else {
                planData = dom.querySelectorAll("#plancheck" + adddisabledcompanypaidproductid[i].id);
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                planData.forEach((element: any) => {
                  if (element.className.includes('cp_plan')) {

                    //console.log(element)
                    element.click()
                  }
                });
              }


            }
          }
        }




        setTimeout(() => {
          let selectplans =
            JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

          selectplans.forEach((products: any) => {
            if (products.paidByCompany == 1) {
              products.products.forEach((element: any) => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan: any = dom.querySelector("#plancheck" + element.id);

                //this.consoleMessage(plan);

                if (plan) {

                }


                const samePlanIdElements = dom.querySelectorAll('#' + e.id);
                //console.log(e)
                let targetClassName = 'cp_plan'
                if (e.className.includes('cp_plan')) {
                  targetClassName = 'cp_plan'
                }
                else if (e.className.includes('cc_plan')) {
                  targetClassName = 'cc_plan'
                }
                else if (e.className.includes('ep_plan')) {
                  targetClassName = 'ep_plan'
                }

                for (let i = 0; i < samePlanIdElements.length; i++) {
                  let elem = samePlanIdElements[i];
                  let element: any = elem;
                  if (elem.className.includes('cp_plan')) {
                    element.disabled = false;
                    if (element.checked) {
                      element.disabled = true;

                    }
                  }

                }
              });
            }
          });
        }, 1000);
      }, 100);



      setTimeout(() => {
        let selectplansInfo =
          JSON.parse(sessionStorage.getItem("plansummary") || '[]') || "";

        //console.log(selectplansInfo)

        if (selectplansInfo.length > 0) {
          for (let i = 0; i < selectplansInfo.length; i++) {
            if (selectplansInfo[i].id == obj.id) {

            }

            else {
              setTimeout(() => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
                const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
                const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
                /*  //console.log(plan) */


                plan.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });

                plan2.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });
                plan3.forEach((elem: any) => {
                  (elem as HTMLElement).style.display = 'block';
                });



              }, 1000);
            }
          }



        }
        else {
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan = dom.querySelectorAll(".plan-description-span.single" + ".plancheck" + obj.id);
            const plan2 = dom.querySelectorAll(".plan-description-span.couple" + ".plancheck" + obj.id);
            const plan3 = dom.querySelectorAll(".plan-description-span.family" + ".plancheck" + obj.id);
            /*  //console.log(plan) */


            plan.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });

            plan2.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });
            plan3.forEach((elem: any) => {
              (elem as HTMLElement).style.display = 'block';
            });



          }, 1000);
        }
      }, 1000);

      setTimeout(() => {
        let selectplansInfo = JSON.parse(sessionStorage.getItem("plansummary") || '[]') || "";
        if (selectplansInfo.length === 0) {
          if (obj.groupName != "Complete Executive Care") {
            this.autoSelectCompanyPaidPlans()
          }


        }
      }, 1000);
    }
  }
  public addtoslectplans(planid: number, plansumamryindex: number) {
    ////this.logger.log("beforeaddtoplans")
    ////this.logger.log(planid)
    ////this.logger.log(plansumamryindex)
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") || "{}");
    ////this.logger.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex;
    ////this.logger.log("afteraddtoplans")
    ////this.logger.log(selectedPlans)
    sessionStorage.setItem("selectedPlans", JSON.stringify(selectedPlans));
  }


  public getslectedplans(planid: number) {
    ////this.logger.log(planid)
    let selectedPlans = JSON.parse(sessionStorage.getItem("selectedPlans") || "{}");
    ////this.logger.log(selectedPlans)
    return selectedPlans[planid];
  }
  public addtosum(amount: any) {
    //this.logger.log("addtosum" + amount);

    // amount = Math.round((amount + Number.EPSILON) * 100) / 100;
    let selectedPlansAmount = parseFloat(
      sessionStorage.getItem('totalAmount') || '0.00'
    );

    selectedPlansAmount = selectedPlansAmount + parseFloat(amount);
    // let selectedPlansAmount:any = parseFloat(sessionStorage.getItem("totalAmount") || "0.00");

    // // selectedPlansAmount = selectedPlansAmount + amount;
    // selectedPlansAmount = selectedPlansAmount+parseFloat(amount)
    //this.logger.log("selectedPlansAmount" + selectedPlansAmount);

    console.log(selectedPlansAmount)
    sessionStorage.setItem(
      "totalAmount",
      this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );

    sessionStorage.setItem(
      "totalAmountUI",
      "$" + this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );

    // this.planAmount = selectedPlansAmount


    //this.logger.log("palnamopunt" + this.planAmount);
    return selectedPlansAmount;
    // //////this.logger.log(this.planAmount )
  }

  public removetosum(amount: number) {
    let selectedPlansAmount = parseFloat(sessionStorage.getItem("totalAmount").replace(/,/g, ""));

    selectedPlansAmount = selectedPlansAmount - amount;
    sessionStorage.setItem(
      "totalAmount",
      this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );
    sessionStorage.setItem(
      "totalAmountUI",
      "$" + this._decimalPipe.transform(selectedPlansAmount, "1.2-2").replace(/,/g, "")
    );

    // this.planAmount = selectedPlansAmount
    return selectedPlansAmount;
  }

  calculateBasePlanDeltasforCCplans1(ccplanspackages, baseplans, compnayplans) {


    let modifiedCCplanPackages = []
    for (let i = 0; i < ccplanspackages.length; i++) {
      let modifiedCCPackage = ccplanspackages[i]
      //this.logger.log(ccplanspackages[i].name)
      //this.logger.log(ccplanspackages[i].id)
      let CCplansgroups = ccplanspackages[i].groupsCC

      modifiedCCPackage.groupsCC = []
      for (let CCplangroup of CCplansgroups) {

        let modifiedCCgroup = CCplangroup
        //this.logger.log(CCplangroup.id)
        //this.logger.log(CCplangroup.parentId)
        //this.logger.log(CCplangroup.name)
        let CCplans = CCplangroup.plans
        modifiedCCgroup.plans = []
        for (let CCplan of CCplans) {

          let modifiedCCplan = CCplan
          //this.logger.log(CCplan.id)
          //this.logger.log(CCplan.isBundle)
          //this.logger.log(CCplan.name)

          CCplan.planLevel_parentId = CCplangroup.parentId

          let payroll = true;
          let EmployeeChoice = 0

          if (this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CCplan.packageId)) {

            if (EmployeeChoice == 2) {
              payroll = false;
            }

          }
          else {
            if (this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(CCplan.planLevel)) {

              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          let selectedCCplanProductarray = CCplan.productAddonss[CCplan.name];

          if (CCplan.isBundle) {
            //this.logger.log("BundlePlan")

            //this.logger.log(baseplans)
            var filtered_base_plans = baseplans.filter(function (plan) {
              //this.logger.log(plan)
              //cp_plans

              //this.logger.log(CCplan.packageId,plan.packageId)
              //this.logger.log(CCplan.planLevel_parentId,plan.planLevel_parentId)
              //this.logger.log(CCplan.planLevel,plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan) {
              //this.logger.log(plan)
              //cp_plans

              //this.logger.log(CCplan.packageId,plan.packageId)
              //this.logger.log(CCplan.planLevel_parentId,plan.planLevel_parentId)
              //this.logger.log(CCplan.planLevel,plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel
              );
            });

            console.log(filtered_base_plans);

            //this.logger.log(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct;
            let selectedBaseplanProductsArray = [];
            let selectedCompanyplanProduct;
            let selectedCompanyplanProductsArray = [];

            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {
              var filtered_base_plans2 = filtered_base_plans.filter(function (plan) {


                return (
                  CCplan.id == plan.id
                );
              });
              var filtered_compnay_plans2 = filtered_compnay_plans.filter(function (plan) {
                ////this.logger.log(plan)
                //cp_plans

                // //this.logger.log(CCplan.packageId,plan.packageId)
                // //this.logger.log(CCplan.planLevel_parentId,plan.planLevel_parentId)
                // //this.logger.log(CCplan.planLevel,plan.planLevel)

                return (
                  CCplan.id == plan.id
                );
              });
              selectedBasePlan = filtered_base_plans2[0];
              selectedCompnayPlan = filtered_compnay_plans2[0];
              // alert("morethan1")
            }
            console.log({ selectedBasePlan })

            if (selectedBasePlan) {
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = selectedBasePlan.productAddonss[selectedBasePlan.name];
              let selectedBaseplanProductsArray2 = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                  selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                }
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
              }
              else {
                let productCoverageFound = false;
                for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                  for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

                    if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
                      productCoverageFound = true
                      selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
                      break;
                    }


                  }
                  if (!productCoverageFound) {



                    selectedBasePlan = {};
                    selectedBaseplanProduct = {};
                    selectedBaseplanProduct.calculatedTax = {};
                    selectedBaseplanProduct.calculatedTax.price = 0;
                    selectedBaseplanProduct.calculatedTax.tax = 0;
                    selectedBaseplanProduct.calculatedTax.total = 0;
                    selectedBaseplanProduct.name = "NA";
                    selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                    selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



                  }

                }
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
              }




            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }

            if (selectedCompnayPlan) {
              // selectedCompanyplanProduct = selectedCompnayPlan.productAddonss[selectedCompnayPlan.name][0]
              selectedCompanyplanProductsArray =
                selectedCompnayPlan.productAddonss[selectedCompnayPlan.name];


              let selectedCompanyplanProductsArray2 = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedCompanyplanProductsArray2 = selectedCompanyplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedCompanyplanProductsArray.length; i++) {
                  selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[selectedCompanyplanProductsArray.length - 1]);
                }
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

              } else {
                let productCoverageFound = false;
                for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                  for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

                    if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
                      productCoverageFound = true
                      selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
                      break;
                    }


                  }
                  if (!productCoverageFound) {


                    selectedCompanyplanProduct = {};
                    selectedCompanyplanProduct.calculatedTax = {};
                    selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
                    selectedCompanyplanProduct.name = "NA";
                    selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                    selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



                  }

                }
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2
              }


            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }
            }


            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.logger.log("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCCplan.products = []

            for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];
              let selectedCCplanProduct = selectedCCplanProductarray[i];
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax?.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );
              let employeeTax =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax?.price -
                selectedBaseplanProduct.calculatedTax?.price
              );

              if (selectedBaseplanProduct.name == 'NA') {
                //this.logger.log("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              let deltaplanTax = adjustWith2DecimalsForUI(
                deltaplanPrice *
                (this.deltaCompanyTax ? companyTax : employeeTax)
              );
              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
              let planName = `${CCplan.name} (${upgradeText})`;
              let compnayShareStatement = `${CCplan.name} Contribution`;
              let employeeShareStatement = `${CCplan.name} upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };

              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
              };

              let ccProduct: any = {}
              ccProduct.upgradeCalculation = obj;
              modifiedCCplan.products.push(ccProduct)
              modifiedCCplan.upgradeCalculation = obj;
            }

          }
          else {

            var filtered_base_plans = baseplans.filter(function (plan) {

              console.log(plan)
              //cp_plans

              console.log(CCplan.packageId, plan.packageId)
              console.log(CCplan.planLevel_parentId, plan.planLevel_parentId)
              console.log(CCplan.planLevel, plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan) {

              console.log(plan)
              //cp_plans

              console.log(CCplan.packageId, plan.packageId)
              console.log(CCplan.planLevel_parentId, plan.planLevel_parentId)
              console.log(CCplan.planLevel, plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel
              );
            });


            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            if (filtered_base_plans.length == 0) {

            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0]
              selectedCompnayPlan = filtered_compnay_plans[0]

            } else {
              //this.logger.log(filtered_base_plans.length)
            }

            let selectedbaseplanproduct
            let selectedBaseplanProduct

            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {


                let products = selectedBasePlan.productAddonss[planname]

                if (products.length == 0) {

                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0]
                  // selectedCompnayPlan= filtered_compnay_plans[0]

                } else {
                  //this.logger.log(products.length)
                }
              }
              //this.logger.log(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct

            }
            else {
              selectedBasePlan = {}
              selectedBaseplanProduct = {}
              selectedBaseplanProduct.calculatedTax = {}
              selectedBaseplanProduct.calculatedTax.price = 0
              selectedBaseplanProduct.calculatedTax.tax = 0
              selectedBaseplanProduct.calculatedTax.total = 0
              selectedBaseplanProduct.name = "NA"
            }





            let CCplanProduct;

            for (let planname in CCplan.productAddonss) {
              let products = CCplan.productAddonss[planname]
              if (products.length == 0) {

              } else if (products.length == 1) {
                CCplanProduct = products[0]
                // selectedCompnayPlan= filtered_compnay_plans[0]

              } else {
                //this.logger.log(products.length)
              }
            }
            console.log({ CCplanProduct, CCplan })
            let selectedCCplanProduct = CCplanProduct


            // //this.logger.log(selectedCCplanProduct.calculatedTax?.price)
            // //this.logger.log(selectedCCplanProduct.calculatedTax.tax)
            // //this.logger.log(selectedCCplanProduct.calculatedTax.total)


            // //this.logger.log("Delta")
            // //this.logger.log(selectedCCplanProduct.calculatedTax?.price-selectedBaseplanProduct.calculatedTax?.price)
            // //this.logger.log("EmployeeTax")
            // //this.logger.log(selectedCCplanProduct.calculatedTax.planProductInfos.length>0?selectedCCplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
            // //this.logger.log(selectedCCplanProduct.calculatedTax.planProductInfos.length>0?selectedCCplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)

            let selectedcompanyplanproduct
            let selectedCompanyplanProduct

            if (selectedCompnayPlan) {
              for (let planname in selectedCompnayPlan.productAddonss) {

                //this.logger.log(planname)
                //this.logger.log(selectedCompnayPlan.productAddonss[planname])
                let products = selectedCompnayPlan.productAddonss[planname]

                if (products.length == 0) {

                } else if (products.length == 1) {
                  selectedcompanyplanproduct = products[0]
                  // selectedCompnayPlan= filtered_compnay_plans[0]

                } else {
                  //this.logger.log(products.length)
                }
              }
              selectedCompanyplanProduct = selectedcompanyplanproduct

              //this.logger.log("CompanyTax")
              //this.logger.log(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
              //this.logger.log(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)

            }
            else {
              selectedCompanyplanProduct = {}
              selectedCompanyplanProduct.calculatedTax = {}
              selectedCompanyplanProduct.calculatedTax.planProductInfos = []
            }


            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction"
              upgradepaymentText = "using payroll deduction"
              //this.logger.log("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            }
            else {
              upgradeText = "Employee upgraded using Direct payment"
              upgradepaymentText = "using Direct payment"


            }
            console.log({ selectedCCplanProduct })
            let companyTax = selectedCompanyplanProduct.calculatedTax?.planProductInfos.length > 0 ? selectedCompanyplanProduct.calculatedTax?.planProductInfos[0].taxRate : 0
            let companyTaxPercentage = selectedCompanyplanProduct.calculatedTax?.planProductInfos.length > 0 ? selectedCompanyplanProduct.calculatedTax?.planProductInfos[0].taxRatePercentage : 0
            let baseplanPrice = adjustWith2DecimalsForUI(selectedBaseplanProduct.calculatedTax?.price)
            let baseplanTaxorg = adjustWith2DecimalsForUI(selectedBaseplanProduct.calculatedTax?.tax)
            let baseplanTax = adjustWith2DecimalsForUI(baseplanPrice * companyTax)
            let baseplanTotalorg = adjustWith2DecimalsForUI(selectedBaseplanProduct.calculatedTax?.total)
            let baseplanTotal = adjustWith2DecimalsForUI(baseplanPrice + baseplanTax)
            let employeeTax = selectedCCplanProduct.calculatedTax?.planProductInfos.length > 0 ? selectedCCplanProduct.calculatedTax.planProductInfos[0].taxRate : 0
            let employeeTaxPercentage = selectedCCplanProduct.calculatedTax?.planProductInfos.length > 0 ? selectedCCplanProduct.calculatedTax?.planProductInfos[0].taxRatePercentage : 0

            let deltaplanPrice = adjustWith2DecimalsForUI(selectedCCplanProduct.calculatedTax?.price - selectedBaseplanProduct.calculatedTax?.price)
            if (selectedBaseplanProduct.name == 'NA') {
              //this.logger.log("No Base plan/product for this upgrade plans/product")
              companyTax = employeeTax
              companyTaxPercentage = employeeTaxPercentage
            }
            let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax))
            // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

            let deltaplanTotal = adjustWith2DecimalsForUI(deltaplanPrice + deltaplanTax)



            let combinedplanPrice = baseplanPrice + deltaplanPrice
            let combinedplanbasePrice = baseplanPrice
            let combinedplanDeltaprice = deltaplanPrice
            let combinedplanTax = adjustWith2DecimalsForUI(baseplanTax + deltaplanTax)
            let combinedplanCompanyTax = baseplanTax
            let combinedplanEmployeeTax = adjustWith2DecimalsForUI(deltaplanTax)
            let combinedplanCompanyTaxPercentage = companyTaxPercentage
            let combinedplanemployeeTaxPercentage = this.deltaCompanyTax ? companyTaxPercentage : employeeTaxPercentage
            let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage
            let combinedplanTotal = adjustWith2DecimalsForUI(baseplanTotal + deltaplanTotal)

            let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`
            let planName = `${CCplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`
            let compnayShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) Contribution`
            let employeeShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) upgrade cost`
            let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `
            let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `
            let type;

            if (payroll) {
              type = "Split with payroll deduction"
            } else {
              type = "Split with direct pay"

            }
            let basePlanDetails = {
              planId: selectedBasePlan.id || 0, //0
              planName: selectedBasePlan.name || "NA", //NA
              planLevelId: selectedBasePlan.planLevel || 0, //0
              amount: baseplanPrice || 0, //0
              amountUI: `$${baseplanPrice}` || 0, //0
              tax: baseplanTax,
              total: baseplanTotal,
              taxUI: `$${baseplanTax}`, //companyTaxpercentage
              totalUI: `$${baseplanTotal}`,
              planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
              planFrequencyID: selectedBasePlan.frqMonthly || "",
              planFusebillID: selectedBasePlan.fusebillId || "",
              products: [selectedBaseplanProduct],
              planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
              packageName: selectedBasePlan.packageName || "",
              packageId: selectedBasePlan.packageId || 0
            };
            let obj = {
              companyTax, companyTaxPercentage, baseplanPrice, baseplanTaxorg, baseplanTax, baseplanTotalorg, baseplanTotal, employeeTax, employeeTaxPercentage,
              deltaplanPrice, deltaplanTax, deltaplanTotal, combinedplanPrice, combinedplanbasePrice, combinedplanDeltaprice, combinedplanTax,
              combinedplanCompanyTax, combinedplanEmployeeTax, combinedplanCompanyTaxPercentage, combinedplanemployeeTaxPercentage, combinedplanTotal, payroll,
              scenario, planName, compnayShareStatement, employeeShareStatement, planDescription, planDescription2, type, basePlanDetails, combinedplanemployeeTaxPercentageorg
            }

            //this.logger.log(obj)
            modifiedCCplan.upgradeCalculation = obj

          }
          modifiedCCgroup.plans.push(modifiedCCplan)

        }
        modifiedCCPackage.groupsCC.push(modifiedCCgroup)


      }

      modifiedCCplanPackages.push(modifiedCCPackage)


    }

    this.modifiedBlocksCoveredByCompany = modifiedCCplanPackages

    //this.logger.log(this.modifiedBlocksCoveredByCompany)
  }
  newplansadded() {

    let plansummarymain = JSON.parse(sessionStorage.getItem("plansummarymain")) || "";

    if (plansummarymain.length > 0) {
      $("#showPlansForEmployee").modal('hide')
      // this.gigtoCorpConvertion()
      this.gigtoCorpConvertion(this.selectedItem.id, this.selectedItem.parentId)
    }
    else {

      Swal.fire({ title: "Info", text: "Please Choose at least one plan to procced" });


    }

  }

  public autoSelectCompanyPaidPlans() {

    // console.log(this.companypaidproductid)
    this.companypaidproductid = this.companypaidproductid.filter(
      (item: any) => item !== undefined && item !== null
    );

    var result = this.companypaidproductid.reduce((unique: any, o: any) => {
      if (!unique.some((obj: { name: any; }) => obj.name === o.name)) {
        unique.push(o);
      }
      return unique;
    }, []);
    console.log(result);

    // this.companypaidproductid.forEach((element, index) => {

    result.forEach((element: any, index: any) => {


      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        // const plan: any = dom.querySelector("#plancheck" + element.id);
        // this.renderer.selectRootElement("#plancheck" + element.id).click()



        if (element.isBundle) {
          let productKeyArray: any = Object.keys(element.productAddonss)
          for (let productkey of productKeyArray) {
            //console.log(productkey)
            //console.log(element.productAddonss)
            //console.log(productKeyArray)
            for (let i = 0; i < element.productAddonss[productkey].length; i++) {
              //console.log(element.productAddonss[productkey][i])
              let coverage = element.companyPaidCoverage?.replace("SELECTIVE_", "")
              console.log(coverage)
              if (coverage && coverage != "DIRECT") {
                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    coverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  console.log(targetElement)
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  if (targetElement.disabled) {
                    targetElement.disabled = false
                    targetElement.click();
                    break;
                  }
                  else {
                    targetElement.click();
                    break;
                  }




                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + coverage).click()

              }
              else {

                try {
                  const elementSelector = "#plancheck" +
                    element.productAddonss[productkey][i].planId +
                    ".coverage" +
                    element.productAddonss[productkey][i].planCoverage;

                  const targetElement = this.renderer.selectRootElement(elementSelector, true);
                  // Use the second argument 'true' to avoid throwing an error if the element is not found
                  console.log(targetElement)
                  if (targetElement.disabled) {
                    targetElement.disabled = false
                    targetElement.click();
                  }
                  else {
                    targetElement.click();
                  }

                } catch (error) {
                  console.warn('Element not found. Moving to the next element:', error);
                  // Handle the case when the element is not found
                  // You can skip the iteration or log the error as needed
                }
                // this.renderer.selectRootElement("#plancheck" + element.productAddonss[productkey][i].planId + ".coverage" + element.productAddonss[productkey][i].planCoverage).click()

              }

            }

          }

          // Object.keys(element.productAddonss).forEach((key) => {
          //   element.productAddonss[key].forEach((product: any) => {
          //    //console.log(product)
          //    let coverage = element.companyPaidCoverage?.replace("SELECTIVE_","")
          //    //console.log(coverage)
          //   //  //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage))
          //   //   // //console.log(this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + covergae))
          //     // this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage?coverage:product.planCoverage).click()

          //     if(coverage!="DIRECT"){
          //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + coverage).click()

          //     }
          //     else{
          //       this.renderer.selectRootElement("#plancheck" + product.planId + ".coverage" + product.planCoverage).click()
          //     }

          //   })
          // })

        }
        else {
          this.renderer.selectRootElement("#plancheck" + element.id).click()
        }



      }, 100);

    });


    setTimeout(() => {
      let selectplans =
        JSON.parse(sessionStorage.getItem("plansummarymain") || '[]') || "";

      //this.consoleMessage(selectplans)

      //console.log(selectplans)
      selectplans.forEach((element: any) => {
        if (element.paidByCompany == 1) {
          element.products.forEach((product: any, index: any) => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            const plan: any = dom.querySelector("#plancheck" + product.id);

            if (plan) {
              plan.disabled = true;
            }
          })

        }
      });
    }, 2000);
    // this.mainarrayFinal.forEach((element: any) => {
    //   element.groups.forEach((group: any) => {
    //     group.plans.forEach((plan: any) => {
    //       if (plan.productAddonss) {
    //         Object.keys(plan.productAddonss).forEach((key) => {
    //           // plan.productAddonss[key].forEach((product) => {
    //           const keys = ['planCoverage'];
    //           const filteredData = plan.productAddonss[key].filter((value: any, index: any, self: any) =>
    //             self.findIndex((v: { [x: string]: any; }) => keys.every(k => v[k] === value[k])) === index
    //           );
    //           plan.productAddonss[key] = filteredData
    //           // });
    //         });
    //       }
    //     });

    //   });
    // });
    //this.consoleMessage(this.mainarray)

    this.mainarrayFinal.forEach((element: { groups: any[]; }) => {
      element.groups.forEach((group: { categorization: { paidByCompany: number; }; plans: any[]; }) => {
        // //this.consoleMessage(element.groups)
        if (element.groups.length == 1) {
          // //this.consoleMessage(group)
          if (group.categorization.paidByCompany == 1) {
            group.plans.forEach((plan: { productAddonss: { [x: string]: any[]; }; }) => {
              Object.keys(plan.productAddonss).forEach((key) => {
                plan.productAddonss[key].forEach((product: { id: any; }) => {
                  this.disabledcompanypaidproductid.push({ id: product.id });
                  const dom: HTMLElement = this.elementRef.nativeElement;

                  const plan: any = dom.querySelector("#plancheck" + product.id);

                  if (plan) {
                    plan.checked = false;
                  }
                  // $("#plancheck" + product.id).prop("checked", false);
                });
              });
            });
          }
        }
      });
    });


    this.disabledcompanypaidproductid.forEach((element: { id: string; }, index: any) => {
      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        const plan: any = dom.querySelector("#plancheck" + element.id);

        // plan.disabled=true
      }, 100);
    });
    // if (packagesInBlocks && packagesInBlocks.paidByCompany) {
    //   for (const cpPackage of packagesInBlocks.paidByCompany) {
    //     for (const cpGroup of cpPackage.groupsCP) {
    //       for (const cpPlan of cpGroup.plans) {

    //         for(const product1 in cpPlan.productAddonss){
    //           //this.consoleMessage(product1)
    //           //this.consoleMessage(cpPlan.productAddonss[product1])
    //           $("#plancheck"+cpPlan.productAddonss[product1][0].id).click();

    //         }

    //       }
    //     }
    //   }
    // }
    // this.toastrService.success("Company paid plans are all selected", "");

  }
  public planCoverafeFunction() {
    this.paidEmployeeShare = 0;
    this.coveredEmployeeShare = 0;

    //this.consoleMessage("plancoverage");

    let planDetailsArray = JSON.parse(
      sessionStorage.getItem("planDetailsArray") || "[]"
    );
    //this.consoleMessage(planDetailsArray);
    // var package_plans = this.convertpackagesToPlans(planDetailsArray);
    // var package_plans = this.convertpackagesToPlans2(this.packagesInBlocks);
    var package_plans = this.convertpackagesToPlans2(this.basepackages);

    //this.consoleMessage(package_plans);
    let planSummaryMain = JSON.parse(sessionStorage.getItem("plansummary") || "[]");
    let planSummaryLife = JSON.parse(sessionStorage.getItem("plansummaryLife") || "[]");
    // let iafgplansCheck = JSON.parse(
    //   sessionStorage.getItem('plansummaryLife') || '[]'
    // );

    this.iafgplansCheck = JSON.parse(
      sessionStorage.getItem('plansummaryLife') || '[]'
    );
    //console.log(planSummaryMain)

    // let planSummary;
    // if(planSummaryMain.length>0){
    //  let planSummary = planSummaryMain.concat(planSummaryLife)
    // }else{
    //    planSummary = planSummaryLife
    // }
    let planSummary = planSummaryMain.concat(planSummaryLife)

    //console.log(planSummary)
    //this.consoleMessage(planSummary);
    var all_selected_plans = [];
    var payrollCCplans = [];
    var directpayCCplans = [];
    var employeeDealingPlans = [];
    var companyDealingPlans = [];
    var alloptinplans = [];
    var company_selected_plans = [];
    var employee_selected_plans = [];
    var company_paid_selected_plans = [];
    var company_covered_selected_plans = [];


    var selected_cp_plans = planSummary.filter(function (plan: any) {
      return plan.paidByCompany == 1 || plan.categorization?.paidByCompany == true;;
    });

    var selected_cc_plans = planSummary.filter(function (plan: any) {
      return plan.coveredByCompany == 1 || plan.categorization?.coveredByCompany == true;;
    });

    var selected_ep_plans = planSummary.filter(function (plan: any) {
      return plan.paidByEmployee == 1 || plan.categorization?.paidByEmployee == true;
    });

    // var selected_cc_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.coveredByCompany == 1;

    //   });

    // });

    // var selected_cp_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.paidByCompany == 1;

    //   });

    // });
    // var selected_ep_plans = planSummary.forEach(element => {

    //   element.groups.forEach(group => {
    //     return group.categorization.paidByEmployee == 1;

    //   });

    // });

    //this.consoleMessage(selected_cc_plans);
    //this.consoleMessage(selected_cp_plans);
    //this.consoleMessage(selected_ep_plans);

    //console.log(selected_cp_plans)

    for (var cp = 0; cp < selected_cp_plans.length; cp++) {
      var current_cp_plan: any = selected_cp_plans[cp];

      // current_cp_plan.amount = parseFloat(
      //   this._decimalPipe.transform(current_cp_plan.amount, "1.2-2")
      // );
      current_cp_plan.amount = adjustWith2DecimalsForUI(current_cp_plan.amount)

      // //this.consoleMessage("rakesh",current_cp_plan.amount)
      current_cp_plan["amounts"] = {
        company: current_cp_plan.amount,
        employee: 0,
        total: current_cp_plan.amount,
      };
      current_cp_plan["categorization"] = {
        paidByCompany: true,
        coveredByCompany: false,
        paidByEmployee: false,
      };

      current_cp_plan["type"] = this.lang["100_Company_Paid"];

      current_cp_plan["companyCoveredBasePlan"] = {
        planId: 0, //0
        planName: "NA", //NA
        planLevelId: 0, //0
        amount: 0, //0
        tax: 0,
        total: 0,
      };
      current_cp_plan["employeeAmount"] = current_cp_plan["amounts"].employee;
      current_cp_plan["employeeAmountUI"] =
        "$" + current_cp_plan["amounts"].employee;
      current_cp_plan["companyAmount"] = current_cp_plan["amounts"].company;
      current_cp_plan["companyAmountUI"] =
        "$" + current_cp_plan["amounts"].company;
      current_cp_plan["planLevelName"] = current_cp_plan.groupName || ""; //Here

      if (
        current_cp_plan.id == 429 ||
        current_cp_plan.packageId == 8 ||
        current_cp_plan.planLevel == 16
      ) {
        alloptinplans.push(current_cp_plan);
      } else {
        all_selected_plans.push(current_cp_plan);
        company_selected_plans.push(current_cp_plan);
        company_paid_selected_plans.push(current_cp_plan);
      }
    }

    for (var cc = 0; cc < selected_cc_plans.length; cc++) {
      var current_cc_plan: any = selected_cc_plans[cc];

      current_cc_plan["amounts"] = {
        company: current_cc_plan.upgradeCalculation.baseplanPrice,
        employee: current_cc_plan.upgradeCalculation.deltaplanPrice,
        total: current_cc_plan.upgradeCalculation.combinedplanPrice,
      };

      current_cc_plan["companyCoveredBasePlan"] =
        current_cc_plan.upgradeCalculation.basePlanDetails;

      current_cc_plan["companyCoveredBasePlan"].companyTax =
        current_cc_plan.upgradeCalculation.baseplanTax;
      current_cc_plan["companyCoveredBasePlan"].companyTaxPercentage =
        current_cc_plan.upgradeCalculation.companyTaxPercentage;

      current_cc_plan["companyCoveredBasePlan"].employeeTax = 0;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentage =
        current_cc_plan.upgradeCalculation.employeeTaxPercentage;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect = 0;
      current_cc_plan["companyCoveredBasePlan"].employeeTaxPercentageEffect =
        "0%";
      current_cc_plan["companyCoveredBasePlan"].specialTax =
        current_cc_plan["companyCoveredBasePlan"].companyTax +
        current_cc_plan["companyCoveredBasePlan"].employeeTaxEffect;
      current_cc_plan["companyCoveredBasePlan"].tax2 =
        current_cc_plan["companyCoveredBasePlan"].companyTax;

      //this.consoleMessage(current_cc_plan);
      ///
      //deleta plan things
      current_cc_plan["employeeDeductions"] = {
        amount: current_cc_plan.upgradeCalculation.deltaplanPrice, //0
        amountUI: `$${current_cc_plan.upgradeCalculation.deltaplanPrice}`, //0
        tax: `${current_cc_plan.upgradeCalculation.deltaplanTax}`,
        total: `${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
        taxUI: `$${current_cc_plan.upgradeCalculation.deltaplanTax}`,
        totalUI: `$${current_cc_plan.upgradeCalculation.deltaplanTotal}`,
      };

      // current_cc_plan["employeeDeductions"].amountUI =
      //   "$" + current_cc_plan["employeeDeductions"].amount;
      // current_cc_plan["employeeDeductions"].taxUI = current_cc_plan[
      //   "companyCoveredBasePlan"
      // ].taxUI.replace(
      //   current_cc_plan["companyCoveredBasePlan"].tax,
      //   current_cc_plan["employeeDeductions"].tax
      // );
      // current_cc_plan["employeeDeductions"].totalUI =
      //   "$" + current_cc_plan["employeeDeductions"].total;

      current_cc_plan["categorization"] = {
        paidByCompany: false,
        coveredByCompany: true,
        paidByEmployee: false,
      };

      current_cc_plan["type"] = current_cc_plan.upgradeCalculation.type;

      current_cc_plan["planGrandTotal"] = {
        amount: current_cc_plan.upgradeCalculation.combinedplanPrice, //0
        amountUI: `$${current_cc_plan.upgradeCalculation.combinedplanPrice}`, //0
        tax: current_cc_plan.upgradeCalculation.combinedplanTax,
        total: current_cc_plan.upgradeCalculation.combinedplanTotal,
        taxUI: `$${current_cc_plan.upgradeCalculation.combinedplanTax}`,
        totalUI: `$${current_cc_plan.upgradeCalculation.combinedplanTotal}`,
      };
      // planid,planname,planlevelid,planlevename,amount
      current_cc_plan.amount = adjustWith2DecimalsForUI(current_cc_plan["planGrandTotal"].amount);
      current_cc_plan.amountUI = adjustWith2DecimalsForUI(current_cc_plan["planGrandTotal"].amount);
      current_cc_plan.tax = current_cc_plan["planGrandTotal"].tax;
      current_cc_plan.taxUI = current_cc_plan["planGrandTotal"].taxUI;
      current_cc_plan.total = current_cc_plan["planGrandTotal"].total;
      current_cc_plan.totalUI = current_cc_plan["planGrandTotal"].totalUI;
      current_cc_plan.skuTotalPrice = current_cc_plan["planGrandTotal"].total;
      current_cc_plan.totalPrice = current_cc_plan["planGrandTotal"].total;

      //this.consoleMessage(current_cc_plan);

      current_cc_plan["companyShareTotal"] =
        current_cc_plan["companyCoveredBasePlan"].total;
      current_cc_plan["employeeShareTotal"] =
        current_cc_plan["employeeDeductions"].total;

      current_cc_plan["companySharePlanAmountTotal"] =
        current_cc_plan["companyCoveredBasePlan"].amount;
      current_cc_plan["employeeSharePlanAmountTotal"] =
        current_cc_plan["employeeDeductions"].amount;

      current_cc_plan["companyShareTaxTotal"] =
        current_cc_plan["companyCoveredBasePlan"].tax;
      current_cc_plan["employeeShareTaxTotal"] =
        current_cc_plan["employeeDeductions"].tax;

      current_cc_plan["employeeAmount"] = current_cc_plan["amounts"].employee;
      current_cc_plan["employeeAmountUI"] =
        "$" + current_cc_plan["amounts"].employee;
      current_cc_plan["companyAmount"] = current_cc_plan["amounts"].company;
      current_cc_plan["companyAmountUI"] =
        "$" + current_cc_plan["amounts"].company;
      //this.consoleMessage(current_cc_plan["amounts"].employee);
      //this.consoleMessage(current_cc_plan["amounts"].company);
      //this.consoleMessage(current_cc_plan["amounts"].total);
      this.coveredEmployeeShare += parseFloat(
        current_cc_plan["amounts"].employee
      );

      // this.coveredEmployeeShare = parseFloat(
      //   this._decimalPipe.transform(this.coveredEmployeeShare, "1.2-2" ||)
      // );
      this.coveredEmployeeShare = parseFloat(this.coveredEmployeeShare)
      all_selected_plans.push(current_cc_plan);
      company_selected_plans.push(current_cc_plan);
      company_covered_selected_plans.push(current_cc_plan);

      if (current_cc_plan.upgradeCalculation.payroll) {
        payrollCCplans.push(current_cc_plan);
      } else {
        directpayCCplans.push(current_cc_plan);
      }
      //this.consoleMessage("payrollCCplans",payrollCCplans)
      //this.consoleMessage("directpayCCplans",directpayCCplans)
    }

    for (var ep = 0; ep < selected_ep_plans.length; ep++) {
      var current_ep_plan: any = selected_ep_plans[ep];

      //this.consoleMessage(current_ep_plan)

      current_ep_plan.amount = adjustWith2DecimalsForUI(current_ep_plan.products[0].price);

      current_ep_plan["amounts"] = {
        company: 0,
        employee: current_ep_plan.total, //current_ep_plan.amount,(+tax)
        total: current_ep_plan.total, //current_ep_plan.amount,(+tax)
      };

      current_ep_plan["categorization"] = {
        paidByCompany: false,
        coveredByCompany: false,
        paidByEmployee: true,
      };

      current_ep_plan["type"] = this.lang["Voluntary_Opt_In"];

      current_ep_plan["companyCoveredBasePlan"] = {
        planId: 0, //0
        planName: "NA", //NA
        planLevelId: 0, //0
        amount: 0, //0
        tax: 0,
        total: 0,
      };
      current_ep_plan["employeeAmount"] = current_ep_plan["amounts"].employee;
      current_ep_plan["employeeAmountUI"] =
        "$" + current_ep_plan["amounts"].employee;
      current_ep_plan["companyAmount"] = current_ep_plan["amounts"].company;
      current_ep_plan["companyAmountUI"] =
        "$" + current_ep_plan["amounts"].company;
      //  current_cp_plan["planLevelName"] = current_ep_plan.groupName || ""

      //this.consoleMessage(current_ep_plan)

      //console.log(current_ep_plan)

      //this.consoleMessage(current_ep_plan["amounts"].employee);
      //this.consoleMessage(this.paidEmployeeShare);
      // this.paidEmployeeShare = +current_ep_plan["amounts"].employee;
      this.paidEmployeeShare += parseFloat(current_ep_plan["amounts"].total);
      //this.consoleMessage(this.paidEmployeeShare);
      // this.paidEmployeeShare = parseFloat(
      //   this._decimalPipe.transform(this.paidEmployeeShare, "1.2-2")
      // );

      //this.consoleMessage(this.paidEmployeeShare);
      all_selected_plans.push(current_ep_plan);
      employee_selected_plans.push(current_ep_plan);
    }

    employeeDealingPlans = directpayCCplans.concat(employee_selected_plans);

    //console.log(employeeDealingPlans)
    companyDealingPlans = company_paid_selected_plans.concat(payrollCCplans);
    //console.log(this.iafgplansCheck)
    // employeeDealingPlans = employeeDealingPlans.concat(this.iafgplansCheck)  //hererakesh
    //console.log(employeeDealingPlans)

    //this.consoleMessage("employeeDealingPlans",employeeDealingPlans)
    //this.consoleMessage("companyDealingPlans",companyDealingPlans)

    this.alloptinplans = alloptinplans;

    //this.consoleMessage(this.coveredEmployeeShare);
    //this.consoleMessage(this.paidEmployeeShare);

    sessionStorage.setItem("employeeshare", this.paidEmployeeShare);
    //this.consoleMessage(this._decimalPipe.transform(this.coveredEmployeeShare, "1.2-2"));
    //this.consoleMessage(this._decimalPipe.transform(this.paidEmployeeShare, "1.2-2"));

    var totalIAFG = 0;
    for (let i = 0; i < this.iafgplansCheck.length; i++) {
      totalIAFG += parseFloat(this.iafgplansCheck[i].skuTotalPrice);
    }



    this.totalEmployeeShare =
      this.coveredEmployeeShare + this.paidEmployeeShare;
    // this.cartDisplayAmount = this.paidEmployeeShare + totalIAFG;
    this.cartDisplayAmount = this.paidEmployeeShare;
    // this.totalEmployeeShare = parseFloat(
    //   this._decimalPipe.transform(this.totalEmployeeShare, "1.2-2")
    // );
    this.totalEmployeeShare = parseFloat(this.totalEmployeeShare)
    this.cartDisplayAmount = this._decimalPipe.transform(
      this.cartDisplayAmount,
      "1.2-2"
    );

    //this.cartDisplayAmount = floatWith2Decimals(this.cartDisplayAmount);

    //this.consoleMessage(this.totalEmployeeShare);

    /* if (employee_selected_plans.length > 0) {
      this.showPaymenthMethod = true;
      this.showPaymenthMethod1 = false;
      this.creditcardform = true;
      sessionStorage.setItem("paymentMethod", "CC");
      this.bankpaymentmethod = "CC";

    } else {


      this.showPaymenthMethod = false;
      this.showPaymenthMethod1 = true;
      this.creditcardform = false;
      sessionStorage.setItem("paymentMethod", "NONE");
    }*/

    //console.log(this.iafgplansCheck)
    //console.log(this.iafgplansCheck.length)
    // if (employeeDealingPlans.length > 0 || this.iafgplansCheck.length > 0) {
    //   this.showPaymenthMethod = true;
    //   this.showPaymenthMethod1 = false;
    //   this.creditcardform = true;
    //   sessionStorage.setItem("paymentMethod", "CC");
    //   this.bankpaymentmethod = "CC";
    //   this.voluntryplansCheck = true
    //   // this.paymentForm.get('paymentRadioCheck')?.setValue("CC");
    // } else {
    //   this.showPaymenthMethod = false;
    //   this.showPaymenthMethod1 = true;
    //   this.creditcardform = false;
    //   this.voluntryplansCheck = false
    //   // this.bankpay =false;  //rakesh
    //   // this.paymentForm.get('paymentRadioCheck')?.setValue('');
    //   sessionStorage.setItem("paymentMethod", "NONE");
    // }

    this.directpayCCplansarr = directpayCCplans;
    this.payrollCCplansarr = payrollCCplans;
    this.companyDealingPlans = companyDealingPlans;
    this.employeeDealingPlansarr = employeeDealingPlans;

    //console.log(this.employeeDealingPlansarr)


    this.payrollCCplansarr = this.payrollCCplansarr.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });
    this.companyDealingPlans = this.companyDealingPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });
    this.companyDealingPlans = this.companyDealingPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });

    if (this.payrollCCplansarr.length > 0) {
      // this.upgradeplansCheck = true
    }
    //this.consoleMessage(this.companyDealingPlans)
    //this.consoleMessage(this.payrollCCplansarr)
    sessionStorage.setItem(
      "allSelectedPlans",
      JSON.stringify(all_selected_plans)
    );
    sessionStorage.setItem(
      "allSelectedOptPlans",
      JSON.stringify(alloptinplans)
    );
    //this.consoleMessage(all_selected_plans);
    //this.consoleMessage(company_selected_plans);

    //this.consoleMessage(company_paid_selected_plans);
    //this.consoleMessage(company_covered_selected_plans);
    //this.consoleMessage(employee_selected_plans);

    //company paid plans

    this.companySelectedPlans = company_paid_selected_plans;
    this.companyCoveredPlans = company_covered_selected_plans;
    // this.EmployeeSelectedPlans = employee_selected_plans.concat(this.iafgplansCheck);
    this.EmployeeSelectedPlans = employee_selected_plans
    this.allSelectedPlans = all_selected_plans;

    this.allSelectedPlans = this.allSelectedPlans.sort(function (a: any, b: any) {
      return a.packageId - b.packageId;
    });

    this.allPlansAmountTotal = sumBy(this.allSelectedPlans, "amount");
    //     this.allPlansAmountTotal =  this._decimalPipe.transform(
    //   this.allPlansAmountTotal,
    //   "1.2-2"
    // );
    this.allPlansTotal = sumBy(this.allSelectedPlans, "total");
    // this.allPlansTotal =  this._decimalPipe.transform(
    //   this.allPlansTotal,
    //   "1.2-2"
    // );
    this.allPlansTotaltax = sumBy(this.allSelectedPlans, "tax");
    // this.allPlansTotaltax =  this._decimalPipe.transform(
    //   this.allPlansTotaltax,
    //   "1.2-2"
    // );

    this.allCPPlansAmountTotal = sumBy(this.companySelectedPlans, "amount");
    this.allCPTaxTotal = sumBy(this.companySelectedPlans, "tax");
    this.companyPaidTotal = sumBy(this.companySelectedPlans, "total");
    //this.consoleMessage(this.companyPaidTotal);
    // this.companyPaidTotal =  this._decimalPipe.transform(
    //   this.companyPaidTotal,
    //   "1.2-2"
    // );
    //this.consoleMessage(this.companyPaidTotal);
    // for(var i=0;i<this.companySelectedPlans.length;i++){
    //   this.companyPaidTotal += this.companySelectedPlans[i].total

    //   this.companyPaidTotal = parseFloat(this._decimalPipe.transform(this.companySelectedPlans[i].total, "1.2-2"))

    // }
    // for(var i=0;i<this.companyCoveredPlans.length;i++){
    //   this.companyCoveredTotal += this.companyCoveredPlans[i].total
    //   this.companyCoveredTotal = parseFloat(this._decimalPipe.transform(this.companyCoveredTotal, "1.2-2"))

    // }
    this.allCCPlansAmountTotal = sumBy(this.companyCoveredPlans, "amount");
    this.allCCTaxTotal = sumBy(this.companyCoveredPlans, "tax");
    this.companyCoveredTotal = sumBy(this.companyCoveredPlans, "total");
    //this.consoleMessage(this.allCCPlansAmountTotal);
    //this.consoleMessage(this.allCCTaxTotal);
    //this.consoleMessage(this.companyCoveredTotal);
    this.companyCoveredCompanyShareTotal = sumBy(
      this.companyCoveredPlans,
      "companyShareTotal"
    );
    this.companyCoveredCompanySharePlanAmountTotal = sumBy(
      this.companyCoveredPlans,
      "companySharePlanAmountTotal"
    );
    this.companyCoveredCompanyShareTaxTotal = sumBy(
      this.companyCoveredPlans,
      "companyShareTaxTotal"
    );
    this.companyCoveredEmployeeShareTotal = sumBy(
      this.companyCoveredPlans,
      "employeeShareTotal"
    );
    this.companyCoveredEmployeeSharePlanAmountTotal = sumBy(
      this.companyCoveredPlans,
      "employeeSharePlanAmountTotal"
    );
    this.companyCoveredEmployeeShareTaxTotal = sumBy(
      this.companyCoveredPlans,
      "employeeShareTaxTotal"
    );

    this.payrollCCPlansAmountTotal = sumBy(payrollCCplans, "amount");
    this.payrollCCPlantaxTotal = sumBy(payrollCCplans, "tax");
    this.payrollCCPlangrandTotal = sumBy(payrollCCplans, "total");

    this.DirectCCpayPlanamountTotal = sumBy(directpayCCplans, "amount");
    this.DirectCCpayPlantaxTotal = sumBy(directpayCCplans, "tax");
    this.DirectCCpayPlangrandTotal = sumBy(directpayCCplans, "total");

    //The below includes Employee-voluntary-plans and company-covered-split with direct-pay-plans
    this.empDirectpayPlanamountTotal = sumBy(employeeDealingPlans, "amount");
    this.empDirectpayPlantaxTotal = sumBy(employeeDealingPlans, "tax");
    this.empDirectpayPlangrandTotal = sumBy(employeeDealingPlans, "total");

    //Company paid and company covered split with payroll
    this.companydealingplansTotal = sumBy(companyDealingPlans, "amount");
    this.companydealingplanstaxTotal = sumBy(companyDealingPlans, "tax");
    this.companydealingplansgrandTotal = sumBy(companyDealingPlans, "total");

    // for(var i=0;i<this.EmployeeSelectedPlans.length;i++){
    //   this.companyCoveredTotal += this.EmployeeSelectedPlans[i].total
    //   this.companyCoveredTotal = parseFloat(this._decimalPipe.transform(this.EmployeeSelectedPlans[i].total, "1.2-2"))

    // }
    //cp+cc(company)
    this.effectiveCompanyPlansAmountTotal =
      parseFloat(this.allCPPlansAmountTotal) +
      parseFloat(this.companyCoveredCompanySharePlanAmountTotal);
    this.effectiveCompanyPlansAmountTotal = this._decimalPipe.transform(
      this.effectiveCompanyPlansAmountTotal,
      "1.2-2"
    );
    this.effectiveCompanyTaxTotal =
      parseFloat(this.allCPTaxTotal) +
      parseFloat(this.companyCoveredCompanyShareTaxTotal);
    this.effectiveCompanyTaxTotal = this._decimalPipe.transform(
      this.effectiveCompanyTaxTotal,
      "1.2-2"
    );
    this.effectiveCompanyTotalContibution =
      parseFloat(this.companyPaidTotal) +
      parseFloat(this.companyCoveredCompanyShareTotal);
    this.effectiveCompanyTotalContibution = this._decimalPipe.transform(
      this.effectiveCompanyTotalContibution,
      "1.2-2"
    );


    this.allEPPlansAmountTotal = sumBy(this.EmployeeSelectedPlans, "amount");
    this.allEPTaxTotal = sumBy(this.EmployeeSelectedPlans, "tax");
    this.paidEmployeedTotal = sumBy(this.EmployeeSelectedPlans, "total");
    //this.consoleMessage(this.paidEmployeedTotal);
    // this.paidEmployeedTotal = this._decimalPipe.transform(
    //   this.paidEmployeedTotal,
    //   "1.2-2"
    // );
    // //this.consoleMessage(this.companyPaidTotal)
    // //this.consoleMessage(this.companyCoveredTotal)
    // //this.consoleMessage(this.paidEmployeedTotal)



    this.planssummarymainLife = JSON.parse(
      sessionStorage.getItem('plansummaryLife') || '[]'
    );

    //console.log(this.planssummarymainLife)
    let total: any = 0;
    for (let i = 0; i < this.planssummarymainLife.length; i++) {
      total += parseFloat(this.planssummarymainLife[i].skuTotalPrice);
    }

    //console.log(total)


    //this.consoleMessage(this.companyCoveredPlans)
    //payrollDeduction setting

    let payrollDeduction = sessionStorage.getItem("payrollDeduction")
      ? sessionStorage.getItem("payrollDeduction")
      : "EMPLOYEE_CHOICE";

    if (
      this.companyCoveredPlans.length > 0 &&
      payrollDeduction == "EMPLOYEE_CHOICE"
    ) {
      // $("payrolldeduction-modal").show()
      // jQuery("#payrolldeduction-modal").modal("show");
    }
  }
  public calculateTaxforPlan(plan: any) {
    let plandetails;
    //this.logger.log(plan)
    //this.logger.log($(`#plancheck${plan.id}`))
    for (const cpPlan of plan) {
      //this.logger.log(plan)
      for (const product1 in cpPlan.productAddonss) {

        //this.logger.log(cpPlan.productAddonss[product1][0].id)

        plandetails = $("#plancheck" + cpPlan.productAddonss[product1][0].id).attr("data");


        //this.logger.log(plandetails)
        let plandetailsobj = plandetails.split("##");

        let obj = {
          // enrollmentDate:this.datePipe.transform(
          //   this.userForm.value.planenrollmentdate,
          //   'yyyy-MM-dd'
          // ),
          enrollmentDate: sessionStorage.getItem('enrollmentdate'),

          // "name":plandetailsobj[1]+"-"+plandetailsobj[2],
          name: plandetailsobj[14],
          details: plandetailsobj[0],
          packagename: plandetailsobj[0],
          groupName: plandetailsobj[1],
          amount: parseFloat(plandetailsobj[3].replace(/\,/g, '')),
          planCoverage: plandetailsobj[2],
          planPrice: parseFloat(plandetailsobj[3].replace(/\,/g, '')),
          amountUI: "$" + parseFloat(plandetailsobj[3].replace(/\,/g, '')),
          gst:
            plandetailsobj[4] == null ||
              plandetailsobj[4] == "" ||
              plandetailsobj[4] == undefined ||
              plandetailsobj[4] == "null"
              ? 0
              : parseFloat(plandetailsobj[4]),
          hst:
            plandetailsobj[5] == null ||
              plandetailsobj[5] == "" ||
              plandetailsobj[5] == undefined ||
              plandetailsobj[5] == "null"
              ? 0
              : parseFloat(plandetailsobj[5]),
          pst:
            plandetailsobj[6] == null ||
              plandetailsobj[6] == "" ||
              plandetailsobj[6] == undefined ||
              plandetailsobj[6] == "null"
              ? 0
              : parseFloat(plandetailsobj[6]),
          qst:
            plandetailsobj[17] == null ||
              plandetailsobj[17] == "" ||
              plandetailsobj[17] == undefined ||
              plandetailsobj[17] == "null"
              ? 0
              : parseFloat(plandetailsobj[17]),
          gstCheck:
            plandetailsobj[4] == null ||
              plandetailsobj[4] == "" ||
              plandetailsobj[4] == undefined ||
              plandetailsobj[4] == "null"
              ? false
              : true,
          hstCheck:
            plandetailsobj[5] == null ||
              plandetailsobj[5] == "" ||
              plandetailsobj[5] == undefined ||
              plandetailsobj[5] == "null"
              ? false
              : true,
          pstCheck:
            plandetailsobj[6] == null ||
              plandetailsobj[6] == "" ||
              plandetailsobj[6] == undefined ||
              plandetailsobj[6] == "null"
              ? false
              : true,
          qstCheck:
            plandetailsobj[17] == null ||
              plandetailsobj[17] == "" ||
              plandetailsobj[17] == undefined ||
              plandetailsobj[17] == "null"
              ? false
              : true,
          id: parseFloat(plandetailsobj[7]),
          fusebillPlanID:
            plandetailsobj[8] == null ||
              plandetailsobj[8] == "" ||
              plandetailsobj[8] == undefined ||
              plandetailsobj[8] == "null"
              ? 0
              : parseFloat(plandetailsobj[8]),
          planFrequencyID:
            plandetailsobj[9] == null ||
              plandetailsobj[9] == "" ||
              plandetailsobj[9] == undefined ||
              plandetailsobj[9] == "null"
              ? 0
              : parseFloat(plandetailsobj[9]),
          optIn: plandetailsobj[10] == "true" ? true : false,
          planname: plandetailsobj[14],
          planLevel: parseInt(plandetailsobj[15]),
          packageId: parseInt(plandetailsobj[16]),
          options: [],
          paidByCompany1: plandetailsobj[19],
          coveredByCompany1: plandetailsobj[20],
          paidByEmployee1: plandetailsobj[21],
          planLevel_parentId: plandetailsobj[12],
          disallowedPlanLevels: plandetailsobj[11],
        };

        ////this.logger.log(obj)
        let gstprice = 0;
        let hstprice = 0;
        let pstprice = 0;
        let qstprice = 0;

        if (obj.gst > 0) {
          gstprice = obj.planPrice * obj.gst;
          obj["gstPrice"] = parseFloat(this._decimalPipe.transform(gstprice, "1.2-2"));
        } else {
          obj["gstPrice"] = 0;
        }

        if (obj.hst > 0) {
          hstprice = obj.planPrice * obj.hst;

          obj["hstPrice"] = parseFloat(this._decimalPipe.transform(hstprice, "1.2-2"));
        } else {
          obj["hstPrice"] = 0;
        }

        if (obj.pst > 0) {
          pstprice = obj.planPrice * obj.pst;
          obj["pstPrice"] = parseFloat(this._decimalPipe.transform(pstprice, "1.2-2"));
        } else {
          obj["pstPrice"] = 0;
        }

        if (obj.qst > 0) {
          qstprice = obj.planPrice * obj.qst;
          obj["qstPrice"] = parseFloat(this._decimalPipe.transform(qstprice, "1.2-2"));
        } else {
          obj["qstPrice"] = 0;
        }

        obj["taxUI"] = "";
        if (obj["gstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["gstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] += "$" + this._decimalPipe.transform(obj["gstPrice"], "1.2-2") + "&nbsp;(GST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["pstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["pstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] += "$" + this._decimalPipe.transform(obj["pstPrice"], "1.2-2") + "&nbsp;(PST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["qstCheck"]) {
          obj["taxUI"] += "<span>";
          if (obj["qstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] += "$" + this._decimalPipe.transform(obj["qstPrice"], "1.2-2") + "&nbsp;(QST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (obj["hstCheck"]) {
          obj["taxUI"] += "<span> ";
          if (obj["hstPrice"] == 0) {
            obj["taxUI"] += "-";
          } else {
            obj["taxUI"] += "$" + this._decimalPipe.transform(obj["hstPrice"], "1.2-2") + "&nbsp;(HST)";
          }
          obj["taxUI"] += "</span>";
        }

        if (!obj["hstCheck"] && !obj["gstCheck"] && !obj["pstCheck"] && !obj["qstCheck"]) {
          obj["taxUI"] += "<span>-";

          obj["taxUI"] += "</span>";
        }

        // ////this.logger.log(object["taxUI"])

        obj["tax"] = parseFloat(
          this._decimalPipe.transform(gstprice + hstprice + pstprice + qstprice, "1.2-2")
        );

        //this.logger.log(obj.planPrice);
        //this.logger.log(gstprice);
        //this.logger.log(hstprice);
        //this.logger.log(pstprice);

        //this.logger.log(qstprice);
        let pricecal = obj.planPrice + gstprice + hstprice + pstprice + qstprice;
        obj["totalPrice"] = pricecal;

        obj["totalUI"] = "$" + pricecal;

        obj["total"] = pricecal;
        //this.logger.log(obj)
        return obj;


      }

    }


  }

  public convertpackagesToPlans2(packages: { paidByCompany: any[]; }) {
    //this.consoleMessage("pacakges");
    //all_plans
    var plans: any[] = [];
    var cp_plans: any[] = [];
    var cc_plans: any[] = [];
    var ep_plans: any[] = [];

    packages?.paidByCompany.forEach((pack: { groupsCP: any[]; name: any; }, index: any) => {
      pack.groupsCP.forEach((group: { plans: any[]; parentId: any; name: any; id: any; categorization: { paidByCompany: any; coveredByCompany: any; paidByEmployee: any; companyPaidCoverage: any }; }, index1: any) => {
        group.plans.forEach((plan: { [x: string]: any; }, index2: any) => {
          if (plan) {
            plan["planLevel_parentId"] = group.parentId;
            plan["packageName"] = pack.name;
            plan["groupName"] = group.name;
            plan["groupId"] = group.id;
            plan["groupparentId"] = group.parentId;
            plan["companyPaidCoverage"] = group.categorization?.companyPaidCoverage ?? "DIRECT";
            plans.push(plan);

            if (group.categorization.paidByCompany) {
              cp_plans.push(plan);
            }
            if (group.categorization.coveredByCompany) {
              cc_plans.push(plan);
            }
            if (group.categorization.paidByEmployee) {
              ep_plans.push(plan);
            }
          } else {
            //this.consoleMessage("else");
          }
        });
      });
    });



    return [plans, cp_plans, cc_plans, ep_plans];
  }

  calculateBasePlanDeltasforCCplans(ccplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

    //console.log(ccplanspackages)
    let modifiedCCplanPackages = [];
    //console.log(baseplans)
    for (let i = 0; i < ccplanspackages?.length; i++) {
      let modifiedCCPackage = ccplanspackages[i];
      //this.consoleMessage(ccplanspackages[i].name)
      //this.consoleMessage(ccplanspackages[i].id)
      let CCplansgroups = ccplanspackages[i].groupsCC;

      modifiedCCPackage.groupsCC = [];
      for (let CCplangroup of CCplansgroups) {
        let modifiedCCgroup = CCplangroup;

        let bbCoverage = baseplans.filter((bb: any) => { return bb.packageId == modifiedCCPackage.id && bb.planLevel_parentId == modifiedCCgroup.parentId })

        let selectedCoverage = bbCoverage[0]?.companyPaidCoverage ?? "DIRECT"

        // let selectedCoverage = CCplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"

        if (selectedCoverage == "null" || selectedCoverage == "" || selectedCoverage == " ") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        //console.log(selectedCoverage)
        let CCplans = CCplangroup.plans;
        //console.log(CCplangroup)

        modifiedCCgroup.plans = [];
        for (let CCplan of CCplans) {
          let modifiedCCplan = CCplan;
          //this.consoleMessage(CCplan.id);
          //this.consoleMessage(CCplan.isBundle);
          //this.consoleMessage(CCplan.name);

          CCplan.planLevel_parentId = CCplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CCplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CCplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          let selectedCCplanProductarray = CCplan.productAddonss[CCplan.name];
          console.log(CCplan)
          console.log(CCplan.productAddonss[CCplan.name])

          if (CCplan.isBundle) {
            //this.consoleMessage("BundlePlan")

            //this.consoleMessage(baseplans)
            //console.log(baseplans)
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {



              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {
              //this.consoleMessage(plan)
              //cp_plans

              //this.consoleMessage(CCplan.packageId,plan.packageId)
              //this.consoleMessage(CCplan.planLevel_parentId,plan.planLevel_parentId)
              //this.consoleMessage(CCplan.planLevel,plan.planLevel)

              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            //this.consoleMessage(filtered_base_plans);

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray: any = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];


            //console.log("length" + filtered_base_plans.length)
            //console.log(filtered_base_plans)
            //console.log(filtered_compnay_plans)

            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {


              var filtered_base_plans2 = filtered_base_plans.filter(function (plan: { id: any; }) {
                return (
                  CCplan.id == plan.id
                );
              });
              var filtered_compnay_plans2 = filtered_compnay_plans.filter(function (plan: { id: any; }) {


                return (
                  CCplan.id == plan.id
                );
              });
              selectedBasePlan = filtered_base_plans2[0];
              selectedCompnayPlan = filtered_compnay_plans2[0];
            }

            //console.log(selectedBasePlan)
            //console.log(selectedCompnayPlan)
            //console.log("name" + selectedBasePlan?.name)
            if (selectedBasePlan) {
              // //this.consoleMessage(selectedBasePlan)
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = selectedBasePlan.productAddonss[selectedBasePlan.name];
              let selectedBaseplanProductsArray2 = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                  selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                }

                let remainigProdcuts = selectedCCplanProductarray.length - selectedBaseplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray2[selectedBaseplanProductsArray2.length - 1]);
                  }
                }
                selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                // Direct Coverage Method
                // setTimeout(() => {
                if (selectedCoverage == "DIRECT") {
                  selectedBaseplanProductsArray = this.DirectCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                  //console.log(selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedBaseplanProductsArray = this.selectiveSingleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedBaseplanProductsArray = this.selectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedBaseplanProductsArray = this.selectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedBaseplanProductsArray)
                }

                //console.log(selectedBaseplanProductsArray)
                // }, 1000)

                // let productCoverageFound = false;
                // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                //   for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

                //     if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
                //       productCoverageFound = true
                //       selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
                //       break;
                //     }


                //   }
                //   if (!productCoverageFound) {



                //     selectedBasePlan = {};
                //     selectedBaseplanProduct = {};
                //     selectedBaseplanProduct.calculatedTax = {};
                //     selectedBaseplanProduct.calculatedTax.price = 0;
                //     selectedBaseplanProduct.calculatedTax.tax = 0;
                //     selectedBaseplanProduct.calculatedTax.total = 0;
                //     selectedBaseplanProduct.name = "NA";
                //     selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                //     selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



                //   }

                // }
                // //this.consoleMessage(selectedBaseplanProductsArray)
                // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                //this.consoleMessage(selectedBaseplanProductsArray)
              }
            }
            else {
              //console.log("elseStatement")
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }


            //console.log(selectedBaseplanProductsArray)
            if (selectedCompnayPlan) {
              // selectedCompanyplanProduct = selectedCompnayPlan.productAddonss[selectedCompnayPlan.name][0]
              selectedCompanyplanProductsArray =
                selectedCompnayPlan.productAddonss[selectedCompnayPlan.name];
              // //this.consoleMessage(selectedCompanyplanProductsArray)
              // //this.consoleMessage(selectedCompnayPlan.name)

              let selectedCompanyplanProductsArray2 = [];

              if (CCplan.packageId == 5 || CCplan.packageId == 10) {
                selectedCompanyplanProductsArray2 = selectedCompanyplanProductsArray
                for (let i = 0; i < selectedCCplanProductarray.length - selectedCompanyplanProductsArray.length; i++) {
                  selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[selectedCompanyplanProductsArray.length - 1]);
                }
                //this.consoleMessage(selectedCompanyplanProductsArray)

                let remainigProdcuts = selectedCCplanProductarray.length - selectedCompanyplanProductsArray2.length
                // //this.consoleMessage(selectedBaseplanProductsArray)

                if (remainigProdcuts > 0) {
                  for (let i = 0; i < remainigProdcuts; i++) {
                    selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray2[selectedCompanyplanProductsArray2.length - 1]);
                  }
                }
                selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2
                //this.consoleMessage(selectedCompanyplanProductsArray)

              }
              else {

                //console.log(selectedCCplanProductarray)
                // let productCoverageFound = false;
                // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                //   for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

                //     if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
                //       productCoverageFound = true
                //       selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
                //       break;
                //     }


                //   }
                //   if (!productCoverageFound) {


                //     selectedCompanyplanProduct = {};
                //     selectedCompanyplanProduct.calculatedTax = {};
                //     selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
                //     selectedCompanyplanProduct.name = "NA";
                //     selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
                //     selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



                //   }

                // }
                // selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

                // // setTimeout(() => {
                if (selectedCoverage == "DIRECT") {
                  selectedCompanyplanProductsArray = this.CompanyDirectCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                  //console.log(selectedBaseplanProductsArray)
                }

                // Selective single Coverage Method
                if (selectedCoverage == "SINGLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                // Selective Couple Coverage Method

                if (selectedCoverage == "COUPLE") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }
                //  // Selective Family Coverage Method
                if (selectedCoverage == "FAMILY") {
                  selectedCompanyplanProductsArray = this.CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray, selectedCompanyplanProductsArray)
                }


                // // }, 1000)


                //console.log(selectedCompanyplanProductsArray)


              }


            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }
              //console.log(selectedCompanyplanProductsArray)
              //this.consoleMessage(selectedCompanyplanProductsArray)
            }


            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCCplan.products = []



            for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              //console.log(selectedBaseplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];
              let selectedCCplanProduct = selectedCCplanProductarray[i];
              //console.log(selectedCCplanProduct)
              //console.log(selectedCompanyplanProductsArray[i])
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos
                  .length > 0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );


              let employeeTax =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );
              //console.log(deltaplanPrice)


              //console.log(selectedBaseplanProduct.calculatedTax.price)

              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                // companyTax = employeeTax
                companyTax = 0  ////when there is no base planproduct
                // companyTaxPercentage = employeeTaxPercentage
                companyTaxPercentage = "0%" //when there is no base planproduct

              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice < 0) {
                deltaplanPrice = 0
                baseplanPrice = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.price
                );
                baseplanTaxorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.tax
                );
                baseplanTax = adjustWith2DecimalsForUI(
                  baseplanPrice * companyTax
                );
                baseplanTotalorg = adjustWith2DecimalsForUI(
                  selectedCCplanProduct.calculatedTax.total
                );
                baseplanTotal = adjustWith2DecimalsForUI(
                  baseplanPrice + baseplanTax
                );
              }
              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice *
              //   (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
              let planName = `${CCplan.name} (${upgradeText})`;
              let compnayShareStatement = `${CCplan.name} Contribution`;
              let employeeShareStatement = `${CCplan.name} upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                selectedCoverage
              };

              //this.consoleMessage(obj)

              console.log(obj)
              let ccProduct: any = {}
              ccProduct.upgradeCalculation = obj;
              modifiedCCplan.products.push(ccProduct)
              modifiedCCplan.upgradeCalculation = obj;


            }
            modifiedCCgroup.plans.push(modifiedCCplan);

          }
          else {
            let selectedCCplanNamearray = Object.keys(CCplan.productAddonss)

            let selectedCCplanProductarray: any = []
            for (let name of selectedCCplanNamearray) {
              selectedCCplanProductarray = selectedCCplanProductarray.concat(CCplan.productAddonss[name])
            }
            var filtered_base_plans = baseplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            var filtered_compnay_plans = compnayplans.filter(function (plan: { packageId: any; planLevel_parentId: any; planLevel: number; productAddonss: any }) {


              return (
                CCplan.packageId == plan.packageId &&
                CCplan.planLevel_parentId == plan.planLevel_parentId &&
                CCplan.planLevel >= plan.planLevel &&
                plan.productAddonss && JSON.stringify(plan.productAddonss).length > 2
              );
            });

            //this.consoleMessage(filtered_base_plans)

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            console.log("length" + filtered_base_plans.length)
            console.log(filtered_base_plans)
            console.log(filtered_compnay_plans)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 1) {
              selectedBasePlan = filtered_base_plans[0];
              selectedCompnayPlan = filtered_compnay_plans[0];
            } else {
              //this.consoleMessage(filtered_base_plans.length)

            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray = []
            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                console.log(planname)
                console.log(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  selectedBaseplanProductsArray.push(products[0]);

                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  selectedbaseplanproduct = products[products.length - 1]; //

                  for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                    selectedBaseplanProductsArray.push(products[i]);
                  }
                  /* Added for in the case of medacan year roudn care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                  console.log(products.length)
                }
              }
              console.log(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.tax)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.total)
            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";


              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }

            let CCplanProduct;
            let CCproductslength

            for (let planname in CCplan.productAddonss) {
              let products = CCplan.productAddonss[planname];
              CCproductslength = products.length
              console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
                // selectedCompnayPlan= filtered_compnay_plans[0]
              } else {
                CCplanProduct = products[products.length - 1]; //
                /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                Selecting last product(highest) in this case */
                //this.consoleMessage(products.length)
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray = []

            if (selectedCompnayPlan) {
              for (let planname in selectedCompnayPlan.productAddonss) {
                //this.consoleMessage(planname)
                //this.consoleMessage(selectedCompnayPlan.productAddonss[planname])
                let products = selectedCompnayPlan.productAddonss[planname];

                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedcompanyplanproduct = products[0];
                  selectedCompanyplanProductsArray.push(
                    products[0]
                  );
                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  selectedcompanyplanproduct = products[products.length - 1]; //
                  for (let i = 0; i < products.length; i++) {
                    selectedCompanyplanProductsArray.push(
                      products[i]
                    );
                  }

                  /* Added for in the case of medacan year M care as base plan and with two products one is Individual(single) and(Family)
                  Selecting last product(highest) in this case */
                }
              }
              selectedCompanyplanProduct = selectedcompanyplanproduct;
              // for (let i = 0; i < selectedCCplanProductarray.length; i++) {
              //   selectedCompanyplanProductsArray.push(
              //     selectedCompanyplanProduct
              //   );
              // }
              //this.consoleMessage("CompanyTax")
              //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRate:0)
              //this.consoleMessage(selectedCompanyplanProduct.calculatedTax.planProductInfos.length>0?selectedCompanyplanProduct.calculatedTax.planProductInfos[0].taxRatePercentage:0)
            } else {
              selectedCompanyplanProduct = {};
              selectedCompanyplanProduct.calculatedTax = {};
              selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
              console.log(selectedCCplanProductarray)
              console.log(selectedCompanyplanProduct)
              for (let i = 0; i < selectedCCplanProductarray.length; i++) {
                selectedCompanyplanProductsArray.push(
                  selectedCompanyplanProduct
                );
              }


            }

            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }



            if (CCproductslength == 1) {
              modifiedCCplan = this.singleCCCoverageProduct(selectedCompanyplanProduct, selectedBaseplanProduct, selectedCCplanProduct, CCplan, upgradeText, payroll, selectedBasePlan, upgradepaymentText, modifiedCCplan)

            }
            else {
              modifiedCCplan = this.multipleCCCoverageProduct(selectedCCplanProductarray, selectedBaseplanProductsArray, selectedCompanyplanProductsArray, selectedBasePlan, CCplan, upgradeText, payroll, upgradepaymentText, selectedCoverage, modifiedCCplan)

            }
            modifiedCCgroup.plans.push(modifiedCCplan);
          }
          //           modifiedCCgroup.plans = Array.from(new Set(modifiedCCgroup.plans.map((item:any) => JSON.stringify(item)))
          // ).map((str:any) => JSON.parse(str));
          modifiedCCPackage.groupsCC.push(modifiedCCgroup);
        }

        modifiedCCplanPackages.push(modifiedCCPackage);
      }
      modifiedCCplanPackages = Array.from(new Set(modifiedCCplanPackages.map((item: any) => JSON.stringify(item)))
      ).map((str: any) => JSON.parse(str));
      this.modifiedBlocksCoveredByCompany = modifiedCCplanPackages;

      console.log(this.modifiedBlocksCoveredByCompany)
    }
  }
  public singleCCCoverageProduct(selectedCompanyplanProduct: any, selectedBaseplanProduct: any, selectedCCplanProduct: any, CCplan: any, upgradeText: any, payroll: any, selectedBasePlan: any, upgradepaymentText: any, modifiedCCplan: any) {
    let companyTax =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let companyTaxPercentage =
      selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
        0
        ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;
    let baseplanPrice = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.price
    );
    let baseplanTaxorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.tax
    );
    let baseplanTax = adjustWith2DecimalsForUI(
      baseplanPrice * companyTax
    );
    let baseplanTotalorg = adjustWith2DecimalsForUI(
      selectedBaseplanProduct.calculatedTax.total
    );
    let baseplanTotal = adjustWith2DecimalsForUI(
      baseplanPrice + baseplanTax
    );
    let employeeTax =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRate
        : 0;
    let employeeTaxPercentage =
      selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
        ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
          .taxRatePercentage
        : 0;

    let deltaplanPrice = adjustWith2DecimalsForUI(
      selectedCCplanProduct.calculatedTax.price -
      selectedBaseplanProduct.calculatedTax.price
    );

    //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
    //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
    //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
    if (selectedBaseplanProduct.name == 'NA') {
      //this.consoleMessage("No Base plan/product for this upgrade plans/product")
      companyTax = employeeTax
      companyTaxPercentage = employeeTaxPercentage
    }
    let deltaplanTax = adjustWith2DecimalsForUI(
      deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
    );
    // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

    let deltaplanTotal = adjustWith2DecimalsForUI(
      deltaplanPrice + deltaplanTax
    );

    let combinedplanPrice = baseplanPrice + deltaplanPrice;
    let combinedplanbasePrice = baseplanPrice;
    let combinedplanDeltaprice = deltaplanPrice;
    let combinedplanTax = adjustWith2DecimalsForUI(
      baseplanTax + deltaplanTax
    );
    let combinedplanCompanyTax = baseplanTax;
    let combinedplanEmployeeTax =
      adjustWith2DecimalsForUI(deltaplanTax);
    let combinedplanCompanyTaxPercentage = companyTaxPercentage;
    let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
      ? companyTaxPercentage
      : employeeTaxPercentage;
    let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
    let combinedplanTotal = adjustWith2DecimalsForUI(
      baseplanTotal + deltaplanTotal
    );

    let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
    let planName = `${CCplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
    let compnayShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) Contribution`;
    let employeeShareStatement = `${CCplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
    let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
    let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
    let type;

    if (payroll) {
      type = "Split with payroll deduction";
    } else {
      type = "Split with direct pay";
    }
    let basePlanDetails = {
      planId: selectedBasePlan.id || 0, //0
      planName: selectedBasePlan.name || "NA", //NA
      planLevelId: selectedBasePlan.planLevel || 0, //0
      amount: baseplanPrice || 0, //0
      amountUI: `$${baseplanPrice}` || 0, //0
      tax: baseplanTax,
      total: baseplanTotal,
      taxUI: `$${baseplanTax}`, //companyTaxpercentage
      totalUI: `$${baseplanTotal}`,
      planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
      planFrequencyID: selectedBasePlan.frqMonthly || "",
      planFusebillID: selectedBasePlan.fusebillId || "",
      products: [selectedBaseplanProduct],
      planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
      packageName: selectedBasePlan.packageName || "",
      packageId: selectedBasePlan.packageId || 0,
    };
    let obj = {
      companyTax,
      companyTaxPercentage,
      baseplanPrice,
      baseplanTaxorg,
      baseplanTax,
      baseplanTotalorg,
      baseplanTotal,
      employeeTax,
      employeeTaxPercentage,
      deltaplanPrice,
      deltaplanTax,
      deltaplanTotal,
      combinedplanPrice,
      combinedplanbasePrice,
      combinedplanDeltaprice,
      combinedplanTax,
      combinedplanCompanyTax,
      combinedplanEmployeeTax,
      combinedplanCompanyTaxPercentage,
      combinedplanemployeeTaxPercentage,
      combinedplanTotal,
      payroll,
      scenario,
      planName,
      compnayShareStatement,
      employeeShareStatement,
      planDescription,
      planDescription2,
      type,
      basePlanDetails,
      combinedplanemployeeTaxPercentageorg,
    };

    console.log(obj)
    modifiedCCplan.upgradeCalculation = obj;
    return modifiedCCplan
  }

  public multipleCCCoverageProduct(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCompanyplanProductsArray: any, selectedBasePlan: any, CCplan: any, upgradeText: any, payroll: any, upgradepaymentText: any, selectedCoverage: any, modifiedCCplan: any) {

    console.log(selectedCCplanProductarray)
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
      console.log(selectedBaseplanProduct)
      let selectedCompanyplanProduct =
        selectedCompanyplanProductsArray[i];
      let selectedCCplanProduct = selectedCCplanProductarray[i];
      console.log(selectedCCplanProduct)
      console.log(selectedCompanyplanProductsArray[i])
      let companyTax =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let companyTaxPercentage =
        selectedCompanyplanProduct.calculatedTax.planProductInfos
          .length > 0
          ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;

      let baseplanPrice = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.price
      );
      let baseplanTaxorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.tax
      );
      let baseplanTax = adjustWith2DecimalsForUI(
        baseplanPrice * companyTax
      );
      let baseplanTotalorg = adjustWith2DecimalsForUI(
        selectedBaseplanProduct.calculatedTax.total
      );
      let baseplanTotal = adjustWith2DecimalsForUI(
        baseplanPrice + baseplanTax
      );


      let employeeTax =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRate
          : 0;
      let employeeTaxPercentage =
        selectedCCplanProduct?.calculatedTax?.planProductInfos.length > 0
          ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
            .taxRatePercentage
          : 0;
      let deltaplanPrice = adjustWith2DecimalsForUI(
        selectedCCplanProduct.calculatedTax.price -
        selectedBaseplanProduct.calculatedTax.price
      );
      //console.log(deltaplanPrice)


      //console.log(selectedBaseplanProduct.calculatedTax.price)

      if (selectedBaseplanProduct.name == 'NA') {
        //this.consoleMessage("No Base plan/product for this upgrade plans/product")
        // companyTax = employeeTax
        companyTax = 0  ////when there is no base planproduct
        // companyTaxPercentage = employeeTaxPercentage
        companyTaxPercentage = "0%" //when there is no base planproduct

      }
      //Delete plan Total Price and Total Combination
      if (deltaplanPrice < 0) {
        deltaplanPrice = 0
        baseplanPrice = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.price
        );
        baseplanTaxorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.tax
        );
        baseplanTax = adjustWith2DecimalsForUI(
          baseplanPrice * companyTax
        );
        baseplanTotalorg = adjustWith2DecimalsForUI(
          selectedCCplanProduct.calculatedTax.total
        );
        baseplanTotal = adjustWith2DecimalsForUI(
          baseplanPrice + baseplanTax
        );
      }
      // let deltaplanTax = adjustWith2DecimalsForUI(
      //   deltaplanPrice *
      //   (this.deltaCompanyTax ? companyTax : employeeTax)
      // );
      let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);

      let deltaplanTotal = adjustWith2DecimalsForUI(
        deltaplanPrice + deltaplanTax
      );
      let combinedplanPrice = adjustWith2DecimalsForUI(
        baseplanPrice + deltaplanPrice
      );
      let combinedplanbasePrice = baseplanPrice;
      let combinedplanDeltaprice = deltaplanPrice;
      let combinedplanTax = adjustWith2DecimalsForUI(
        baseplanTax + deltaplanTax
      );
      let combinedplanCompanyTax = baseplanTax;
      let combinedplanEmployeeTax =
        adjustWith2DecimalsForUI(deltaplanTax);
      let combinedplanCompanyTaxPercentage = companyTaxPercentage;
      let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
        ? companyTaxPercentage
        : employeeTaxPercentage;
      let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

      let combinedplanTotal = adjustWith2DecimalsForUI(
        baseplanTotal + deltaplanTotal
      );

      let scenario = `Employee Upgrade from ${selectedBasePlan.name} to ${CCplan.name}`;
      let planName = `${CCplan.name} (${upgradeText})`;
      let compnayShareStatement = `${CCplan.name} Contribution`;
      let employeeShareStatement = `${CCplan.name} upgrade cost`;
      let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
      let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
      let type;

      if (payroll) {
        type = "Split with payroll deduction";
      } else {
        type = "Split with direct pay";
      }
      let basePlanDetails = {
        planId: selectedBasePlan.id, //0
        planName: selectedBasePlan.name, //NA
        planLevelId: selectedBasePlan.planLevel, //0
        amount: baseplanPrice, //0
        amountUI: `$${baseplanPrice}`, //0
        tax: baseplanTax,
        total: baseplanTotal,
        taxUI: `$${baseplanTax}`, //companyTaxpercentage
        totalUI: `$${baseplanTotal}`,
        planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
        planFrequencyID: selectedBasePlan.frqMonthly || "",
        planFusebillID: selectedBasePlan.fusebillId || "",
        products: [selectedBaseplanProduct],
        planLevel_parentId: selectedBasePlan.planLevel_parentId,
        packageName: selectedBasePlan.packageName,
        packageId: selectedBasePlan.packageId,
      };





      let obj = {
        companyTax,
        companyTaxPercentage,
        baseplanPrice,
        baseplanTaxorg,
        baseplanTax,
        baseplanTotalorg,
        baseplanTotal,
        employeeTax,
        employeeTaxPercentage,
        deltaplanPrice,
        deltaplanTax,
        deltaplanTotal,
        combinedplanPrice,
        combinedplanbasePrice,
        combinedplanDeltaprice,
        combinedplanTax,
        combinedplanCompanyTax,
        combinedplanEmployeeTax,
        combinedplanCompanyTaxPercentage,
        combinedplanemployeeTaxPercentage,
        combinedplanTotal,
        payroll,
        scenario,
        planName,
        compnayShareStatement,
        employeeShareStatement,
        planDescription,
        planDescription2,
        type,
        basePlanDetails,
        combinedplanemployeeTaxPercentageorg,
        selectedCoverage
      };

      //this.consoleMessage(obj)

      console.log(obj)

      if (modifiedCCplan.products) {

      } else {
        modifiedCCplan.products = []
      }
      let ccProduct: any = {}
      ccProduct.upgradeCalculation = obj;
      modifiedCCplan.products.push(ccProduct)
      modifiedCCplan.upgradeCalculation = obj;

      //console.log(modifiedCCplan)
    }

    return modifiedCCplan
  }
  // calculateBasePlanCPplans(cpplanspackages: string | any[], baseplans: any[], compnayplans: any[]) {

  //   //console.log(cpplanspackages)


  //   let modifiedCPplanPackages: any = [];
  //   for (let i = 0; i < cpplanspackages?.length; i++) {
  //     let modifiedCPPackage = cpplanspackages[i];

  //     let CPplansgroups = cpplanspackages[i].groupsCP;

  //     modifiedCPPackage.groupsCP = [];
  //     for (let CPplangroup of CPplansgroups) {
  //       let modifiedCPgroup = CPplangroup;
  //       let selectedCoverage = CPplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"
  //       if (selectedCoverage == "null") {
  //         selectedCoverage = "DIRECT"
  //       }
  //       if (selectedCoverage != "DIRECT") {
  //         selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
  //       }

  //       //console.log(selectedCoverage)


  //       if (selectedCoverage == "DIRECT") {
  //         modifiedCPPackage.groupsCP.push(modifiedCPgroup)
  //         if (modifiedCPPackage.groupsCP.length == CPplansgroups.length) {
  //           modifiedCPplanPackages.push(modifiedCPPackage)
  //         }
  //         continue;
  //       }
  //       let CPplans = CPplangroup.plans;

  //       //console.log(CPplangroup)

  //       modifiedCPgroup.plans = [];
  //       baseplans = []
  //       for (let CPplan of CPplans) {
  //         let modifiedCPplan = CPplan;


  //         CPplan.planLevel_parentId = CPplangroup.parentId;

  //         let payroll = true;
  //         let EmployeeChoice = 0;

  //         if (
  //           this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CPplan.packageId)
  //         ) {
  //           if (EmployeeChoice == 2) {
  //             payroll = false;
  //           }
  //         } else {
  //           if (
  //             this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
  //               CPplan.planLevel
  //             )
  //           ) {
  //             if (EmployeeChoice == 2) {
  //               payroll = false;
  //             }
  //           }
  //         }
  //         console.log(CPplan)
  //         let selectedCPplanProductarray = CPplan.productAddonss[CPplan.name];
  //         //console.log(CPplan)
  //         //console.log(CPplan.productAddonss[CPplan.name])


  //         for (let i = 0; i < selectedCPplanProductarray.length; i++) {

  //           for (let j = 0; j < selectedCPplanProductarray.length; j++) {
  //             if (selectedCPplanProductarray[i].planCoverage == selectedCoverage) {

  //               baseplans.push(selectedCPplanProductarray[i])
  //             }

  //           }

  //         }

  //         if (CPplan.isBundle) {

  //           //console.log(baseplans)
  //           var filtered_base_plans = baseplans



  //           //this.consoleMessage(filtered_base_plans);

  //           //this.consoleMessage(filtered_compnay_plans)
  //           let selectedBasePlan;
  //           let selectedCompnayPlan;
  //           let DeltaPlan;
  //           let selectedBaseplanProduct: any;
  //           let selectedBaseplanProductsArray = [];
  //           let selectedCompanyplanProduct: any;
  //           let selectedCompanyplanProductsArray: any = [];

  //           //console.log("length" + filtered_base_plans.length)

  //           selectedBasePlan = filtered_base_plans[0];

  //           //console.log(selectedBasePlan)

  //           if (selectedBasePlan) {
  //             // //this.consoleMessage(selectedBasePlan)
  //             // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
  //             selectedBaseplanProductsArray = [selectedBasePlan];
  //             let selectedBaseplanProductsArray2 = [];
  //             //  //this.consoleMessage(CCplan.packageId)
  //             if (CPplan.packageId == 5 || CPplan.packageId == 10) {

  //               // selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
  //               // for (let i = 0; i < selectedCPplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
  //               //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
  //               // }
  //               // // //this.consoleMessage(selectedBaseplanProductsArray)
  //               // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
  //               // //this.consoleMessage(selectedBaseplanProductsArray)
  //             }
  //             else {

  //               // Direct Coverage Method

  //               // selectedBaseplanProductsArray =this.DirectCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)


  //               // Selective single Coverage Method

  //               //  selectedBaseplanProductsArray =this.selectiveSingleCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)

  //               // Selective Couple Coverage Method
  //               if (selectedCoverage != "DIRECT") {
  //                 selectedBaseplanProductsArray = this.selectiveCPCoverageMethod(selectedCPplanProductarray, selectedBaseplanProductsArray, selectedCoverage)
  //               }
  //               //  // Selective Family Coverage Method


  //             }
  //           }
  //           else {
  //             selectedBasePlan = {};
  //             selectedBaseplanProduct = {};
  //             selectedBaseplanProduct.calculatedTax = {};
  //             selectedBaseplanProduct.calculatedTax.price = 0;
  //             selectedBaseplanProduct.calculatedTax.tax = 0;
  //             selectedBaseplanProduct.calculatedTax.total = 0;
  //             selectedBaseplanProduct.name = "NA";

  //             for (let i = 0; i < selectedCPplanProductarray.length; i++) {
  //               selectedBaseplanProductsArray.push(selectedBaseplanProduct);
  //             }
  //           }



  //           let upgradeText;
  //           let upgradepaymentText;
  //           if (payroll) {
  //             upgradeText = "Employee upgraded using payroll deduction";
  //             upgradepaymentText = "using payroll deduction";
  //             //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
  //           } else {
  //             upgradeText = "Employee upgraded using Direct payment";
  //             upgradepaymentText = "using Direct payment";
  //           }

  //           modifiedCPplan.products = []

  //           for (let i = 0; i < selectedCPplanProductarray.length; i++) {
  //             let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
  //             //console.log(selectedBaseplanProduct)
  //             let selectedCPplanProduct = selectedCPplanProductarray[i];
  //             //console.log(selectedCPplanProduct)
  //             let coverage = selectedCPplanProduct.planCoverage


  //             if (selectedCoverage == coverage) {

  //               modifiedCPplan.products.push(selectedCPplanProduct)
  //               continue;
  //             }

  //             //console.log(selectedCPplanProduct)
  //             let selectedCompanyplanProduct =
  //               selectedCompanyplanProductsArray[i];


  //             let companyTax =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let companyTaxPercentage =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;

  //             let baseplanPrice = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             let baseplanTaxorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.tax
  //             );
  //             let baseplanTax = adjustWith2DecimalsForUI(
  //               baseplanPrice * companyTax
  //             );
  //             let baseplanTotalorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.total
  //             );
  //             let baseplanTotal = adjustWith2DecimalsForUI(
  //               baseplanPrice + baseplanTax
  //             );



  //             let employeeTax =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let employeeTaxPercentage =
  //               selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
  //                 ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;
  //             let deltaplanPrice = adjustWith2DecimalsForUI(
  //               selectedCPplanProduct.calculatedTax.price -
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             //console.log(deltaplanPrice)


  //             //console.log(selectedBaseplanProduct.calculatedTax.price)

  //             if (selectedBaseplanProduct.name == 'NA') {
  //               //this.consoleMessage("No Base plan/product for this upgrade plans/product")
  //               companyTax = employeeTax
  //               companyTaxPercentage = employeeTaxPercentage
  //             }
  //             //Delete plan Total Price and Total Combination
  //             if (deltaplanPrice <= 0) {
  //               deltaplanPrice = 0
  //               /*      baseplanPrice = adjustWith2DecimalsForUI(
  //                     selectedCPplanProduct.calculatedTax.price
  //                   );
  //                    baseplanTaxorg = adjustWith2DecimalsForUI(
  //                     selectedCPplanProduct.calculatedTax.tax
  //                   );
  //                    baseplanTax = adjustWith2DecimalsForUI(
  //                     baseplanPrice * companyTax
  //                   );
  //                    baseplanTotalorg = adjustWith2DecimalsForUI(
  //                     selectedCPplanProduct.calculatedTax.total
  //                   );
  //                    baseplanTotal = adjustWith2DecimalsForUI(
  //                     baseplanPrice + baseplanTax
  //                   ); */

  //               modifiedCPplan.products.push(selectedCPplanProduct)
  //               continue;

  //             }


  //             let deltaplanTax = adjustWith2DecimalsForUI(
  //               deltaplanPrice *
  //               (this.deltaCompanyTax ? companyTax : employeeTax)
  //             );
  //             let deltaplanTotal = adjustWith2DecimalsForUI(
  //               deltaplanPrice + deltaplanTax
  //             );
  //             let combinedplanPrice = adjustWith2DecimalsForUI(
  //               baseplanPrice + deltaplanPrice
  //             );
  //             let combinedplanbasePrice = baseplanPrice;
  //             let combinedplanDeltaprice = deltaplanPrice;
  //             let combinedplanTax = adjustWith2DecimalsForUI(
  //               baseplanTax + deltaplanTax
  //             );
  //             let combinedplanCompanyTax = baseplanTax;
  //             let combinedplanEmployeeTax =
  //               adjustWith2DecimalsForUI(deltaplanTax);
  //             let combinedplanCompanyTaxPercentage = companyTaxPercentage;
  //             let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
  //               ? companyTaxPercentage
  //               : employeeTaxPercentage;
  //             let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

  //             let combinedplanTotal = adjustWith2DecimalsForUI(
  //               baseplanTotal + deltaplanTotal
  //             );

  //             let scenario = `Employee Upgrade from ${selectedBasePlan.name}  (${selectedCoverage}) to ${CPplan.name}`;
  //             let planName = `${CPplan.name} (${this.capitalize(coverage)}) (${upgradeText})`;
  //             let compnayShareStatement = `${CPplan.name} (${this.capitalize(selectedCoverage)})  Contribution`;
  //             let employeeShareStatement = `${CPplan.name} (${this.capitalize(coverage)}) upgrade cost`;
  //             let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
  //             let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
  //             let type;

  //             if (payroll) {
  //               type = "Split with payroll deduction";
  //             } else {
  //               type = "Split with direct pay";
  //             }
  //             let basePlanDetails = {
  //               planId: selectedBasePlan.id, //0
  //               planName: selectedBasePlan.name, //NA
  //               planLevelId: selectedBasePlan.planLevel, //0
  //               amount: baseplanPrice, //0
  //               amountUI: `$${baseplanPrice}`, //0
  //               tax: baseplanTax,
  //               total: baseplanTotal,
  //               taxUI: `$${baseplanTax}`, //companyTaxpercentage
  //               totalUI: `$${baseplanTotal}`,
  //               planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
  //               planFrequencyID: selectedBasePlan.frqMonthly || "",
  //               planFusebillID: selectedBasePlan.fusebillId || "",
  //               products: [selectedBaseplanProduct],
  //               planLevel_parentId: selectedBasePlan.planLevel_parentId,
  //               packageName: selectedBasePlan.packageName,
  //               packageId: selectedBasePlan.packageId,
  //             };





  //             let obj = {
  //               companyTax,
  //               companyTaxPercentage,
  //               baseplanPrice,
  //               baseplanTaxorg,
  //               baseplanTax,
  //               baseplanTotalorg,
  //               baseplanTotal,
  //               employeeTax,
  //               employeeTaxPercentage,
  //               deltaplanPrice,
  //               deltaplanTax,
  //               deltaplanTotal,
  //               combinedplanPrice,
  //               combinedplanbasePrice,
  //               combinedplanDeltaprice,
  //               combinedplanTax,
  //               combinedplanCompanyTax,
  //               combinedplanEmployeeTax,
  //               combinedplanCompanyTaxPercentage,
  //               combinedplanemployeeTaxPercentage,
  //               combinedplanTotal,
  //               payroll,
  //               scenario,
  //               planName,
  //               compnayShareStatement,
  //               employeeShareStatement,
  //               planDescription,
  //               planDescription2,
  //               type,
  //               basePlanDetails,
  //               combinedplanemployeeTaxPercentageorg,
  //               coverage,
  //               selectedCoverage
  //             };

  //             //this.consoleMessage(obj)

  //             //console.log(selectedCoverage)
  //             //console.log(coverage)

  //             //console.log(obj)
  //             let cpProduct: any = {}
  //             cpProduct.upgradeCalculation = obj;
  //             modifiedCPplan.products.push(cpProduct)
  //             // modifiedCPplan.upgradeCalculation = obj;

  //             // if(selectedCoverage == coverage){

  //             // }else{
  //             //   cpProduct.upgradeCalculation = obj;
  //             //   modifiedCPplan.products.push(cpProduct)
  //             // }

  //             //console.log(modifiedCPplan)
  //           }

  //         }
  //         else {
  //           //this.consoleMessage("Not a BundlePlan")

  //           //this.consoleMessage(baseplans)



  //           filtered_base_plans = baseplans

  //           let selectedBasePlan;
  //           let selectedCompnayPlan;
  //           let DeltaPlan;
  //           //console.log("length" + filtered_base_plans.length)
  //           if (filtered_base_plans.length == 0) {
  //           } else if (filtered_base_plans.length == 0) {
  //             selectedBasePlan = filtered_base_plans[0];
  //           } else {
  //             //this.consoleMessage(filtered_base_plans.length)
  //           }

  //           let selectedbaseplanproduct: any;
  //           let selectedBaseplanProduct: any;

  //           if (selectedBasePlan) {
  //             for (let planname in selectedBasePlan.productAddonss) {
  //               //this.consoleMessage(planname)
  //               //this.consoleMessage(selectedBasePlan.productAddonss[planname])
  //               let products = selectedBasePlan.productAddonss[planname];
  //               //console.log("length" + products.length)
  //               if (products.length == 0) {
  //               } else if (products.length == 1) {
  //                 selectedbaseplanproduct = products[0];
  //                 // selectedCompnayPlan= filtered_compnay_plans[0]
  //               } else {
  //                 //this.consoleMessage(products.length)
  //               }
  //             }
  //             //this.consoleMessage(selectedbaseplanproduct)
  //             selectedBaseplanProduct = selectedbaseplanproduct;

  //           } else {
  //             selectedBasePlan = {};
  //             selectedBaseplanProduct = {};
  //             selectedBaseplanProduct.calculatedTax = {};
  //             selectedBaseplanProduct.calculatedTax.price = 0;
  //             selectedBaseplanProduct.calculatedTax.tax = 0;
  //             selectedBaseplanProduct.calculatedTax.total = 0;
  //             selectedBaseplanProduct.name = "NA";
  //           }

  //           let CCplanProduct;

  //           for (let planname in CPplan.productAddonss) {
  //             let products = CPplan.productAddonss[planname];
  //             //console.log("length" + products.length)

  //             if (products.length == 0) {
  //             } else if (products.length == 1) {
  //               CCplanProduct = products[0];
  //               // selectedCompnayPlan= filtered_compnay_plans[0]
  //             } else {
  //               //this.consoleMessage(products.length)
  //             }
  //           }
  //           let selectedCCplanProduct = CCplanProduct;


  //           let selectedcompanyplanproduct: any;
  //           let selectedCompanyplanProduct: any;

  //           if (selectedCompnayPlan) {

  //             let upgradeText;
  //             let upgradepaymentText;
  //             if (payroll) {
  //               upgradeText = "Employee upgraded using payroll deduction";
  //               upgradepaymentText = "using payroll deduction";
  //               //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
  //             } else {
  //               upgradeText = "Employee upgraded using Direct payment";
  //               upgradepaymentText = "using Direct payment";
  //             }
  //             let companyTax =
  //               selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
  //                 0
  //                 ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let companyTaxPercentage =
  //               selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
  //                 0
  //                 ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;
  //             let baseplanPrice = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.price
  //             );
  //             let baseplanTaxorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.tax
  //             );
  //             let baseplanTax = adjustWith2DecimalsForUI(
  //               baseplanPrice * companyTax
  //             );
  //             let baseplanTotalorg = adjustWith2DecimalsForUI(
  //               selectedBaseplanProduct.calculatedTax.total
  //             );
  //             let baseplanTotal = adjustWith2DecimalsForUI(
  //               baseplanPrice + baseplanTax
  //             );
  //             let coverage = selectedCCplanProduct.planCoverage
  //             let employeeTax =
  //               selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
  //                 ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRate
  //                 : 0;
  //             let employeeTaxPercentage =
  //               selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
  //                 ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
  //                   .taxRatePercentage
  //                 : 0;

  //             let deltaplanPrice = adjustWith2DecimalsForUI(
  //               selectedCCplanProduct.calculatedTax.price -
  //               selectedBaseplanProduct.calculatedTax.price
  //             );

  //             //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
  //             //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
  //             //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
  //             if (selectedBaseplanProduct.name == 'NA') {
  //               //this.consoleMessage("No Base plan/product for this upgrade plans/product")
  //               companyTax = employeeTax
  //               companyTaxPercentage = employeeTaxPercentage
  //             }
  //             let deltaplanTax = adjustWith2DecimalsForUI(
  //               deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
  //             );
  //             // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

  //             let deltaplanTotal = adjustWith2DecimalsForUI(
  //               deltaplanPrice + deltaplanTax
  //             );

  //             let combinedplanPrice = baseplanPrice + deltaplanPrice;
  //             let combinedplanbasePrice = baseplanPrice;
  //             let combinedplanDeltaprice = deltaplanPrice;
  //             let combinedplanTax = adjustWith2DecimalsForUI(
  //               baseplanTax + deltaplanTax
  //             );
  //             let combinedplanCompanyTax = baseplanTax;
  //             let combinedplanEmployeeTax =
  //               adjustWith2DecimalsForUI(deltaplanTax);
  //             let combinedplanCompanyTaxPercentage = companyTaxPercentage;
  //             let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
  //               ? companyTaxPercentage
  //               : employeeTaxPercentage;
  //             let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
  //             let combinedplanTotal = adjustWith2DecimalsForUI(
  //               baseplanTotal + deltaplanTotal
  //             );

  //             let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
  //             let planName = `${CPplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
  //             let compnayShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) Contribution`;
  //             let employeeShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
  //             let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
  //             let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
  //             let type;

  //             if (payroll) {
  //               type = "Split with payroll deduction";
  //             } else {
  //               type = "Split with direct pay";
  //             }
  //             let basePlanDetails = {
  //               planId: selectedBasePlan.id || 0, //0
  //               planName: selectedBasePlan.name || "NA", //NA
  //               planLevelId: selectedBasePlan.planLevel || 0, //0
  //               amount: baseplanPrice || 0, //0
  //               amountUI: `$${baseplanPrice}` || 0, //0
  //               tax: baseplanTax,
  //               total: baseplanTotal,
  //               taxUI: `$${baseplanTax}`, //companyTaxpercentage
  //               totalUI: `$${baseplanTotal}`,
  //               planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
  //               planFrequencyID: selectedBasePlan.frqMonthly || "",
  //               planFusebillID: selectedBasePlan.fusebillId || "",
  //               products: [selectedBaseplanProduct],
  //               planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
  //               packageName: selectedBasePlan.packageName || "",
  //               packageId: selectedBasePlan.packageId || 0,
  //             };
  //             let obj = {
  //               companyTax,
  //               companyTaxPercentage,
  //               baseplanPrice,
  //               baseplanTaxorg,
  //               baseplanTax,
  //               baseplanTotalorg,
  //               baseplanTotal,
  //               employeeTax,
  //               employeeTaxPercentage,
  //               deltaplanPrice,
  //               deltaplanTax,
  //               deltaplanTotal,
  //               combinedplanPrice,
  //               combinedplanbasePrice,
  //               combinedplanDeltaprice,
  //               combinedplanTax,
  //               combinedplanCompanyTax,
  //               combinedplanEmployeeTax,
  //               combinedplanCompanyTaxPercentage,
  //               combinedplanemployeeTaxPercentage,
  //               combinedplanTotal,
  //               payroll,
  //               scenario,
  //               planName,
  //               compnayShareStatement,
  //               employeeShareStatement,
  //               planDescription,
  //               planDescription2,
  //               type,
  //               basePlanDetails,
  //               combinedplanemployeeTaxPercentageorg,
  //               coverage
  //             };

  //             //this.consoleMessage(obj)
  //             // modifiedCPplan.upgradeCalculation = obj;
  //           }
  //         }
  //         modifiedCPgroup.plans.push(modifiedCPplan);

  //         modifiedCPPackage.groupsCP.push(modifiedCPgroup);
  //       }
  //       //console.log(modifiedCPPackage)
  //       modifiedCPplanPackages.push(modifiedCPPackage);
  //     }

  //     this.modifiedBlocksPaidByCompany = modifiedCPplanPackages;

  //     console.log(this.modifiedBlocksPaidByCompany)

  //     //this.consoleMessage(this.modifiedBlocksCoveredByCompany)
  //   }
  // }
  calculateBasePlanCPplans(cpplanspackages: string | any[], baseplansMain: any[], compnayplans: any[]) {

    console.log(cpplanspackages)
    console.log(baseplansMain)

    if (baseplansMain) {
      baseplansMain = baseplansMain.filter(name => name.productAddonssNames.length > 0)
    }



    let selectedbasePlanMain;
    console.log(baseplansMain)
    let modifiedCPplanPackages: any = [];
    for (let i = 0; i < cpplanspackages?.length; i++) {
      if (baseplansMain) {
        selectedbasePlanMain = baseplansMain.filter(name => name.packageId == cpplanspackages[i].id)
        if (selectedbasePlanMain.length > 0) {
          selectedbasePlanMain = selectedbasePlanMain[selectedbasePlanMain.length - 1]
        }

      }
      let modifiedCPPackage = cpplanspackages[i];

      let CPplansgroups = cpplanspackages[i].groupsCP;

      modifiedCPPackage.groupsCP = [];
      for (let CPplangroup of CPplansgroups) {
        let modifiedCPgroup = CPplangroup;
        let selectedCoverage = CPplangroup?.categorization?.companyPaidCoverage ?? "DIRECT"
        if (selectedCoverage == "null") {
          selectedCoverage = "DIRECT"
        }
        if (selectedCoverage != "DIRECT") {
          selectedCoverage = selectedCoverage.replace("SELECTIVE_", "")
        }

        console.log(selectedCoverage)


        if (selectedCoverage == "DIRECT") {
          modifiedCPPackage.groupsCP.push(modifiedCPgroup)
          if (modifiedCPPackage.groupsCP.length == CPplansgroups.length) {
            modifiedCPplanPackages.push(modifiedCPPackage)
          }
          continue;
        }
        let CPplans = CPplangroup.plans;

        //console.log(CPplangroup)

        modifiedCPgroup.plans = [];
        let baseplans = []
        for (let CPplan of CPplans) {
          let modifiedCPplan = CPplan;


          CPplan.planLevel_parentId = CPplangroup.parentId;

          let payroll = true;
          let EmployeeChoice = 0;

          if (
            this.CORP_PAYROLL_NOT_MANDATORY_PACKAGES.includes(CPplan.packageId)
          ) {
            if (EmployeeChoice == 2) {
              payroll = false;
            }
          } else {
            if (
              this.CORP_PAYROLL_NOT_MANDATORY_PLANLEVELS.includes(
                CPplan.planLevel
              )
            ) {
              if (EmployeeChoice == 2) {
                payroll = false;
              }
            }
          }
          console.log(CPplan)
          let selectedCPplanProductarray: any = CPplan.productAddonss[CPplan.name];


          // let selectedCPplanProductarray: any = Object.keys(CPplan.productAddonss)

          console.log(selectedCPplanProductarray)
          if (selectedbasePlanMain) {
            let selectedMainProductarray: any = selectedbasePlanMain.productAddonss[selectedbasePlanMain.name];

            console.log(selectedMainProductarray)
            //console.log(CPplan.productAddonss[CPplan.name])

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedMainProductarray.length; j++) {
                if (selectedMainProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedMainProductarray[i])
                }

              }
            }
          }
          else {
            for (let i = 0; i < selectedCPplanProductarray.length; i++) {

              for (let j = 0; j < selectedCPplanProductarray.length; j++) {
                if (selectedCPplanProductarray[i].planCoverage == selectedCoverage) {

                  baseplans.push(selectedCPplanProductarray[i])
                }

              }

            }

          }






          if (CPplan.isBundle) {

            console.log(baseplans)
            var filtered_base_plans = baseplans



            //this.consoleMessage(filtered_base_plans);

            //this.consoleMessage(filtered_compnay_plans)
            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            let selectedBaseplanProduct: any;
            let selectedBaseplanProductsArray = [];
            let selectedCompanyplanProduct: any;
            let selectedCompanyplanProductsArray: any = [];

            //console.log("length" + filtered_base_plans.length)

            selectedBasePlan = filtered_base_plans[0];

            console.log(selectedBasePlan)

            if (selectedBasePlan) {
              // //this.consoleMessage(selectedBasePlan)
              // selectedBaseplanProduct = selectedBasePlan.productAddonss[selectedBasePlan.name][0]
              selectedBaseplanProductsArray = [selectedBasePlan];
              let selectedBaseplanProductsArray2 = [];
              //  //this.consoleMessage(CCplan.packageId)
              if (CPplan.packageId == 5 || CPplan.packageId == 10) {

                // selectedBaseplanProductsArray2 = selectedBaseplanProductsArray
                // for (let i = 0; i < selectedCPplanProductarray.length - selectedBaseplanProductsArray.length; i++) {
                //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[selectedBaseplanProductsArray.length - 1]);
                // }
                // // //this.consoleMessage(selectedBaseplanProductsArray)
                // selectedBaseplanProductsArray = selectedBaseplanProductsArray2
                // //this.consoleMessage(selectedBaseplanProductsArray)
              }
              else {

                // Direct Coverage Method

                // selectedBaseplanProductsArray =this.DirectCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)


                // Selective single Coverage Method

                //  selectedBaseplanProductsArray =this.selectiveSingleCoverageMethod(selectedCCplanProductarray,selectedBaseplanProductsArray)

                // Selective Couple Coverage Method
                if (selectedCoverage != "DIRECT") {
                  selectedBaseplanProductsArray = this.selectiveCPCoverageMethod(selectedCPplanProductarray, selectedBaseplanProductsArray, selectedCoverage)
                }
                //  // Selective Family Coverage Method


              }
            }
            else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";

              for (let i = 0; i < selectedCPplanProductarray.length; i++) {
                selectedBaseplanProductsArray.push(selectedBaseplanProduct);
              }
            }



            let upgradeText;
            let upgradepaymentText;
            if (payroll) {
              upgradeText = "Employee upgraded using payroll deduction";
              upgradepaymentText = "using payroll deduction";
              //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
            } else {
              upgradeText = "Employee upgraded using Direct payment";
              upgradepaymentText = "using Direct payment";
            }

            modifiedCPplan.products = []

            for (let i = 0; i < selectedCPplanProductarray.length; i++) {
              let selectedBaseplanProduct = selectedBaseplanProductsArray[i];
              console.log(selectedBaseplanProduct)
              let selectedCPplanProduct = selectedCPplanProductarray[i];
              console.log(selectedCPplanProduct)
              let coverage = selectedCPplanProduct.planCoverage

              console.log(coverage)
              if (selectedCoverage == coverage) {

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;
              }

              console.log(selectedCPplanProduct)
              let selectedCompanyplanProduct =
                selectedCompanyplanProductsArray[i];

              let companyTax;
              let companyTaxPercentage;
              let employeeTax;
              let employeeTaxPercentage;

              if (selectedBaseplanProduct) {
                companyTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedBaseplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedBaseplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              } else {
                companyTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                companyTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
                employeeTax =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRate
                    : 0;
                employeeTaxPercentage =
                  selectedCPplanProduct?.calculatedTax?.planProductInfos.length > 0
                    ? selectedCPplanProduct.calculatedTax.planProductInfos[0]
                      .taxRatePercentage
                    : 0;
              }




              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );



              console.log(selectedCPplanProduct)

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCPplanProduct?.calculatedTax?.price -
                selectedBaseplanProduct?.calculatedTax?.price
              );
              console.log(deltaplanPrice)


              //console.log(selectedBaseplanProduct.calculatedTax.price)

              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              //Delete plan Total Price and Total Combination
              if (deltaplanPrice <= 0) {
                deltaplanPrice = 0
                /*      baseplanPrice = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.price
                    );
                     baseplanTaxorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.tax
                    );
                     baseplanTax = adjustWith2DecimalsForUI(
                      baseplanPrice * companyTax
                    );
                     baseplanTotalorg = adjustWith2DecimalsForUI(
                      selectedCPplanProduct.calculatedTax.total
                    );
                     baseplanTotal = adjustWith2DecimalsForUI(
                      baseplanPrice + baseplanTax
                    ); */

                modifiedCPplan.products.push(selectedCPplanProduct)
                continue;

              }


              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice *
              //   (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );
              let combinedplanPrice = adjustWith2DecimalsForUI(
                baseplanPrice + deltaplanPrice
              );
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;

              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBasePlan.name}  (${selectedCoverage}) to ${CPplan.name}`;
              let planName = `${CPplan.name} (${this.capitalize(coverage)}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name} (${this.capitalize(selectedCoverage)})  Contribution`;
              let employeeShareStatement = `${CPplan.name} (${this.capitalize(coverage)}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id, //0
                planName: selectedBasePlan.name, //NA
                planLevelId: selectedBasePlan.planLevel, //0
                amount: baseplanPrice, //0
                amountUI: `$${baseplanPrice}`, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId,
                packageName: selectedBasePlan.packageName,
                packageId: selectedBasePlan.packageId,
              };





              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage,
                selectedCoverage
              };

              //this.consoleMessage(obj)

              //console.log(selectedCoverage)
              //console.log(coverage)

              //console.log(obj)
              let cpProduct: any = {}
              cpProduct.upgradeCalculation = obj;
              modifiedCPplan.products.push(cpProduct)
              // modifiedCPplan.upgradeCalculation = obj;

              // if(selectedCoverage == coverage){

              // }else{
              //   cpProduct.upgradeCalculation = obj;
              //   modifiedCPplan.products.push(cpProduct)
              // }

              //console.log(modifiedCPplan)
            }

          }
          else {
            //this.consoleMessage("Not a BundlePlan")

            //this.consoleMessage(baseplans)



            filtered_base_plans = baseplans

            let selectedBasePlan;
            let selectedCompnayPlan;
            let DeltaPlan;
            //console.log("length" + filtered_base_plans.length)
            if (filtered_base_plans.length == 0) {
            } else if (filtered_base_plans.length == 0) {
              selectedBasePlan = filtered_base_plans[0];
            } else {
              //this.consoleMessage(filtered_base_plans.length)
            }

            let selectedbaseplanproduct: any;
            let selectedBaseplanProduct: any;

            if (selectedBasePlan) {
              for (let planname in selectedBasePlan.productAddonss) {
                //this.consoleMessage(planname)
                //this.consoleMessage(selectedBasePlan.productAddonss[planname])
                let products = selectedBasePlan.productAddonss[planname];
                //console.log("length" + products.length)
                if (products.length == 0) {
                } else if (products.length == 1) {
                  selectedbaseplanproduct = products[0];
                  // selectedCompnayPlan= filtered_compnay_plans[0]
                } else {
                  //this.consoleMessage(products.length)
                }
              }
              //this.consoleMessage(selectedbaseplanproduct)
              selectedBaseplanProduct = selectedbaseplanproduct;

            } else {
              selectedBasePlan = {};
              selectedBaseplanProduct = {};
              selectedBaseplanProduct.calculatedTax = {};
              selectedBaseplanProduct.calculatedTax.price = 0;
              selectedBaseplanProduct.calculatedTax.tax = 0;
              selectedBaseplanProduct.calculatedTax.total = 0;
              selectedBaseplanProduct.name = "NA";
            }

            let CCplanProduct;

            for (let planname in CPplan.productAddonss) {
              let products = CPplan.productAddonss[planname];
              //console.log("length" + products.length)

              if (products.length == 0) {
              } else if (products.length == 1) {
                CCplanProduct = products[0];
                // selectedCompnayPlan= filtered_compnay_plans[0]
              } else {
                //this.consoleMessage(products.length)
              }
            }
            let selectedCCplanProduct = CCplanProduct;


            let selectedcompanyplanproduct: any;
            let selectedCompanyplanProduct: any;

            if (selectedCompnayPlan) {

              let upgradeText;
              let upgradepaymentText;
              if (payroll) {
                upgradeText = "Employee upgraded using payroll deduction";
                upgradepaymentText = "using payroll deduction";
                //this.consoleMessage("One subscription to parent/corp with base(company tax)+Delta(employee tax)")
              } else {
                upgradeText = "Employee upgraded using Direct payment";
                upgradepaymentText = "using Direct payment";
              }
              let companyTax =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let companyTaxPercentage =
                selectedCompanyplanProduct.calculatedTax.planProductInfos.length >
                  0
                  ? selectedCompanyplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;
              let baseplanPrice = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.price
              );
              let baseplanTaxorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.tax
              );
              let baseplanTax = adjustWith2DecimalsForUI(
                baseplanPrice * companyTax
              );
              let baseplanTotalorg = adjustWith2DecimalsForUI(
                selectedBaseplanProduct.calculatedTax.total
              );
              let baseplanTotal = adjustWith2DecimalsForUI(
                baseplanPrice + baseplanTax
              );
              let coverage = selectedCCplanProduct.planCoverage
              let employeeTax =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRate
                  : 0;
              let employeeTaxPercentage =
                selectedCCplanProduct.calculatedTax.planProductInfos.length > 0
                  ? selectedCCplanProduct.calculatedTax.planProductInfos[0]
                    .taxRatePercentage
                  : 0;

              let deltaplanPrice = adjustWith2DecimalsForUI(
                selectedCCplanProduct.calculatedTax.price -
                selectedBaseplanProduct.calculatedTax.price
              );

              //this.consoleMessage(selectedCCplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedBaseplanProduct.calculatedTax.price)
              //this.consoleMessage(selectedCCplanProduct.calculatedTax.price -selectedBaseplanProduct.calculatedTax.price)
              if (selectedBaseplanProduct.name == 'NA') {
                //this.consoleMessage("No Base plan/product for this upgrade plans/product")
                companyTax = employeeTax
                companyTaxPercentage = employeeTaxPercentage
              }
              // let deltaplanTax = adjustWith2DecimalsForUI(
              //   deltaplanPrice * (this.deltaCompanyTax ? companyTax : employeeTax)
              // );
              let deltaplanTax = adjustWith2DecimalsForUI(deltaplanPrice * employeeTax);
              // let deltaplanTax = deltaplanPrice*(this.deltaCompanyTax?companyTax:employeeTax)

              let deltaplanTotal = adjustWith2DecimalsForUI(
                deltaplanPrice + deltaplanTax
              );

              let combinedplanPrice = baseplanPrice + deltaplanPrice;
              let combinedplanbasePrice = baseplanPrice;
              let combinedplanDeltaprice = deltaplanPrice;
              let combinedplanTax = adjustWith2DecimalsForUI(
                baseplanTax + deltaplanTax
              );
              let combinedplanCompanyTax = baseplanTax;
              let combinedplanEmployeeTax =
                adjustWith2DecimalsForUI(deltaplanTax);
              let combinedplanCompanyTaxPercentage = companyTaxPercentage;
              let combinedplanemployeeTaxPercentage = this.deltaCompanyTax
                ? companyTaxPercentage
                : employeeTaxPercentage;
              let combinedplanemployeeTaxPercentageorg = employeeTaxPercentage;
              let combinedplanTotal = adjustWith2DecimalsForUI(
                baseplanTotal + deltaplanTotal
              );

              let scenario = `Employee Upgrade from ${selectedBaseplanProduct.name} to ${selectedCCplanProduct.name}`;
              let planName = `${CPplan.name}(${selectedCCplanProduct.name}) (${upgradeText})`;
              let compnayShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) Contribution`;
              let employeeShareStatement = `${CPplan.name}(${selectedCCplanProduct.name}) upgrade cost`;
              let planDescription = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanTotal} and Employee- pays ${upgradepaymentText} ${deltaplanTotal} `;
              let planDescription2 = `${scenario} On a total of ${combinedplanTotal}, company share ${baseplanPrice}(with tax:${companyTaxPercentage}) and Employee- pays ${upgradepaymentText} ${deltaplanPrice}(with tax:${employeeTaxPercentage}) `;
              let type;

              if (payroll) {
                type = "Split with payroll deduction";
              } else {
                type = "Split with direct pay";
              }
              let basePlanDetails = {
                planId: selectedBasePlan.id || 0, //0
                planName: selectedBasePlan.name || "NA", //NA
                planLevelId: selectedBasePlan.planLevel || 0, //0
                amount: baseplanPrice || 0, //0
                amountUI: `$${baseplanPrice}` || 0, //0
                tax: baseplanTax,
                total: baseplanTotal,
                taxUI: `$${baseplanTax}`, //companyTaxpercentage
                totalUI: `$${baseplanTotal}`,
                planLevelName: selectedBasePlan.groupName || "", //if it is Bundle
                planFrequencyID: selectedBasePlan.frqMonthly || "",
                planFusebillID: selectedBasePlan.fusebillId || "",
                products: [selectedBaseplanProduct],
                planLevel_parentId: selectedBasePlan.planLevel_parentId || 0,
                packageName: selectedBasePlan.packageName || "",
                packageId: selectedBasePlan.packageId || 0,
              };
              let obj = {
                companyTax,
                companyTaxPercentage,
                baseplanPrice,
                baseplanTaxorg,
                baseplanTax,
                baseplanTotalorg,
                baseplanTotal,
                employeeTax,
                employeeTaxPercentage,
                deltaplanPrice,
                deltaplanTax,
                deltaplanTotal,
                combinedplanPrice,
                combinedplanbasePrice,
                combinedplanDeltaprice,
                combinedplanTax,
                combinedplanCompanyTax,
                combinedplanEmployeeTax,
                combinedplanCompanyTaxPercentage,
                combinedplanemployeeTaxPercentage,
                combinedplanTotal,
                payroll,
                scenario,
                planName,
                compnayShareStatement,
                employeeShareStatement,
                planDescription,
                planDescription2,
                type,
                basePlanDetails,
                combinedplanemployeeTaxPercentageorg,
                coverage
              };

              //this.consoleMessage(obj)
              // modifiedCPplan.upgradeCalculation = obj;
            }
          }
          modifiedCPgroup.plans.push(modifiedCPplan);

          modifiedCPPackage.groupsCP.push(modifiedCPgroup);
        }
        //console.log(modifiedCPPackage)
        modifiedCPplanPackages.push(modifiedCPPackage);
      }

      this.modifiedBlocksPaidByCompany = modifiedCPplanPackages;

      console.log(this.modifiedBlocksPaidByCompany)

      //this.consoleMessage(this.modifiedBlocksCoveredByCompany)
    }
  }

  public DirectCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {

    //console.log("DirectCoveragemETHOD")
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {

        //console.log(selectedCCplanProductarray[i])
        //console.log(selectedBaseplanProductsArray[j])

        if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        //console.log("ElseDirectCoveragemETHOD")
        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)

    //console.log(selectedBaseplanProductsArray2)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;

    //console.log(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        //console.log(selectedBaseplanProductsArray[j])
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedBaseplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)

    //console.log(selectedBaseplanProductsArray2)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }

  public selectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public selectiveCPCoverageMethod(selectedCCplanProductarray: any, selectedBaseplanProductsArray: any, selectedCoverage: any) {
    let productCoverageFound = false;
    let selectedBaseplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedBaseplanProduct: any;
    selectedBaseplanProductsArray = selectedBaseplanProductsArray.filter((bb: any) => { return bb.planCoverage == selectedCoverage })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedBaseplanProductsArray.length; j++) {
        productCoverageFound = true
        selectedBaseplanProductsArray2.push(selectedBaseplanProductsArray[j])
        break;


      }
      if (!productCoverageFound) {



        selectedBasePlan = {};
        selectedBaseplanProduct = {};
        selectedBaseplanProduct.calculatedTax = {};
        selectedBaseplanProduct.calculatedTax.price = 0;
        selectedBaseplanProduct.calculatedTax.tax = 0;
        selectedBaseplanProduct.calculatedTax.total = 0;
        selectedBaseplanProduct.name = "NA";
        selectedBaseplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedBaseplanProductsArray2.push(selectedBaseplanProduct);



      }

    }
    //this.consoleMessage(selectedBaseplanProductsArray)
    selectedBaseplanProductsArray = selectedBaseplanProductsArray2

    return selectedBaseplanProductsArray
  }
  public CompanyDirectCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {

    //console.log("DirectCoveragemETHOD")
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;



    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
          productCoverageFound = true
          selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
          break;
        }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveSingleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'SINGLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }

  public CompanyselectiveCoupleCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'COUPLE' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }
  public CompanyselectiveFamilyCoverageMethod(selectedCCplanProductarray: any, selectedCompanyplanProductsArray: any) {
    let productCoverageFound = false;
    let selectedCompanyplanProductsArray2 = []
    let selectedBasePlan = {};
    let selectedCompanyplanProduct: any;
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray.filter((bb: any) => { return bb.planCoverage == 'FAMILY' })
    for (let i = 0; i < selectedCCplanProductarray.length; i++) {
      for (let j = 0; j < selectedCompanyplanProductsArray.length; j++) {

        productCoverageFound = true
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        break;
        // if (selectedCCplanProductarray[i].planCoverage == selectedCompanyplanProductsArray[j].planCoverage) {
        //   productCoverageFound = true
        //   selectedCompanyplanProductsArray2.push(selectedCompanyplanProductsArray[j])
        //   break;
        // }


      }
      if (!productCoverageFound) {


        selectedCompanyplanProduct = {};
        selectedCompanyplanProduct.calculatedTax = {};
        selectedCompanyplanProduct.calculatedTax.planProductInfos = [];
        selectedCompanyplanProduct.name = "NA";
        selectedCompanyplanProduct.planCoverage = selectedCCplanProductarray[i].planCoverage;
        selectedCompanyplanProductsArray2.push(selectedCompanyplanProduct);



      }

    }
    selectedCompanyplanProductsArray = selectedCompanyplanProductsArray2

    return selectedCompanyplanProductsArray
  }
  cobminedcommonfunction(cpPackages: any, ccPackages: any, epPackages: any) {

    // //console.log(cpPackages)
    let commonPackages: any = {};
    if (cpPackages) {
      for (let cpPackage of cpPackages) {
        let pckg = cpPackage;
        pckg.groups = pckg.groupsCP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups.push(pckg.groupsCP);
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    //this.consoleMessage(commonPackages)
    if (ccPackages) {
      for (let ccPackage of ccPackages) {
        let pckg = ccPackage;
        //this.consoleMessage(pckg)
        pckg.groups = pckg.groupsCC;

        //this.consoleMessage(pckg.groups)
        //this.consoleMessage(pckg.groupsCC)

        if (commonPackages && commonPackages[pckg.id]) {
          //this.consoleMessage(commonPackages[pckg.id])
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsCC
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }
    if (epPackages) {
      for (let epPackage of epPackages) {
        let pckg = epPackage;
        pckg.groups = pckg.groupsEP;

        if (commonPackages && commonPackages[pckg.id]) {
          commonPackages[pckg.id].groups = commonPackages[pckg.id].groups.concat(
            pckg.groupsEP
          );
        } else {
          commonPackages[pckg.id] = pckg;
        }
      }
    }

    return commonPackages;


  }
  gigtoCorpConvertion(CorpId, parentId) {

    let date = this._CustomDatePipe.transform(this.effectiveDateForm.get('effectiveDate').value)
    let accessTokensession = sessionStorage.getItem('accessToken');
    let gigtermination = `/api/ap/member/${this.memberInfo.id}/configureMemberTermination?terminationDate=${date}`
    let endPoint = '/api/ap/admin/customer/' + this.memberInfo.id + '/convert-gig-to-corp';
    let accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(environment.apiUrl + gigtermination, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            let plansummarymain = JSON.parse(sessionStorage.getItem("plansummarymain")) || "";


            $("#showCorporatelist").modal('hide')
            this.gigterminationRes = response.data
            // if (!this.gigterminationRes.plans) {
            //   this.gigterminationRes.plans = [];
            // }

            // if (!this.continueWithExistingPlans) {
            //   this.gigterminationRes.plans.push(...plansummarymain);
            // } else if (this.samePlansWithCorporate) {
            //   this.gigterminationRes.plans = [...this.plansDataarray]; // Assigning a new array reference
            // }

            if (this.continueWithExistingPlans == false && this.samePlansWithCorporate == false) {

              if (!this.gigterminationRes.plans) {
                this.gigterminationRes.plans = [];
              }

              plansummarymain.forEach((source) => {
                this.gigterminationRes.plans.push(source);
              });

            }

            else if (this.continueWithExistingPlans == false && this.samePlansWithCorporate == true) {

              if (!this.gigterminationRes.plans) {
                this.gigterminationRes.plans = [];
              }


              this.gigterminationRes.plans = this.plansDataarray;
            }
            else {
              if (!this.gigterminationRes.plans) {
                this.gigterminationRes.plans = [];
              }
            }




            let obj = {
              corporateDetails: { "id": CorpId, 'parentId': parentId }, //dev/test/prod/dummy
              continueWithExistingPlans: this.continueWithExistingPlans,
              samePlansWithCorporate: this.samePlansWithCorporate,
              provisioning: this.provisioning,
              plansDataarray: this.plansDataarray,
              data: this.gigterminationRes
            }
            this.http
              .post(environment.apiUrl + endPoint, obj, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                },
              })
              .subscribe(
                (response: any) => {
                  if (response['status'] == 200) {
                    this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                      this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                        "message": "Corporates information has been updated. Please refresh screen."
                      }, {
                        headers: {
                          Authorization: 'Bearer ' + accessToken,
                          'Content-Type': 'application/json',
                        }
                      }).subscribe((res) => {
                        console.log({ res })
                      })
                    })


                    this.http.get(environment.apiUrl + '/api/ap/global/set-adminMembers').subscribe((newResponse) => {
                      this.members = this.members.map(member =>
                        member.id == this.memberInfo.id ? { ...member, isCorporateAccount: true } : member
                      );
                    })
                    // this.members=[]
                    this.store.dispatch(loadMemberDataSuccess({ memberData: this.members }))
                    Swal.fire({
                      title: this.lang.Info,
                      text: response.message,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: 'Ok',
                    }).then((result) => {
                      if (result.isConfirmed) {
                        this.router.navigate(['/manageMembers'])

                        // this.router.navigate(['/manageCorporates'])
                      }
                    });
                    this.router.navigate(['/manageMembers'])
                  }
                })



          }
          else {
            Swal.fire({ title: this.lang.Info, text: response.message || response.data.message })
            this.router.navigate(['/manageMembers'])
          }
        })


  }

  public determineTaxes(taxArray: any) {
    let taxObj: any = {
      pst: null,
      pstTaxRate: null,
      hst: null,
      hstTaxRate: null,
      gst: null,
      gstTaxRate: null,
      taxName: null,
      taxPrice: null
    };
    for (let tax of taxArray) {
      if (!taxObj.taxName || taxObj.taxName == null) {
        taxObj.taxName = "";
      }

      if (tax.name.includes("PST") || tax.name.includes("Prov")) {
        taxObj.pst = parseFloat(tax.price + (taxObj.pst ?? 0));
        taxObj.pstTaxRate = (tax.taxRate ?? tax.tax_rate) * 100
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("HST")) {
        taxObj.hst = parseFloat(tax.price + (taxObj.hst ?? 0));
        taxObj.hstTaxRate = (tax.taxRate ?? tax.tax_rate) * 100
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
      if (tax.name.includes("GST")) {
        taxObj.gst = parseFloat(tax.price + (taxObj.gst ?? 0));
        taxObj.gstTaxRate = (tax.taxRate ?? tax.tax_rate) * 100;
        if (!taxObj.taxName.includes(tax.name))
          taxObj.taxName += tax.name + " | "
      }
    }
    taxObj.taxName = taxObj.taxName?.trim();
    if (taxObj.taxName && taxObj.taxName[taxObj.taxName.length - 1] == "|") {
      taxObj.taxName = taxObj.taxName.slice(0, -1);
      taxObj.taxName = taxObj.taxName?.trim();
    }

    if (taxObj.pst || taxObj.hst || taxObj.gst) {
      taxObj.taxPrice = 0;
      taxObj.taxPrice = (taxObj.pst ?? 0) + (taxObj.hst ?? 0) + (taxObj.gst ?? 0)
    }

    return taxObj;
  }
  @ViewChild(ConfirmationDialogComponent) confirmationDialog: ConfirmationDialogComponent;

  // invitationMail(client: any) {
  //   this.logger.log({ client })
  //   this.message = `Are you sure you want to send invitation to ${client.firstName} ${client.lastName}?`
  //   $('#confirmationModal').modal('show');
  //   this.confirmationDialog.confirmed.subscribe(obj => {
  //     if (obj.confirmed) {
  //       var accessToken = sessionStorage.getItem('accessToken');
  //       var brokerStatus = '/api/ap/member/' + client.id + '/inviteMail'
  //       this.logger.log('invition Id', client.id)


  //       this.http
  //         .get(environment.apiUrl + brokerStatus, {
  //           headers: {
  //             Authorization: 'Bearer ' + accessToken,
  //             'Content-Type': 'application/json',
  //           },
  //         })
  //         .subscribe(
  //           (response: any) => {
  //             if (response['status'] == 200 || response['statusCode'] == 200) {
  //               // this.getclientList()
  //               // window.location.reload()
  //               Swal.fire({ title: this.lang.Info, text: response.message })
  //             } else {
  //               Swal.fire({ title: this.lang.Error??'Error', text: response.message })
  //             }
  //           },
  //           (error) => {
  //             if (
  //               error.status == 400 ||
  //               error.status == 401 ||
  //               error.status == 402 ||
  //               error.status == 403
  //             ) {
  //               Swal.fire({
  //                 title: this.lang.Error??'Error',
  //                 text: error.error.error.message,
  //                 showDenyButton: false,
  //                 showCancelButton: false,
  //                 // confirmButtonText: this.lang.Proceed,
  //               }).then((result) => {
  //                 if (result.isConfirmed) {
  //                 }
  //                 else {
  //                 }
  //               });
  //             } else {
  //               // Swal.fire(error.error.error.message)
  //               Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
  //             }
  //             // this.toastrService.error("Invalid Credentials", 'Error!');
  //           }
  //         );

  //     }
  //     $('#confirmationModal').modal('hide');
  //   });
  // }
  invitationMail(client: any) {
    // this.logger.log({ client });
    this.inviteEmailId = client.id;
    this.message = this.lang.Are_you_sure_you_want_to_send_an_invitation_to + ` ${client.firstName} ${client.lastName}?`;
    $('#confirmationModal').modal('show');

    if (!this.isSubscribed) {
      this.confirmationDialog.confirmed.subscribe(obj => {
        this.isSubscribed = true;
        if (obj.confirmed) {
          this.sendInvitationEmail(client);
        }
        $('#confirmationModal').modal('hide');
      });
    }
  }

  public genRandonString(length: any) {
    var chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    var charLength = chars.length;
    var result = "";
    for (var i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * charLength));
    }
    return result;
  }
  sendInvitationEmail(client) {
    var accessToken = sessionStorage.getItem('accessToken');
    var brokerStatus = '/api/ap/member/' + this.inviteEmailId + '/inviteMail';
    this.logger.log('invitation Id', this.inviteEmailId);

    this.http.get(`${environment.apiUrl}${brokerStatus}`, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      },
    }).subscribe(
      response => this.handleResponse(response),
      error => this.handleError(error)
    );
  }

  handleResponse(response: any) {
    console.log({ response }, response['status'] === 200 || response['statusCode'] === 200, response.status)
    if (response['status'] == 200 || response['statusCode'] == 200) {
      Swal.fire({ title: this.lang.Info, text: response.message });
    } else {
      console.log("response")
      Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
    }
  }

  handleError(error: any) {
    Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
  }

  public capitalize(str: any) {
    // if (str) {
    //   return str.charAt(0).toUpperCase() + str.slice(1);
    // }

    if (str) {
      return str.replace(/(?:^|\s)\S/g, function (match) {
        return match.toUpperCase();
      });
    }
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();

    // this.http.get(environment.apiUrl+'/api/ap/global/set-adminMembers').subscribe(()=>{})
    // this.store.dispatch(loadMemberDataSuccess({membersData:[]}));
    // this.store.dispatch(loadMemberData());

    console.log('MemberGateway', 'Destroyed');
    this.socketMemberService.disconnect();
    if (this.socketSubscription) {
      this.socketSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }


  openModelAddMumber() {
    this.valuFormChaild++;
    this.router.navigate(['/manageMembers/addMember']);//member
    // alert('1212')
  }


  submitreinstate() {

    let proceedToReinstate = true;

    
    if(this.finalEffectiveDate == null){
      proceedToReinstate = false;
      Swal.fire({title: "Info", text: "Please select effective date"}).then(res => {
        if(res.isConfirmed){
          return;
        }
      })
    }


    if(!proceedToReinstate){
      return;
    }

    var accessToken = sessionStorage.getItem('accessToken');
    var terminate = '/api/ap/v2/member/' + this.currentMember.id + '/reinstate';
    var headers = {
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
    };


    
    const isBackdated = moment(this.finalEffectiveDate).isBefore(moment().startOf('day'));
    

 
    let payload = {
      effectiveDate: moment(this.finalEffectiveDate).format('YYYY-MM-DD'),
      reason: this.reasonForReinstate,
      customerPlans: this?.reinstateData?.customerPlans ?? [],
      isBackdated: isBackdated
    }
 
    if(isBackdated){
      proceedToReinstate = false;
      Swal.fire({
        title: 'Info',
        html: `The selected date is backdated, so the request will be sent to the underwriting queue. An admin needs to approve the request.<br><br>Do you want to proceed?`,
        showCancelButton: true,
        confirmButtonText: 'Proceed',
        cancelButtonText: 'Close',
      }).then((res) => {
        if(res.isConfirmed){
          proceedToReinstate = true;
          this.http.post(environment.apiUrl + terminate, payload, { headers: headers })
          .subscribe(async (response: any) => {
            if (response.status == '200') {
              Swal.fire({ title: 'Info', text:  response.message}).then(res => {
                if(res.isConfirmed){
                  window.location.reload()
                }
              })
            }
          })
        }else{
          proceedToReinstate = false;
        }
      })
 
    }else{
      if(proceedToReinstate){
        this.http.post(environment.apiUrl + terminate, payload, { headers: headers })
        .subscribe(async (response: any) => {
          if (response.status == '200') {
            Swal.fire({ title: 'Info', text:  response.message}).then(res => {
              if(res.isConfirmed){
                window.location.reload()
              }
            })
          }
        })
      }
    }
 
  }

  handleGetPlansForReinstate(member:any){
    this.currentMember = member;
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .get(
        environment.apiUrl + `/api/ap/member/${member.id}/reinstate`, {
        // .get(getClients, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      }
      )
      .subscribe(
        (response: any) => {
 
          if (response['status'] == 200 || response['statusCode'] == 200) {
            console.log(response)
            this.reinstateData = response.data;
            if(response.data.corporatePlans && response.data.corporatePlans.length == 0 && response.data.customer.isCorporateAccount){
              this.loader = false
              Swal.fire({ title: 'Info', text: 'corporate has no active plans.' }).then(res => {
                if(res.isConfirmed){
                    this.closeModelPopup('showReinstate');
                }
              })
            }
            if(response.data.customerPlans && response.data.customerPlans.length > 0) {
              // remove the tax plan
              const modifiedPlans = response.data.customerPlans.filter((item:any) => !item.isSubscriptionTax);
              // check all the modified plans exists in corporate
              const corporatePlans = response.data.corporatePlans.filter((item:any) => !item.isSubscriptionTax);
              let isCorpHavingSamePlans:any = true;
              let existingCPPlanIds:any = modifiedPlans.map((item:any) => item.planId);
              let corporatePlanIds:any = [];
              if(corporatePlans && corporatePlans.length > 0) {
                for(const cp of corporatePlans){
                  corporatePlanIds.push(cp.planId);
                }
              }
 
              for(const ecp of existingCPPlanIds){
                if(corporatePlanIds.includes(ecp)){
                  // no worries
                  continue;
                }else{
                  isCorpHavingSamePlans = false
                }
              }
 
              if(!isCorpHavingSamePlans  && response.data.customer.isCorporateAccount){
                Swal.fire({title: 'Info', text: 'Some of the customer plans are not included in the corporate. Do you wish to continue?', showCancelButton: true,
                confirmButtonText: 'Proceed',
                cancelButtonText: 'Close'}).then(res => {
                  if(res.isConfirmed){
                    this.reinstatePlans = modifiedPlans;
                  }else{
                    this.closeModelPopup('showReinstate');
                  }
                })
              }else{
                this.reinstatePlans = modifiedPlans;
              }
            }
          } else {
            this.loader = false
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message }).then(res => {
              if(res.isConfirmed){
                  this.closeModelPopup('showReinstate');
              }
            })
          }
        },
        (error) => {
          this.loader = false
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }



  modifiedDate(date:any){
    const mDate = moment(date).format('YYYY-MM-DD');
    return mDate
  }

  checkCoverage(coverage:any){
    let coverageUpdated:any;
    let validCoverages:any = ['SINGLE', 'COUPLE', 'FAMILY'];
    if(validCoverages.includes(coverage?.toUpperCase())){
      coverageUpdated = coverage.toUpperCase();
    }
    return coverageUpdated;
  }


  handleEffectiveDateChange() {
    
  }


}


export function moments(date: string | undefined): moment.Moment {

  if (date)

    return moment((new Date(date)).toJSON())

  else

    return moment();

}
